export const COLOR_TRANSPARENT = "eon-transparent";
// export const COLOR_WHITE = "eon-white";
// export const COLOR_ULTRALIGHTGREY = "eon-ultralightgrey";
// export const COLOR_LIGHTGREY = "eon-lightgrey";
// export const COLOR_MIDDLEGREY = "eon-middlegrey";
// export const COLOR_DARKGREY = "eon-darkgrey";
// export const COLOR_BLACK = "eon-black";

export const COLOR_BRIGHT = "eon-bright";
export const COLOR_DARK = "eon-dark";
export const COLOR_RED = "eon-red";
export const COLOR_TURQUOISE = "eon-turquoise";
export const COLOR_LIMEYELLOW = "eon-limeyellow";
export const COLOR_BORDEAUX = "eon-bordeaux";
export const COLOR_WHITE = "eon-white";
export const COLOR_ULTRALIGHTGREY = "eon-ultralightgrey";
export const COLOR_LIGHTGREY = "eon-lightgrey";
export const COLOR_MIDDLEGREY = "eon-middlegrey";
export const COLOR_DARKGREY = "eon-darkgrey";
export const COLOR_BLACK = "eon-black";
export const COLOR_BRIGHT_FONT = "eon-bright-font";
export const COLOR_DARK_FONT = "eon-dark-font";
export const COLOR_RED_FONT = "eon-red-font";
export const COLOR_TURQUOISE_FONT = "eon-turquoise-font";
export const COLOR_LIMEYELLOW_FONT = "eon-limeyellow-font";
export const COLOR_BORDEAUX_FONT = "eon-bordeaux-font";
export const COLOR_WHITE_FONT = "eon-white-font";
export const COLOR_ULTRALIGHTGREY_FONT = "eon-ultralightgrey-font";
export const COLOR_LIGHTGREY_FONT = "eon-lightgrey-font";
export const COLOR_MIDDLEGREY_FONT = "eon-middlegrey-font";
export const COLOR_DARKGREY_FONT = "eon-darkgrey-font";
export const COLOR_BLACK_FONT = "eon-black-font";
export const COLOR_RED_ACTIVE = "eon-red-active";
export const COLOR_LIGHTGREY_ACTIVE = "eon-lightgrey-active";
export const COLOR_TURQUOISE_ACTIVE = "eon-turquoise-active";
export const COLOR_BORDEAUX_ACTIVE = "eon-bordeaux-active";
export const COLOR_LIMEYELLOW_ACTIVE = "eon-limeyellow-active";
export const COLOR_DARKGREY_ACTIVE = "eon-darkgrey-active";
export const COLOR_MIDDLEGREY_ACTIVE = "eon-middlegrey-active";
export const COLOR_WHITE_TABBAR_COLOR = "eon-white-tabbar-color";
export const COLOR_DARK_TABBAR_COLOR = "eon-dark-tabbar-color";
export const COLOR_LIMEYELLOW_DARK = "eon-limeyellow-dark";
export const COLOR_BORDEAUX_DARK = "eon-bordeaux-dark";
export const COLOR_TURQUOISE_DARK = "eon-turquoise-dark";
export const COLOR_VIOLET_DARK = "eon-violet-dark";
export const COLOR_LIMEYELLOW_LIGHT = "eon-limeyellow-light";
export const COLOR_BRIGHT_SHADE_1 = "eon-bright-shade-1";
export const COLOR_BRIGHT_SHADE_2 = "eon-bright-shade-2";
export const COLOR_BRIGHT_TINT_1 = "eon-bright-tint-1";
export const COLOR_BRIGHT_TINT_2 = "eon-bright-tint-2";
export const COLOR_BRIGHT_5 = "eon-bright-5";
export const COLOR_BRIGHT_10 = "eon-bright-10";
export const COLOR_BRIGHT_15 = "eon-bright-15";
export const COLOR_BRIGHT_20 = "eon-bright-20";
export const COLOR_BRIGHT_25 = "eon-bright-25";
export const COLOR_BRIGHT_30 = "eon-bright-30";
export const COLOR_BRIGHT_35 = "eon-bright-35";
export const COLOR_BRIGHT_40 = "eon-bright-40";
export const COLOR_BRIGHT_45 = "eon-bright-45";
export const COLOR_BRIGHT_50 = "eon-bright-50";
export const COLOR_BRIGHT_55 = "eon-bright-55";
export const COLOR_BRIGHT_60 = "eon-bright-60";
export const COLOR_BRIGHT_65 = "eon-bright-65";
export const COLOR_BRIGHT_70 = "eon-bright-70";
export const COLOR_BRIGHT_75 = "eon-bright-75";
export const COLOR_BRIGHT_80 = "eon-bright-80";
export const COLOR_BRIGHT_85 = "eon-bright-85";
export const COLOR_BRIGHT_90 = "eon-bright-90";
export const COLOR_BRIGHT_95 = "eon-bright-95";
export const COLOR_BRIGHT_OPACITY_5 = "eon-bright-opacity-5";
export const COLOR_BRIGHT_OPACITY_10 = "eon-bright-opacity-10";
export const COLOR_BRIGHT_OPACITY_15 = "eon-bright-opacity-15";
export const COLOR_BRIGHT_OPACITY_20 = "eon-bright-opacity-20";
export const COLOR_BRIGHT_OPACITY_25 = "eon-bright-opacity-25";
export const COLOR_BRIGHT_OPACITY_30 = "eon-bright-opacity-30";
export const COLOR_BRIGHT_OPACITY_35 = "eon-bright-opacity-35";
export const COLOR_BRIGHT_OPACITY_40 = "eon-bright-opacity-40";
export const COLOR_BRIGHT_OPACITY_45 = "eon-bright-opacity-45";
export const COLOR_BRIGHT_OPACITY_50 = "eon-bright-opacity-50";
export const COLOR_BRIGHT_OPACITY_55 = "eon-bright-opacity-55";
export const COLOR_BRIGHT_OPACITY_60 = "eon-bright-opacity-60";
export const COLOR_BRIGHT_OPACITY_65 = "eon-bright-opacity-65";
export const COLOR_BRIGHT_OPACITY_70 = "eon-bright-opacity-70";
export const COLOR_BRIGHT_OPACITY_75 = "eon-bright-opacity-75";
export const COLOR_BRIGHT_OPACITY_80 = "eon-bright-opacity-80";
export const COLOR_BRIGHT_OPACITY_85 = "eon-bright-opacity-85";
export const COLOR_BRIGHT_OPACITY_90 = "eon-bright-opacity-90";
export const COLOR_BRIGHT_OPACITY_95 = "eon-bright-opacity-95";
export const COLOR_DARK_SHADE_1 = "eon-dark-shade-1";
export const COLOR_DARK_SHADE_2 = "eon-dark-shade-2";
export const COLOR_DARK_TINT_1 = "eon-dark-tint-1";
export const COLOR_DARK_TINT_2 = "eon-dark-tint-2";
export const COLOR_DARK_5 = "eon-dark-5";
export const COLOR_DARK_10 = "eon-dark-10";
export const COLOR_DARK_15 = "eon-dark-15";
export const COLOR_DARK_20 = "eon-dark-20";
export const COLOR_DARK_25 = "eon-dark-25";
export const COLOR_DARK_30 = "eon-dark-30";
export const COLOR_DARK_35 = "eon-dark-35";
export const COLOR_DARK_40 = "eon-dark-40";
export const COLOR_DARK_45 = "eon-dark-45";
export const COLOR_DARK_50 = "eon-dark-50";
export const COLOR_DARK_55 = "eon-dark-55";
export const COLOR_DARK_60 = "eon-dark-60";
export const COLOR_DARK_65 = "eon-dark-65";
export const COLOR_DARK_70 = "eon-dark-70";
export const COLOR_DARK_75 = "eon-dark-75";
export const COLOR_DARK_80 = "eon-dark-80";
export const COLOR_DARK_85 = "eon-dark-85";
export const COLOR_DARK_90 = "eon-dark-90";
export const COLOR_DARK_95 = "eon-dark-95";
export const COLOR_DARK_OPACITY_5 = "eon-dark-opacity-5";
export const COLOR_DARK_OPACITY_10 = "eon-dark-opacity-10";
export const COLOR_DARK_OPACITY_15 = "eon-dark-opacity-15";
export const COLOR_DARK_OPACITY_20 = "eon-dark-opacity-20";
export const COLOR_DARK_OPACITY_25 = "eon-dark-opacity-25";
export const COLOR_DARK_OPACITY_30 = "eon-dark-opacity-30";
export const COLOR_DARK_OPACITY_35 = "eon-dark-opacity-35";
export const COLOR_DARK_OPACITY_40 = "eon-dark-opacity-40";
export const COLOR_DARK_OPACITY_45 = "eon-dark-opacity-45";
export const COLOR_DARK_OPACITY_50 = "eon-dark-opacity-50";
export const COLOR_DARK_OPACITY_55 = "eon-dark-opacity-55";
export const COLOR_DARK_OPACITY_60 = "eon-dark-opacity-60";
export const COLOR_DARK_OPACITY_65 = "eon-dark-opacity-65";
export const COLOR_DARK_OPACITY_70 = "eon-dark-opacity-70";
export const COLOR_DARK_OPACITY_75 = "eon-dark-opacity-75";
export const COLOR_DARK_OPACITY_80 = "eon-dark-opacity-80";
export const COLOR_DARK_OPACITY_85 = "eon-dark-opacity-85";
export const COLOR_DARK_OPACITY_90 = "eon-dark-opacity-90";
export const COLOR_DARK_OPACITY_95 = "eon-dark-opacity-95";
export const COLOR_RED_SHADE_1 = "eon-red-shade-1";
export const COLOR_RED_SHADE_2 = "eon-red-shade-2";
export const COLOR_RED_TINT_1 = "eon-red-tint-1";
export const COLOR_RED_TINT_2 = "eon-red-tint-2";
export const COLOR_RED_5 = "eon-red-5";
export const COLOR_RED_10 = "eon-red-10";
export const COLOR_RED_15 = "eon-red-15";
export const COLOR_RED_20 = "eon-red-20";
export const COLOR_RED_25 = "eon-red-25";
export const COLOR_RED_30 = "eon-red-30";
export const COLOR_RED_35 = "eon-red-35";
export const COLOR_RED_40 = "eon-red-40";
export const COLOR_RED_45 = "eon-red-45";
export const COLOR_RED_50 = "eon-red-50";
export const COLOR_RED_55 = "eon-red-55";
export const COLOR_RED_60 = "eon-red-60";
export const COLOR_RED_65 = "eon-red-65";
export const COLOR_RED_70 = "eon-red-70";
export const COLOR_RED_75 = "eon-red-75";
export const COLOR_RED_80 = "eon-red-80";
export const COLOR_RED_85 = "eon-red-85";
export const COLOR_RED_90 = "eon-red-90";
export const COLOR_RED_95 = "eon-red-95";
export const COLOR_RED_OPACITY_5 = "eon-red-opacity-5";
export const COLOR_RED_OPACITY_10 = "eon-red-opacity-10";
export const COLOR_RED_OPACITY_15 = "eon-red-opacity-15";
export const COLOR_RED_OPACITY_20 = "eon-red-opacity-20";
export const COLOR_RED_OPACITY_25 = "eon-red-opacity-25";
export const COLOR_RED_OPACITY_30 = "eon-red-opacity-30";
export const COLOR_RED_OPACITY_35 = "eon-red-opacity-35";
export const COLOR_RED_OPACITY_40 = "eon-red-opacity-40";
export const COLOR_RED_OPACITY_45 = "eon-red-opacity-45";
export const COLOR_RED_OPACITY_50 = "eon-red-opacity-50";
export const COLOR_RED_OPACITY_55 = "eon-red-opacity-55";
export const COLOR_RED_OPACITY_60 = "eon-red-opacity-60";
export const COLOR_RED_OPACITY_65 = "eon-red-opacity-65";
export const COLOR_RED_OPACITY_70 = "eon-red-opacity-70";
export const COLOR_RED_OPACITY_75 = "eon-red-opacity-75";
export const COLOR_RED_OPACITY_80 = "eon-red-opacity-80";
export const COLOR_RED_OPACITY_85 = "eon-red-opacity-85";
export const COLOR_RED_OPACITY_90 = "eon-red-opacity-90";
export const COLOR_RED_OPACITY_95 = "eon-red-opacity-95";
export const COLOR_TURQUOISE_SHADE_1 = "eon-turquoise-shade-1";
export const COLOR_TURQUOISE_SHADE_2 = "eon-turquoise-shade-2";
export const COLOR_TURQUOISE_TINT_1 = "eon-turquoise-tint-1";
export const COLOR_TURQUOISE_TINT_2 = "eon-turquoise-tint-2";
export const COLOR_TURQUOISE_5 = "eon-turquoise-5";
export const COLOR_TURQUOISE_10 = "eon-turquoise-10";
export const COLOR_TURQUOISE_15 = "eon-turquoise-15";
export const COLOR_TURQUOISE_20 = "eon-turquoise-20";
export const COLOR_TURQUOISE_25 = "eon-turquoise-25";
export const COLOR_TURQUOISE_30 = "eon-turquoise-30";
export const COLOR_TURQUOISE_35 = "eon-turquoise-35";
export const COLOR_TURQUOISE_40 = "eon-turquoise-40";
export const COLOR_TURQUOISE_45 = "eon-turquoise-45";
export const COLOR_TURQUOISE_50 = "eon-turquoise-50";
export const COLOR_TURQUOISE_55 = "eon-turquoise-55";
export const COLOR_TURQUOISE_60 = "eon-turquoise-60";
export const COLOR_TURQUOISE_65 = "eon-turquoise-65";
export const COLOR_TURQUOISE_70 = "eon-turquoise-70";
export const COLOR_TURQUOISE_75 = "eon-turquoise-75";
export const COLOR_TURQUOISE_80 = "eon-turquoise-80";
export const COLOR_TURQUOISE_85 = "eon-turquoise-85";
export const COLOR_TURQUOISE_90 = "eon-turquoise-90";
export const COLOR_TURQUOISE_95 = "eon-turquoise-95";
export const COLOR_TURQUOISE_OPACITY_5 = "eon-turquoise-opacity-5";
export const COLOR_TURQUOISE_OPACITY_10 = "eon-turquoise-opacity-10";
export const COLOR_TURQUOISE_OPACITY_15 = "eon-turquoise-opacity-15";
export const COLOR_TURQUOISE_OPACITY_20 = "eon-turquoise-opacity-20";
export const COLOR_TURQUOISE_OPACITY_25 = "eon-turquoise-opacity-25";
export const COLOR_TURQUOISE_OPACITY_30 = "eon-turquoise-opacity-30";
export const COLOR_TURQUOISE_OPACITY_35 = "eon-turquoise-opacity-35";
export const COLOR_TURQUOISE_OPACITY_40 = "eon-turquoise-opacity-40";
export const COLOR_TURQUOISE_OPACITY_45 = "eon-turquoise-opacity-45";
export const COLOR_TURQUOISE_OPACITY_50 = "eon-turquoise-opacity-50";
export const COLOR_TURQUOISE_OPACITY_55 = "eon-turquoise-opacity-55";
export const COLOR_TURQUOISE_OPACITY_60 = "eon-turquoise-opacity-60";
export const COLOR_TURQUOISE_OPACITY_65 = "eon-turquoise-opacity-65";
export const COLOR_TURQUOISE_OPACITY_70 = "eon-turquoise-opacity-70";
export const COLOR_TURQUOISE_OPACITY_75 = "eon-turquoise-opacity-75";
export const COLOR_TURQUOISE_OPACITY_80 = "eon-turquoise-opacity-80";
export const COLOR_TURQUOISE_OPACITY_85 = "eon-turquoise-opacity-85";
export const COLOR_TURQUOISE_OPACITY_90 = "eon-turquoise-opacity-90";
export const COLOR_TURQUOISE_OPACITY_95 = "eon-turquoise-opacity-95";
export const COLOR_LIMEYELLOW_SHADE_1 = "eon-limeyellow-shade-1";
export const COLOR_LIMEYELLOW_SHADE_2 = "eon-limeyellow-shade-2";
export const COLOR_LIMEYELLOW_TINT_1 = "eon-limeyellow-tint-1";
export const COLOR_LIMEYELLOW_TINT_2 = "eon-limeyellow-tint-2";
export const COLOR_LIMEYELLOW_5 = "eon-limeyellow-5";
export const COLOR_LIMEYELLOW_10 = "eon-limeyellow-10";
export const COLOR_LIMEYELLOW_15 = "eon-limeyellow-15";
export const COLOR_LIMEYELLOW_20 = "eon-limeyellow-20";
export const COLOR_LIMEYELLOW_25 = "eon-limeyellow-25";
export const COLOR_LIMEYELLOW_30 = "eon-limeyellow-30";
export const COLOR_LIMEYELLOW_35 = "eon-limeyellow-35";
export const COLOR_LIMEYELLOW_40 = "eon-limeyellow-40";
export const COLOR_LIMEYELLOW_45 = "eon-limeyellow-45";
export const COLOR_LIMEYELLOW_50 = "eon-limeyellow-50";
export const COLOR_LIMEYELLOW_55 = "eon-limeyellow-55";
export const COLOR_LIMEYELLOW_60 = "eon-limeyellow-60";
export const COLOR_LIMEYELLOW_65 = "eon-limeyellow-65";
export const COLOR_LIMEYELLOW_70 = "eon-limeyellow-70";
export const COLOR_LIMEYELLOW_75 = "eon-limeyellow-75";
export const COLOR_LIMEYELLOW_80 = "eon-limeyellow-80";
export const COLOR_LIMEYELLOW_85 = "eon-limeyellow-85";
export const COLOR_LIMEYELLOW_90 = "eon-limeyellow-90";
export const COLOR_LIMEYELLOW_95 = "eon-limeyellow-95";
export const COLOR_LIMEYELLOW_OPACITY_5 = "eon-limeyellow-opacity-5";
export const COLOR_LIMEYELLOW_OPACITY_10 = "eon-limeyellow-opacity-10";
export const COLOR_LIMEYELLOW_OPACITY_15 = "eon-limeyellow-opacity-15";
export const COLOR_LIMEYELLOW_OPACITY_20 = "eon-limeyellow-opacity-20";
export const COLOR_LIMEYELLOW_OPACITY_25 = "eon-limeyellow-opacity-25";
export const COLOR_LIMEYELLOW_OPACITY_30 = "eon-limeyellow-opacity-30";
export const COLOR_LIMEYELLOW_OPACITY_35 = "eon-limeyellow-opacity-35";
export const COLOR_LIMEYELLOW_OPACITY_40 = "eon-limeyellow-opacity-40";
export const COLOR_LIMEYELLOW_OPACITY_45 = "eon-limeyellow-opacity-45";
export const COLOR_LIMEYELLOW_OPACITY_50 = "eon-limeyellow-opacity-50";
export const COLOR_LIMEYELLOW_OPACITY_55 = "eon-limeyellow-opacity-55";
export const COLOR_LIMEYELLOW_OPACITY_60 = "eon-limeyellow-opacity-60";
export const COLOR_LIMEYELLOW_OPACITY_65 = "eon-limeyellow-opacity-65";
export const COLOR_LIMEYELLOW_OPACITY_70 = "eon-limeyellow-opacity-70";
export const COLOR_LIMEYELLOW_OPACITY_75 = "eon-limeyellow-opacity-75";
export const COLOR_LIMEYELLOW_OPACITY_80 = "eon-limeyellow-opacity-80";
export const COLOR_LIMEYELLOW_OPACITY_85 = "eon-limeyellow-opacity-85";
export const COLOR_LIMEYELLOW_OPACITY_90 = "eon-limeyellow-opacity-90";
export const COLOR_LIMEYELLOW_OPACITY_95 = "eon-limeyellow-opacity-95";
export const COLOR_BORDEAUX_SHADE_1 = "eon-bordeaux-shade-1";
export const COLOR_BORDEAUX_SHADE_2 = "eon-bordeaux-shade-2";
export const COLOR_BORDEAUX_TINT_1 = "eon-bordeaux-tint-1";
export const COLOR_BORDEAUX_TINT_2 = "eon-bordeaux-tint-2";
export const COLOR_BORDEAUX_5 = "eon-bordeaux-5";
export const COLOR_BORDEAUX_10 = "eon-bordeaux-10";
export const COLOR_BORDEAUX_15 = "eon-bordeaux-15";
export const COLOR_BORDEAUX_20 = "eon-bordeaux-20";
export const COLOR_BORDEAUX_25 = "eon-bordeaux-25";
export const COLOR_BORDEAUX_30 = "eon-bordeaux-30";
export const COLOR_BORDEAUX_35 = "eon-bordeaux-35";
export const COLOR_BORDEAUX_40 = "eon-bordeaux-40";
export const COLOR_BORDEAUX_45 = "eon-bordeaux-45";
export const COLOR_BORDEAUX_50 = "eon-bordeaux-50";
export const COLOR_BORDEAUX_55 = "eon-bordeaux-55";
export const COLOR_BORDEAUX_60 = "eon-bordeaux-60";
export const COLOR_BORDEAUX_65 = "eon-bordeaux-65";
export const COLOR_BORDEAUX_70 = "eon-bordeaux-70";
export const COLOR_BORDEAUX_75 = "eon-bordeaux-75";
export const COLOR_BORDEAUX_80 = "eon-bordeaux-80";
export const COLOR_BORDEAUX_85 = "eon-bordeaux-85";
export const COLOR_BORDEAUX_90 = "eon-bordeaux-90";
export const COLOR_BORDEAUX_95 = "eon-bordeaux-95";
export const COLOR_BORDEAUX_OPACITY_5 = "eon-bordeaux-opacity-5";
export const COLOR_BORDEAUX_OPACITY_10 = "eon-bordeaux-opacity-10";
export const COLOR_BORDEAUX_OPACITY_15 = "eon-bordeaux-opacity-15";
export const COLOR_BORDEAUX_OPACITY_20 = "eon-bordeaux-opacity-20";
export const COLOR_BORDEAUX_OPACITY_25 = "eon-bordeaux-opacity-25";
export const COLOR_BORDEAUX_OPACITY_30 = "eon-bordeaux-opacity-30";
export const COLOR_BORDEAUX_OPACITY_35 = "eon-bordeaux-opacity-35";
export const COLOR_BORDEAUX_OPACITY_40 = "eon-bordeaux-opacity-40";
export const COLOR_BORDEAUX_OPACITY_45 = "eon-bordeaux-opacity-45";
export const COLOR_BORDEAUX_OPACITY_50 = "eon-bordeaux-opacity-50";
export const COLOR_BORDEAUX_OPACITY_55 = "eon-bordeaux-opacity-55";
export const COLOR_BORDEAUX_OPACITY_60 = "eon-bordeaux-opacity-60";
export const COLOR_BORDEAUX_OPACITY_65 = "eon-bordeaux-opacity-65";
export const COLOR_BORDEAUX_OPACITY_70 = "eon-bordeaux-opacity-70";
export const COLOR_BORDEAUX_OPACITY_75 = "eon-bordeaux-opacity-75";
export const COLOR_BORDEAUX_OPACITY_80 = "eon-bordeaux-opacity-80";
export const COLOR_BORDEAUX_OPACITY_85 = "eon-bordeaux-opacity-85";
export const COLOR_BORDEAUX_OPACITY_90 = "eon-bordeaux-opacity-90";
export const COLOR_BORDEAUX_OPACITY_95 = "eon-bordeaux-opacity-95";
export const COLOR_WHITE_SHADE_1 = "eon-white-shade-1";
export const COLOR_WHITE_SHADE_2 = "eon-white-shade-2";
export const COLOR_WHITE_TINT_1 = "eon-white-tint-1";
export const COLOR_WHITE_TINT_2 = "eon-white-tint-2";
export const COLOR_WHITE_5 = "eon-white-5";
export const COLOR_WHITE_10 = "eon-white-10";
export const COLOR_WHITE_15 = "eon-white-15";
export const COLOR_WHITE_20 = "eon-white-20";
export const COLOR_WHITE_25 = "eon-white-25";
export const COLOR_WHITE_30 = "eon-white-30";
export const COLOR_WHITE_35 = "eon-white-35";
export const COLOR_WHITE_40 = "eon-white-40";
export const COLOR_WHITE_45 = "eon-white-45";
export const COLOR_WHITE_50 = "eon-white-50";
export const COLOR_WHITE_55 = "eon-white-55";
export const COLOR_WHITE_60 = "eon-white-60";
export const COLOR_WHITE_65 = "eon-white-65";
export const COLOR_WHITE_70 = "eon-white-70";
export const COLOR_WHITE_75 = "eon-white-75";
export const COLOR_WHITE_80 = "eon-white-80";
export const COLOR_WHITE_85 = "eon-white-85";
export const COLOR_WHITE_90 = "eon-white-90";
export const COLOR_WHITE_95 = "eon-white-95";
export const COLOR_WHITE_OPACITY_5 = "eon-white-opacity-5";
export const COLOR_WHITE_OPACITY_10 = "eon-white-opacity-10";
export const COLOR_WHITE_OPACITY_15 = "eon-white-opacity-15";
export const COLOR_WHITE_OPACITY_20 = "eon-white-opacity-20";
export const COLOR_WHITE_OPACITY_25 = "eon-white-opacity-25";
export const COLOR_WHITE_OPACITY_30 = "eon-white-opacity-30";
export const COLOR_WHITE_OPACITY_35 = "eon-white-opacity-35";
export const COLOR_WHITE_OPACITY_40 = "eon-white-opacity-40";
export const COLOR_WHITE_OPACITY_45 = "eon-white-opacity-45";
export const COLOR_WHITE_OPACITY_50 = "eon-white-opacity-50";
export const COLOR_WHITE_OPACITY_55 = "eon-white-opacity-55";
export const COLOR_WHITE_OPACITY_60 = "eon-white-opacity-60";
export const COLOR_WHITE_OPACITY_65 = "eon-white-opacity-65";
export const COLOR_WHITE_OPACITY_70 = "eon-white-opacity-70";
export const COLOR_WHITE_OPACITY_75 = "eon-white-opacity-75";
export const COLOR_WHITE_OPACITY_80 = "eon-white-opacity-80";
export const COLOR_WHITE_OPACITY_85 = "eon-white-opacity-85";
export const COLOR_WHITE_OPACITY_90 = "eon-white-opacity-90";
export const COLOR_WHITE_OPACITY_95 = "eon-white-opacity-95";
export const COLOR_ULTRALIGHTGREY_SHADE_1 = "eon-ultralightgrey-shade-1";
export const COLOR_ULTRALIGHTGREY_SHADE_2 = "eon-ultralightgrey-shade-2";
export const COLOR_ULTRALIGHTGREY_TINT_1 = "eon-ultralightgrey-tint-1";
export const COLOR_ULTRALIGHTGREY_TINT_2 = "eon-ultralightgrey-tint-2";
export const COLOR_ULTRALIGHTGREY_5 = "eon-ultralightgrey-5";
export const COLOR_ULTRALIGHTGREY_10 = "eon-ultralightgrey-10";
export const COLOR_ULTRALIGHTGREY_15 = "eon-ultralightgrey-15";
export const COLOR_ULTRALIGHTGREY_20 = "eon-ultralightgrey-20";
export const COLOR_ULTRALIGHTGREY_25 = "eon-ultralightgrey-25";
export const COLOR_ULTRALIGHTGREY_30 = "eon-ultralightgrey-30";
export const COLOR_ULTRALIGHTGREY_35 = "eon-ultralightgrey-35";
export const COLOR_ULTRALIGHTGREY_40 = "eon-ultralightgrey-40";
export const COLOR_ULTRALIGHTGREY_45 = "eon-ultralightgrey-45";
export const COLOR_ULTRALIGHTGREY_50 = "eon-ultralightgrey-50";
export const COLOR_ULTRALIGHTGREY_55 = "eon-ultralightgrey-55";
export const COLOR_ULTRALIGHTGREY_60 = "eon-ultralightgrey-60";
export const COLOR_ULTRALIGHTGREY_65 = "eon-ultralightgrey-65";
export const COLOR_ULTRALIGHTGREY_70 = "eon-ultralightgrey-70";
export const COLOR_ULTRALIGHTGREY_75 = "eon-ultralightgrey-75";
export const COLOR_ULTRALIGHTGREY_80 = "eon-ultralightgrey-80";
export const COLOR_ULTRALIGHTGREY_85 = "eon-ultralightgrey-85";
export const COLOR_ULTRALIGHTGREY_90 = "eon-ultralightgrey-90";
export const COLOR_ULTRALIGHTGREY_95 = "eon-ultralightgrey-95";
export const COLOR_ULTRALIGHTGREY_OPACITY_5 = "eon-ultralightgrey-opacity-5";
export const COLOR_ULTRALIGHTGREY_OPACITY_10 = "eon-ultralightgrey-opacity-10";
export const COLOR_ULTRALIGHTGREY_OPACITY_15 = "eon-ultralightgrey-opacity-15";
export const COLOR_ULTRALIGHTGREY_OPACITY_20 = "eon-ultralightgrey-opacity-20";
export const COLOR_ULTRALIGHTGREY_OPACITY_25 = "eon-ultralightgrey-opacity-25";
export const COLOR_ULTRALIGHTGREY_OPACITY_30 = "eon-ultralightgrey-opacity-30";
export const COLOR_ULTRALIGHTGREY_OPACITY_35 = "eon-ultralightgrey-opacity-35";
export const COLOR_ULTRALIGHTGREY_OPACITY_40 = "eon-ultralightgrey-opacity-40";
export const COLOR_ULTRALIGHTGREY_OPACITY_45 = "eon-ultralightgrey-opacity-45";
export const COLOR_ULTRALIGHTGREY_OPACITY_50 = "eon-ultralightgrey-opacity-50";
export const COLOR_ULTRALIGHTGREY_OPACITY_55 = "eon-ultralightgrey-opacity-55";
export const COLOR_ULTRALIGHTGREY_OPACITY_60 = "eon-ultralightgrey-opacity-60";
export const COLOR_ULTRALIGHTGREY_OPACITY_65 = "eon-ultralightgrey-opacity-65";
export const COLOR_ULTRALIGHTGREY_OPACITY_70 = "eon-ultralightgrey-opacity-70";
export const COLOR_ULTRALIGHTGREY_OPACITY_75 = "eon-ultralightgrey-opacity-75";
export const COLOR_ULTRALIGHTGREY_OPACITY_80 = "eon-ultralightgrey-opacity-80";
export const COLOR_ULTRALIGHTGREY_OPACITY_85 = "eon-ultralightgrey-opacity-85";
export const COLOR_ULTRALIGHTGREY_OPACITY_90 = "eon-ultralightgrey-opacity-90";
export const COLOR_ULTRALIGHTGREY_OPACITY_95 = "eon-ultralightgrey-opacity-95";
export const COLOR_LIGHTGREY_SHADE_1 = "eon-lightgrey-shade-1";
export const COLOR_LIGHTGREY_SHADE_2 = "eon-lightgrey-shade-2";
export const COLOR_LIGHTGREY_TINT_1 = "eon-lightgrey-tint-1";
export const COLOR_LIGHTGREY_TINT_2 = "eon-lightgrey-tint-2";
export const COLOR_LIGHTGREY_5 = "eon-lightgrey-5";
export const COLOR_LIGHTGREY_10 = "eon-lightgrey-10";
export const COLOR_LIGHTGREY_15 = "eon-lightgrey-15";
export const COLOR_LIGHTGREY_20 = "eon-lightgrey-20";
export const COLOR_LIGHTGREY_25 = "eon-lightgrey-25";
export const COLOR_LIGHTGREY_30 = "eon-lightgrey-30";
export const COLOR_LIGHTGREY_35 = "eon-lightgrey-35";
export const COLOR_LIGHTGREY_40 = "eon-lightgrey-40";
export const COLOR_LIGHTGREY_45 = "eon-lightgrey-45";
export const COLOR_LIGHTGREY_50 = "eon-lightgrey-50";
export const COLOR_LIGHTGREY_55 = "eon-lightgrey-55";
export const COLOR_LIGHTGREY_60 = "eon-lightgrey-60";
export const COLOR_LIGHTGREY_65 = "eon-lightgrey-65";
export const COLOR_LIGHTGREY_70 = "eon-lightgrey-70";
export const COLOR_LIGHTGREY_75 = "eon-lightgrey-75";
export const COLOR_LIGHTGREY_80 = "eon-lightgrey-80";
export const COLOR_LIGHTGREY_85 = "eon-lightgrey-85";
export const COLOR_LIGHTGREY_90 = "eon-lightgrey-90";
export const COLOR_LIGHTGREY_95 = "eon-lightgrey-95";
export const COLOR_LIGHTGREY_OPACITY_5 = "eon-lightgrey-opacity-5";
export const COLOR_LIGHTGREY_OPACITY_10 = "eon-lightgrey-opacity-10";
export const COLOR_LIGHTGREY_OPACITY_15 = "eon-lightgrey-opacity-15";
export const COLOR_LIGHTGREY_OPACITY_20 = "eon-lightgrey-opacity-20";
export const COLOR_LIGHTGREY_OPACITY_25 = "eon-lightgrey-opacity-25";
export const COLOR_LIGHTGREY_OPACITY_30 = "eon-lightgrey-opacity-30";
export const COLOR_LIGHTGREY_OPACITY_35 = "eon-lightgrey-opacity-35";
export const COLOR_LIGHTGREY_OPACITY_40 = "eon-lightgrey-opacity-40";
export const COLOR_LIGHTGREY_OPACITY_45 = "eon-lightgrey-opacity-45";
export const COLOR_LIGHTGREY_OPACITY_50 = "eon-lightgrey-opacity-50";
export const COLOR_LIGHTGREY_OPACITY_55 = "eon-lightgrey-opacity-55";
export const COLOR_LIGHTGREY_OPACITY_60 = "eon-lightgrey-opacity-60";
export const COLOR_LIGHTGREY_OPACITY_65 = "eon-lightgrey-opacity-65";
export const COLOR_LIGHTGREY_OPACITY_70 = "eon-lightgrey-opacity-70";
export const COLOR_LIGHTGREY_OPACITY_75 = "eon-lightgrey-opacity-75";
export const COLOR_LIGHTGREY_OPACITY_80 = "eon-lightgrey-opacity-80";
export const COLOR_LIGHTGREY_OPACITY_85 = "eon-lightgrey-opacity-85";
export const COLOR_LIGHTGREY_OPACITY_90 = "eon-lightgrey-opacity-90";
export const COLOR_LIGHTGREY_OPACITY_95 = "eon-lightgrey-opacity-95";
export const COLOR_MIDDLEGREY_SHADE_1 = "eon-middlegrey-shade-1";
export const COLOR_MIDDLEGREY_SHADE_2 = "eon-middlegrey-shade-2";
export const COLOR_MIDDLEGREY_TINT_1 = "eon-middlegrey-tint-1";
export const COLOR_MIDDLEGREY_TINT_2 = "eon-middlegrey-tint-2";
export const COLOR_MIDDLEGREY_5 = "eon-middlegrey-5";
export const COLOR_MIDDLEGREY_10 = "eon-middlegrey-10";
export const COLOR_MIDDLEGREY_15 = "eon-middlegrey-15";
export const COLOR_MIDDLEGREY_20 = "eon-middlegrey-20";
export const COLOR_MIDDLEGREY_25 = "eon-middlegrey-25";
export const COLOR_MIDDLEGREY_30 = "eon-middlegrey-30";
export const COLOR_MIDDLEGREY_35 = "eon-middlegrey-35";
export const COLOR_MIDDLEGREY_40 = "eon-middlegrey-40";
export const COLOR_MIDDLEGREY_45 = "eon-middlegrey-45";
export const COLOR_MIDDLEGREY_50 = "eon-middlegrey-50";
export const COLOR_MIDDLEGREY_55 = "eon-middlegrey-55";
export const COLOR_MIDDLEGREY_60 = "eon-middlegrey-60";
export const COLOR_MIDDLEGREY_65 = "eon-middlegrey-65";
export const COLOR_MIDDLEGREY_70 = "eon-middlegrey-70";
export const COLOR_MIDDLEGREY_75 = "eon-middlegrey-75";
export const COLOR_MIDDLEGREY_80 = "eon-middlegrey-80";
export const COLOR_MIDDLEGREY_85 = "eon-middlegrey-85";
export const COLOR_MIDDLEGREY_90 = "eon-middlegrey-90";
export const COLOR_MIDDLEGREY_95 = "eon-middlegrey-95";
export const COLOR_MIDDLEGREY_OPACITY_5 = "eon-middlegrey-opacity-5";
export const COLOR_MIDDLEGREY_OPACITY_10 = "eon-middlegrey-opacity-10";
export const COLOR_MIDDLEGREY_OPACITY_15 = "eon-middlegrey-opacity-15";
export const COLOR_MIDDLEGREY_OPACITY_20 = "eon-middlegrey-opacity-20";
export const COLOR_MIDDLEGREY_OPACITY_25 = "eon-middlegrey-opacity-25";
export const COLOR_MIDDLEGREY_OPACITY_30 = "eon-middlegrey-opacity-30";
export const COLOR_MIDDLEGREY_OPACITY_35 = "eon-middlegrey-opacity-35";
export const COLOR_MIDDLEGREY_OPACITY_40 = "eon-middlegrey-opacity-40";
export const COLOR_MIDDLEGREY_OPACITY_45 = "eon-middlegrey-opacity-45";
export const COLOR_MIDDLEGREY_OPACITY_50 = "eon-middlegrey-opacity-50";
export const COLOR_MIDDLEGREY_OPACITY_55 = "eon-middlegrey-opacity-55";
export const COLOR_MIDDLEGREY_OPACITY_60 = "eon-middlegrey-opacity-60";
export const COLOR_MIDDLEGREY_OPACITY_65 = "eon-middlegrey-opacity-65";
export const COLOR_MIDDLEGREY_OPACITY_70 = "eon-middlegrey-opacity-70";
export const COLOR_MIDDLEGREY_OPACITY_75 = "eon-middlegrey-opacity-75";
export const COLOR_MIDDLEGREY_OPACITY_80 = "eon-middlegrey-opacity-80";
export const COLOR_MIDDLEGREY_OPACITY_85 = "eon-middlegrey-opacity-85";
export const COLOR_MIDDLEGREY_OPACITY_90 = "eon-middlegrey-opacity-90";
export const COLOR_MIDDLEGREY_OPACITY_95 = "eon-middlegrey-opacity-95";
export const COLOR_DARKGREY_SHADE_1 = "eon-darkgrey-shade-1";
export const COLOR_DARKGREY_SHADE_2 = "eon-darkgrey-shade-2";
export const COLOR_DARKGREY_TINT_1 = "eon-darkgrey-tint-1";
export const COLOR_DARKGREY_TINT_2 = "eon-darkgrey-tint-2";
export const COLOR_DARKGREY_5 = "eon-darkgrey-5";
export const COLOR_DARKGREY_10 = "eon-darkgrey-10";
export const COLOR_DARKGREY_15 = "eon-darkgrey-15";
export const COLOR_DARKGREY_20 = "eon-darkgrey-20";
export const COLOR_DARKGREY_25 = "eon-darkgrey-25";
export const COLOR_DARKGREY_30 = "eon-darkgrey-30";
export const COLOR_DARKGREY_35 = "eon-darkgrey-35";
export const COLOR_DARKGREY_40 = "eon-darkgrey-40";
export const COLOR_DARKGREY_45 = "eon-darkgrey-45";
export const COLOR_DARKGREY_50 = "eon-darkgrey-50";
export const COLOR_DARKGREY_55 = "eon-darkgrey-55";
export const COLOR_DARKGREY_60 = "eon-darkgrey-60";
export const COLOR_DARKGREY_65 = "eon-darkgrey-65";
export const COLOR_DARKGREY_70 = "eon-darkgrey-70";
export const COLOR_DARKGREY_75 = "eon-darkgrey-75";
export const COLOR_DARKGREY_80 = "eon-darkgrey-80";
export const COLOR_DARKGREY_85 = "eon-darkgrey-85";
export const COLOR_DARKGREY_90 = "eon-darkgrey-90";
export const COLOR_DARKGREY_95 = "eon-darkgrey-95";
export const COLOR_DARKGREY_OPACITY_5 = "eon-darkgrey-opacity-5";
export const COLOR_DARKGREY_OPACITY_10 = "eon-darkgrey-opacity-10";
export const COLOR_DARKGREY_OPACITY_15 = "eon-darkgrey-opacity-15";
export const COLOR_DARKGREY_OPACITY_20 = "eon-darkgrey-opacity-20";
export const COLOR_DARKGREY_OPACITY_25 = "eon-darkgrey-opacity-25";
export const COLOR_DARKGREY_OPACITY_30 = "eon-darkgrey-opacity-30";
export const COLOR_DARKGREY_OPACITY_35 = "eon-darkgrey-opacity-35";
export const COLOR_DARKGREY_OPACITY_40 = "eon-darkgrey-opacity-40";
export const COLOR_DARKGREY_OPACITY_45 = "eon-darkgrey-opacity-45";
export const COLOR_DARKGREY_OPACITY_50 = "eon-darkgrey-opacity-50";
export const COLOR_DARKGREY_OPACITY_55 = "eon-darkgrey-opacity-55";
export const COLOR_DARKGREY_OPACITY_60 = "eon-darkgrey-opacity-60";
export const COLOR_DARKGREY_OPACITY_65 = "eon-darkgrey-opacity-65";
export const COLOR_DARKGREY_OPACITY_70 = "eon-darkgrey-opacity-70";
export const COLOR_DARKGREY_OPACITY_75 = "eon-darkgrey-opacity-75";
export const COLOR_DARKGREY_OPACITY_80 = "eon-darkgrey-opacity-80";
export const COLOR_DARKGREY_OPACITY_85 = "eon-darkgrey-opacity-85";
export const COLOR_DARKGREY_OPACITY_90 = "eon-darkgrey-opacity-90";
export const COLOR_DARKGREY_OPACITY_95 = "eon-darkgrey-opacity-95";
export const COLOR_BLACK_SHADE_1 = "eon-black-shade-1";
export const COLOR_BLACK_SHADE_2 = "eon-black-shade-2";
export const COLOR_BLACK_TINT_1 = "eon-black-tint-1";
export const COLOR_BLACK_TINT_2 = "eon-black-tint-2";
export const COLOR_BLACK_5 = "eon-black-5";
export const COLOR_BLACK_10 = "eon-black-10";
export const COLOR_BLACK_15 = "eon-black-15";
export const COLOR_BLACK_20 = "eon-black-20";
export const COLOR_BLACK_25 = "eon-black-25";
export const COLOR_BLACK_30 = "eon-black-30";
export const COLOR_BLACK_35 = "eon-black-35";
export const COLOR_BLACK_40 = "eon-black-40";
export const COLOR_BLACK_45 = "eon-black-45";
export const COLOR_BLACK_50 = "eon-black-50";
export const COLOR_BLACK_55 = "eon-black-55";
export const COLOR_BLACK_60 = "eon-black-60";
export const COLOR_BLACK_65 = "eon-black-65";
export const COLOR_BLACK_70 = "eon-black-70";
export const COLOR_BLACK_75 = "eon-black-75";
export const COLOR_BLACK_80 = "eon-black-80";
export const COLOR_BLACK_85 = "eon-black-85";
export const COLOR_BLACK_90 = "eon-black-90";
export const COLOR_BLACK_95 = "eon-black-95";
export const COLOR_BLACK_OPACITY_5 = "eon-black-opacity-5";
export const COLOR_BLACK_OPACITY_10 = "eon-black-opacity-10";
export const COLOR_BLACK_OPACITY_15 = "eon-black-opacity-15";
export const COLOR_BLACK_OPACITY_20 = "eon-black-opacity-20";
export const COLOR_BLACK_OPACITY_25 = "eon-black-opacity-25";
export const COLOR_BLACK_OPACITY_30 = "eon-black-opacity-30";
export const COLOR_BLACK_OPACITY_35 = "eon-black-opacity-35";
export const COLOR_BLACK_OPACITY_40 = "eon-black-opacity-40";
export const COLOR_BLACK_OPACITY_45 = "eon-black-opacity-45";
export const COLOR_BLACK_OPACITY_50 = "eon-black-opacity-50";
export const COLOR_BLACK_OPACITY_55 = "eon-black-opacity-55";
export const COLOR_BLACK_OPACITY_60 = "eon-black-opacity-60";
export const COLOR_BLACK_OPACITY_65 = "eon-black-opacity-65";
export const COLOR_BLACK_OPACITY_70 = "eon-black-opacity-70";
export const COLOR_BLACK_OPACITY_75 = "eon-black-opacity-75";
export const COLOR_BLACK_OPACITY_80 = "eon-black-opacity-80";
export const COLOR_BLACK_OPACITY_85 = "eon-black-opacity-85";
export const COLOR_BLACK_OPACITY_90 = "eon-black-opacity-90";
export const COLOR_BLACK_OPACITY_95 = "eon-black-opacity-95";

export const EON_COLORS = [
  COLOR_BRIGHT,
  COLOR_DARK,
  COLOR_RED,
  COLOR_TURQUOISE,
  COLOR_LIMEYELLOW,
  COLOR_BORDEAUX,
  COLOR_WHITE,
  COLOR_ULTRALIGHTGREY,
  COLOR_LIGHTGREY,
  COLOR_MIDDLEGREY,
  COLOR_DARKGREY,
  COLOR_BLACK,
  COLOR_BRIGHT_SHADE_1,
  COLOR_BRIGHT_SHADE_2,
  COLOR_BRIGHT_TINT_1,
  COLOR_BRIGHT_TINT_2,
  COLOR_BRIGHT_5,
  COLOR_BRIGHT_10,
  COLOR_BRIGHT_15,
  COLOR_BRIGHT_20,
  COLOR_BRIGHT_25,
  COLOR_BRIGHT_30,
  COLOR_BRIGHT_35,
  COLOR_BRIGHT_40,
  COLOR_BRIGHT_45,
  COLOR_BRIGHT_50,
  COLOR_BRIGHT_55,
  COLOR_BRIGHT_60,
  COLOR_BRIGHT_65,
  COLOR_BRIGHT_70,
  COLOR_BRIGHT_75,
  COLOR_BRIGHT_80,
  COLOR_BRIGHT_85,
  COLOR_BRIGHT_90,
  COLOR_BRIGHT_95,
  COLOR_BRIGHT_OPACITY_5,
  COLOR_BRIGHT_OPACITY_10,
  COLOR_BRIGHT_OPACITY_15,
  COLOR_BRIGHT_OPACITY_20,
  COLOR_BRIGHT_OPACITY_25,
  COLOR_BRIGHT_OPACITY_30,
  COLOR_BRIGHT_OPACITY_35,
  COLOR_BRIGHT_OPACITY_40,
  COLOR_BRIGHT_OPACITY_45,
  COLOR_BRIGHT_OPACITY_50,
  COLOR_BRIGHT_OPACITY_55,
  COLOR_BRIGHT_OPACITY_60,
  COLOR_BRIGHT_OPACITY_65,
  COLOR_BRIGHT_OPACITY_70,
  COLOR_BRIGHT_OPACITY_75,
  COLOR_BRIGHT_OPACITY_80,
  COLOR_BRIGHT_OPACITY_85,
  COLOR_BRIGHT_OPACITY_90,
  COLOR_BRIGHT_OPACITY_95,
  COLOR_DARK_SHADE_1,
  COLOR_DARK_SHADE_2,
  COLOR_DARK_TINT_1,
  COLOR_DARK_TINT_2,
  COLOR_DARK_5,
  COLOR_DARK_10,
  COLOR_DARK_15,
  COLOR_DARK_20,
  COLOR_DARK_25,
  COLOR_DARK_30,
  COLOR_DARK_35,
  COLOR_DARK_40,
  COLOR_DARK_45,
  COLOR_DARK_50,
  COLOR_DARK_55,
  COLOR_DARK_60,
  COLOR_DARK_65,
  COLOR_DARK_70,
  COLOR_DARK_75,
  COLOR_DARK_80,
  COLOR_DARK_85,
  COLOR_DARK_90,
  COLOR_DARK_95,
  COLOR_DARK_OPACITY_5,
  COLOR_DARK_OPACITY_10,
  COLOR_DARK_OPACITY_15,
  COLOR_DARK_OPACITY_20,
  COLOR_DARK_OPACITY_25,
  COLOR_DARK_OPACITY_30,
  COLOR_DARK_OPACITY_35,
  COLOR_DARK_OPACITY_40,
  COLOR_DARK_OPACITY_45,
  COLOR_DARK_OPACITY_50,
  COLOR_DARK_OPACITY_55,
  COLOR_DARK_OPACITY_60,
  COLOR_DARK_OPACITY_65,
  COLOR_DARK_OPACITY_70,
  COLOR_DARK_OPACITY_75,
  COLOR_DARK_OPACITY_80,
  COLOR_DARK_OPACITY_85,
  COLOR_DARK_OPACITY_90,
  COLOR_DARK_OPACITY_95,
  COLOR_RED_SHADE_1,
  COLOR_RED_SHADE_2,
  COLOR_RED_TINT_1,
  COLOR_RED_TINT_2,
  COLOR_RED_5,
  COLOR_RED_10,
  COLOR_RED_15,
  COLOR_RED_20,
  COLOR_RED_25,
  COLOR_RED_30,
  COLOR_RED_35,
  COLOR_RED_40,
  COLOR_RED_45,
  COLOR_RED_50,
  COLOR_RED_55,
  COLOR_RED_60,
  COLOR_RED_65,
  COLOR_RED_70,
  COLOR_RED_75,
  COLOR_RED_80,
  COLOR_RED_85,
  COLOR_RED_90,
  COLOR_RED_95,
  COLOR_RED_OPACITY_5,
  COLOR_RED_OPACITY_10,
  COLOR_RED_OPACITY_15,
  COLOR_RED_OPACITY_20,
  COLOR_RED_OPACITY_25,
  COLOR_RED_OPACITY_30,
  COLOR_RED_OPACITY_35,
  COLOR_RED_OPACITY_40,
  COLOR_RED_OPACITY_45,
  COLOR_RED_OPACITY_50,
  COLOR_RED_OPACITY_55,
  COLOR_RED_OPACITY_60,
  COLOR_RED_OPACITY_65,
  COLOR_RED_OPACITY_70,
  COLOR_RED_OPACITY_75,
  COLOR_RED_OPACITY_80,
  COLOR_RED_OPACITY_85,
  COLOR_RED_OPACITY_90,
  COLOR_RED_OPACITY_95,
  COLOR_TURQUOISE_SHADE_1,
  COLOR_TURQUOISE_SHADE_2,
  COLOR_TURQUOISE_TINT_1,
  COLOR_TURQUOISE_TINT_2,
  COLOR_TURQUOISE_5,
  COLOR_TURQUOISE_10,
  COLOR_TURQUOISE_15,
  COLOR_TURQUOISE_20,
  COLOR_TURQUOISE_25,
  COLOR_TURQUOISE_30,
  COLOR_TURQUOISE_35,
  COLOR_TURQUOISE_40,
  COLOR_TURQUOISE_45,
  COLOR_TURQUOISE_50,
  COLOR_TURQUOISE_55,
  COLOR_TURQUOISE_60,
  COLOR_TURQUOISE_65,
  COLOR_TURQUOISE_70,
  COLOR_TURQUOISE_75,
  COLOR_TURQUOISE_80,
  COLOR_TURQUOISE_85,
  COLOR_TURQUOISE_90,
  COLOR_TURQUOISE_95,
  COLOR_TURQUOISE_OPACITY_5,
  COLOR_TURQUOISE_OPACITY_10,
  COLOR_TURQUOISE_OPACITY_15,
  COLOR_TURQUOISE_OPACITY_20,
  COLOR_TURQUOISE_OPACITY_25,
  COLOR_TURQUOISE_OPACITY_30,
  COLOR_TURQUOISE_OPACITY_35,
  COLOR_TURQUOISE_OPACITY_40,
  COLOR_TURQUOISE_OPACITY_45,
  COLOR_TURQUOISE_OPACITY_50,
  COLOR_TURQUOISE_OPACITY_55,
  COLOR_TURQUOISE_OPACITY_60,
  COLOR_TURQUOISE_OPACITY_65,
  COLOR_TURQUOISE_OPACITY_70,
  COLOR_TURQUOISE_OPACITY_75,
  COLOR_TURQUOISE_OPACITY_80,
  COLOR_TURQUOISE_OPACITY_85,
  COLOR_TURQUOISE_OPACITY_90,
  COLOR_TURQUOISE_OPACITY_95,
  COLOR_LIMEYELLOW_SHADE_1,
  COLOR_LIMEYELLOW_SHADE_2,
  COLOR_LIMEYELLOW_TINT_1,
  COLOR_LIMEYELLOW_TINT_2,
  COLOR_LIMEYELLOW_5,
  COLOR_LIMEYELLOW_10,
  COLOR_LIMEYELLOW_15,
  COLOR_LIMEYELLOW_20,
  COLOR_LIMEYELLOW_25,
  COLOR_LIMEYELLOW_30,
  COLOR_LIMEYELLOW_35,
  COLOR_LIMEYELLOW_40,
  COLOR_LIMEYELLOW_45,
  COLOR_LIMEYELLOW_50,
  COLOR_LIMEYELLOW_55,
  COLOR_LIMEYELLOW_60,
  COLOR_LIMEYELLOW_65,
  COLOR_LIMEYELLOW_70,
  COLOR_LIMEYELLOW_75,
  COLOR_LIMEYELLOW_80,
  COLOR_LIMEYELLOW_85,
  COLOR_LIMEYELLOW_90,
  COLOR_LIMEYELLOW_95,
  COLOR_LIMEYELLOW_OPACITY_5,
  COLOR_LIMEYELLOW_OPACITY_10,
  COLOR_LIMEYELLOW_OPACITY_15,
  COLOR_LIMEYELLOW_OPACITY_20,
  COLOR_LIMEYELLOW_OPACITY_25,
  COLOR_LIMEYELLOW_OPACITY_30,
  COLOR_LIMEYELLOW_OPACITY_35,
  COLOR_LIMEYELLOW_OPACITY_40,
  COLOR_LIMEYELLOW_OPACITY_45,
  COLOR_LIMEYELLOW_OPACITY_50,
  COLOR_LIMEYELLOW_OPACITY_55,
  COLOR_LIMEYELLOW_OPACITY_60,
  COLOR_LIMEYELLOW_OPACITY_65,
  COLOR_LIMEYELLOW_OPACITY_70,
  COLOR_LIMEYELLOW_OPACITY_75,
  COLOR_LIMEYELLOW_OPACITY_80,
  COLOR_LIMEYELLOW_OPACITY_85,
  COLOR_LIMEYELLOW_OPACITY_90,
  COLOR_LIMEYELLOW_OPACITY_95,
  COLOR_BORDEAUX_SHADE_1,
  COLOR_BORDEAUX_SHADE_2,
  COLOR_BORDEAUX_TINT_1,
  COLOR_BORDEAUX_TINT_2,
  COLOR_BORDEAUX_5,
  COLOR_BORDEAUX_10,
  COLOR_BORDEAUX_15,
  COLOR_BORDEAUX_20,
  COLOR_BORDEAUX_25,
  COLOR_BORDEAUX_30,
  COLOR_BORDEAUX_35,
  COLOR_BORDEAUX_40,
  COLOR_BORDEAUX_45,
  COLOR_BORDEAUX_50,
  COLOR_BORDEAUX_55,
  COLOR_BORDEAUX_60,
  COLOR_BORDEAUX_65,
  COLOR_BORDEAUX_70,
  COLOR_BORDEAUX_75,
  COLOR_BORDEAUX_80,
  COLOR_BORDEAUX_85,
  COLOR_BORDEAUX_90,
  COLOR_BORDEAUX_95,
  COLOR_BORDEAUX_OPACITY_5,
  COLOR_BORDEAUX_OPACITY_10,
  COLOR_BORDEAUX_OPACITY_15,
  COLOR_BORDEAUX_OPACITY_20,
  COLOR_BORDEAUX_OPACITY_25,
  COLOR_BORDEAUX_OPACITY_30,
  COLOR_BORDEAUX_OPACITY_35,
  COLOR_BORDEAUX_OPACITY_40,
  COLOR_BORDEAUX_OPACITY_45,
  COLOR_BORDEAUX_OPACITY_50,
  COLOR_BORDEAUX_OPACITY_55,
  COLOR_BORDEAUX_OPACITY_60,
  COLOR_BORDEAUX_OPACITY_65,
  COLOR_BORDEAUX_OPACITY_70,
  COLOR_BORDEAUX_OPACITY_75,
  COLOR_BORDEAUX_OPACITY_80,
  COLOR_BORDEAUX_OPACITY_85,
  COLOR_BORDEAUX_OPACITY_90,
  COLOR_BORDEAUX_OPACITY_95,
  COLOR_WHITE_SHADE_1,
  COLOR_WHITE_SHADE_2,
  COLOR_WHITE_TINT_1,
  COLOR_WHITE_TINT_2,
  COLOR_WHITE_5,
  COLOR_WHITE_10,
  COLOR_WHITE_15,
  COLOR_WHITE_20,
  COLOR_WHITE_25,
  COLOR_WHITE_30,
  COLOR_WHITE_35,
  COLOR_WHITE_40,
  COLOR_WHITE_45,
  COLOR_WHITE_50,
  COLOR_WHITE_55,
  COLOR_WHITE_60,
  COLOR_WHITE_65,
  COLOR_WHITE_70,
  COLOR_WHITE_75,
  COLOR_WHITE_80,
  COLOR_WHITE_85,
  COLOR_WHITE_90,
  COLOR_WHITE_95,
  COLOR_WHITE_OPACITY_5,
  COLOR_WHITE_OPACITY_10,
  COLOR_WHITE_OPACITY_15,
  COLOR_WHITE_OPACITY_20,
  COLOR_WHITE_OPACITY_25,
  COLOR_WHITE_OPACITY_30,
  COLOR_WHITE_OPACITY_35,
  COLOR_WHITE_OPACITY_40,
  COLOR_WHITE_OPACITY_45,
  COLOR_WHITE_OPACITY_50,
  COLOR_WHITE_OPACITY_55,
  COLOR_WHITE_OPACITY_60,
  COLOR_WHITE_OPACITY_65,
  COLOR_WHITE_OPACITY_70,
  COLOR_WHITE_OPACITY_75,
  COLOR_WHITE_OPACITY_80,
  COLOR_WHITE_OPACITY_85,
  COLOR_WHITE_OPACITY_90,
  COLOR_WHITE_OPACITY_95,
  COLOR_ULTRALIGHTGREY_SHADE_1,
  COLOR_ULTRALIGHTGREY_SHADE_2,
  COLOR_ULTRALIGHTGREY_TINT_1,
  COLOR_ULTRALIGHTGREY_TINT_2,
  COLOR_ULTRALIGHTGREY_5,
  COLOR_ULTRALIGHTGREY_10,
  COLOR_ULTRALIGHTGREY_15,
  COLOR_ULTRALIGHTGREY_20,
  COLOR_ULTRALIGHTGREY_25,
  COLOR_ULTRALIGHTGREY_30,
  COLOR_ULTRALIGHTGREY_35,
  COLOR_ULTRALIGHTGREY_40,
  COLOR_ULTRALIGHTGREY_45,
  COLOR_ULTRALIGHTGREY_50,
  COLOR_ULTRALIGHTGREY_55,
  COLOR_ULTRALIGHTGREY_60,
  COLOR_ULTRALIGHTGREY_65,
  COLOR_ULTRALIGHTGREY_70,
  COLOR_ULTRALIGHTGREY_75,
  COLOR_ULTRALIGHTGREY_80,
  COLOR_ULTRALIGHTGREY_85,
  COLOR_ULTRALIGHTGREY_90,
  COLOR_ULTRALIGHTGREY_95,
  COLOR_ULTRALIGHTGREY_OPACITY_5,
  COLOR_ULTRALIGHTGREY_OPACITY_10,
  COLOR_ULTRALIGHTGREY_OPACITY_15,
  COLOR_ULTRALIGHTGREY_OPACITY_20,
  COLOR_ULTRALIGHTGREY_OPACITY_25,
  COLOR_ULTRALIGHTGREY_OPACITY_30,
  COLOR_ULTRALIGHTGREY_OPACITY_35,
  COLOR_ULTRALIGHTGREY_OPACITY_40,
  COLOR_ULTRALIGHTGREY_OPACITY_45,
  COLOR_ULTRALIGHTGREY_OPACITY_50,
  COLOR_ULTRALIGHTGREY_OPACITY_55,
  COLOR_ULTRALIGHTGREY_OPACITY_60,
  COLOR_ULTRALIGHTGREY_OPACITY_65,
  COLOR_ULTRALIGHTGREY_OPACITY_70,
  COLOR_ULTRALIGHTGREY_OPACITY_75,
  COLOR_ULTRALIGHTGREY_OPACITY_80,
  COLOR_ULTRALIGHTGREY_OPACITY_85,
  COLOR_ULTRALIGHTGREY_OPACITY_90,
  COLOR_ULTRALIGHTGREY_OPACITY_95,
  COLOR_LIGHTGREY_SHADE_1,
  COLOR_LIGHTGREY_SHADE_2,
  COLOR_LIGHTGREY_TINT_1,
  COLOR_LIGHTGREY_TINT_2,
  COLOR_LIGHTGREY_5,
  COLOR_LIGHTGREY_10,
  COLOR_LIGHTGREY_15,
  COLOR_LIGHTGREY_20,
  COLOR_LIGHTGREY_25,
  COLOR_LIGHTGREY_30,
  COLOR_LIGHTGREY_35,
  COLOR_LIGHTGREY_40,
  COLOR_LIGHTGREY_45,
  COLOR_LIGHTGREY_50,
  COLOR_LIGHTGREY_55,
  COLOR_LIGHTGREY_60,
  COLOR_LIGHTGREY_65,
  COLOR_LIGHTGREY_70,
  COLOR_LIGHTGREY_75,
  COLOR_LIGHTGREY_80,
  COLOR_LIGHTGREY_85,
  COLOR_LIGHTGREY_90,
  COLOR_LIGHTGREY_95,
  COLOR_LIGHTGREY_OPACITY_5,
  COLOR_LIGHTGREY_OPACITY_10,
  COLOR_LIGHTGREY_OPACITY_15,
  COLOR_LIGHTGREY_OPACITY_20,
  COLOR_LIGHTGREY_OPACITY_25,
  COLOR_LIGHTGREY_OPACITY_30,
  COLOR_LIGHTGREY_OPACITY_35,
  COLOR_LIGHTGREY_OPACITY_40,
  COLOR_LIGHTGREY_OPACITY_45,
  COLOR_LIGHTGREY_OPACITY_50,
  COLOR_LIGHTGREY_OPACITY_55,
  COLOR_LIGHTGREY_OPACITY_60,
  COLOR_LIGHTGREY_OPACITY_65,
  COLOR_LIGHTGREY_OPACITY_70,
  COLOR_LIGHTGREY_OPACITY_75,
  COLOR_LIGHTGREY_OPACITY_80,
  COLOR_LIGHTGREY_OPACITY_85,
  COLOR_LIGHTGREY_OPACITY_90,
  COLOR_LIGHTGREY_OPACITY_95,
  COLOR_MIDDLEGREY_SHADE_1,
  COLOR_MIDDLEGREY_SHADE_2,
  COLOR_MIDDLEGREY_TINT_1,
  COLOR_MIDDLEGREY_TINT_2,
  COLOR_MIDDLEGREY_5,
  COLOR_MIDDLEGREY_10,
  COLOR_MIDDLEGREY_15,
  COLOR_MIDDLEGREY_20,
  COLOR_MIDDLEGREY_25,
  COLOR_MIDDLEGREY_30,
  COLOR_MIDDLEGREY_35,
  COLOR_MIDDLEGREY_40,
  COLOR_MIDDLEGREY_45,
  COLOR_MIDDLEGREY_50,
  COLOR_MIDDLEGREY_55,
  COLOR_MIDDLEGREY_60,
  COLOR_MIDDLEGREY_65,
  COLOR_MIDDLEGREY_70,
  COLOR_MIDDLEGREY_75,
  COLOR_MIDDLEGREY_80,
  COLOR_MIDDLEGREY_85,
  COLOR_MIDDLEGREY_90,
  COLOR_MIDDLEGREY_95,
  COLOR_MIDDLEGREY_OPACITY_5,
  COLOR_MIDDLEGREY_OPACITY_10,
  COLOR_MIDDLEGREY_OPACITY_15,
  COLOR_MIDDLEGREY_OPACITY_20,
  COLOR_MIDDLEGREY_OPACITY_25,
  COLOR_MIDDLEGREY_OPACITY_30,
  COLOR_MIDDLEGREY_OPACITY_35,
  COLOR_MIDDLEGREY_OPACITY_40,
  COLOR_MIDDLEGREY_OPACITY_45,
  COLOR_MIDDLEGREY_OPACITY_50,
  COLOR_MIDDLEGREY_OPACITY_55,
  COLOR_MIDDLEGREY_OPACITY_60,
  COLOR_MIDDLEGREY_OPACITY_65,
  COLOR_MIDDLEGREY_OPACITY_70,
  COLOR_MIDDLEGREY_OPACITY_75,
  COLOR_MIDDLEGREY_OPACITY_80,
  COLOR_MIDDLEGREY_OPACITY_85,
  COLOR_MIDDLEGREY_OPACITY_90,
  COLOR_MIDDLEGREY_OPACITY_95,
  COLOR_DARKGREY_SHADE_1,
  COLOR_DARKGREY_SHADE_2,
  COLOR_DARKGREY_TINT_1,
  COLOR_DARKGREY_TINT_2,
  COLOR_DARKGREY_5,
  COLOR_DARKGREY_10,
  COLOR_DARKGREY_15,
  COLOR_DARKGREY_20,
  COLOR_DARKGREY_25,
  COLOR_DARKGREY_30,
  COLOR_DARKGREY_35,
  COLOR_DARKGREY_40,
  COLOR_DARKGREY_45,
  COLOR_DARKGREY_50,
  COLOR_DARKGREY_55,
  COLOR_DARKGREY_60,
  COLOR_DARKGREY_65,
  COLOR_DARKGREY_70,
  COLOR_DARKGREY_75,
  COLOR_DARKGREY_80,
  COLOR_DARKGREY_85,
  COLOR_DARKGREY_90,
  COLOR_DARKGREY_95,
  COLOR_DARKGREY_OPACITY_5,
  COLOR_DARKGREY_OPACITY_10,
  COLOR_DARKGREY_OPACITY_15,
  COLOR_DARKGREY_OPACITY_20,
  COLOR_DARKGREY_OPACITY_25,
  COLOR_DARKGREY_OPACITY_30,
  COLOR_DARKGREY_OPACITY_35,
  COLOR_DARKGREY_OPACITY_40,
  COLOR_DARKGREY_OPACITY_45,
  COLOR_DARKGREY_OPACITY_50,
  COLOR_DARKGREY_OPACITY_55,
  COLOR_DARKGREY_OPACITY_60,
  COLOR_DARKGREY_OPACITY_65,
  COLOR_DARKGREY_OPACITY_70,
  COLOR_DARKGREY_OPACITY_75,
  COLOR_DARKGREY_OPACITY_80,
  COLOR_DARKGREY_OPACITY_85,
  COLOR_DARKGREY_OPACITY_90,
  COLOR_DARKGREY_OPACITY_95,
  COLOR_BLACK_SHADE_1,
  COLOR_BLACK_SHADE_2,
  COLOR_BLACK_TINT_1,
  COLOR_BLACK_TINT_2,
  COLOR_BLACK_5,
  COLOR_BLACK_10,
  COLOR_BLACK_15,
  COLOR_BLACK_20,
  COLOR_BLACK_25,
  COLOR_BLACK_30,
  COLOR_BLACK_35,
  COLOR_BLACK_40,
  COLOR_BLACK_45,
  COLOR_BLACK_50,
  COLOR_BLACK_55,
  COLOR_BLACK_60,
  COLOR_BLACK_65,
  COLOR_BLACK_70,
  COLOR_BLACK_75,
  COLOR_BLACK_80,
  COLOR_BLACK_85,
  COLOR_BLACK_90,
  COLOR_BLACK_95,
  COLOR_BLACK_OPACITY_5,
  COLOR_BLACK_OPACITY_10,
  COLOR_BLACK_OPACITY_15,
  COLOR_BLACK_OPACITY_20,
  COLOR_BLACK_OPACITY_25,
  COLOR_BLACK_OPACITY_30,
  COLOR_BLACK_OPACITY_35,
  COLOR_BLACK_OPACITY_40,
  COLOR_BLACK_OPACITY_45,
  COLOR_BLACK_OPACITY_50,
  COLOR_BLACK_OPACITY_55,
  COLOR_BLACK_OPACITY_60,
  COLOR_BLACK_OPACITY_65,
  COLOR_BLACK_OPACITY_70,
  COLOR_BLACK_OPACITY_75,
  COLOR_BLACK_OPACITY_80,
  COLOR_BLACK_OPACITY_85,
  COLOR_BLACK_OPACITY_90,
  COLOR_BLACK_OPACITY_95,
  COLOR_RED_ACTIVE,
  COLOR_LIGHTGREY_ACTIVE,
  COLOR_TURQUOISE_ACTIVE,
  COLOR_BORDEAUX_ACTIVE,
  COLOR_LIMEYELLOW_ACTIVE,
  COLOR_DARKGREY_ACTIVE,
  COLOR_MIDDLEGREY_ACTIVE,
  COLOR_WHITE_TABBAR_COLOR,
  COLOR_DARK_TABBAR_COLOR,
  COLOR_LIMEYELLOW_DARK,
  COLOR_BORDEAUX_DARK,
  COLOR_TURQUOISE_DARK,
  COLOR_VIOLET_DARK,
  COLOR_LIMEYELLOW_LIGHT,

  COLOR_TRANSPARENT
] as const;

export const THEME_COLORS = [
  "bright",
  "dark",
  "red",
  "turquoise",
  "limeyellow",
  "bordeaux",
  "white",
  "ultralightgrey",
  "lightgrey",
  "middlegrey",
  "darkgrey",
  "black"
];

export const DEFAULT_PAGE_BACKGROUND_COLOR = "eon-white" as const;

export const ACCORDION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "whiteRed",
    scheme: {
      textColor: COLOR_DARKGREY,
      accordionBorderColor: COLOR_LIGHTGREY,
      activeAccordionBackgroundColor: COLOR_ULTRALIGHTGREY,
      activeAccordionBarColor: COLOR_RED,
      accordionHoverColor: COLOR_ULTRALIGHTGREY,
      borderHoverColor: COLOR_LIGHTGREY
    }
  },
  {
    schemeName: "whiteRedOnLightgrey",
    scheme: {
      textColor: COLOR_DARKGREY,
      accordionBorderColor: COLOR_LIGHTGREY_ACTIVE,
      activeAccordionBackgroundColor: COLOR_ULTRALIGHTGREY,
      activeAccordionBarColor: COLOR_RED,
      accordionHoverColor: COLOR_ULTRALIGHTGREY,
      borderHoverColor: COLOR_LIGHTGREY_ACTIVE
    }
  },
  {
    schemeName: "whiteRedOnUltralightgrey",
    scheme: {
      textColor: COLOR_DARKGREY,
      accordionBorderColor: COLOR_LIGHTGREY,
      activeAccordionBackgroundColor: COLOR_WHITE,
      activeAccordionBarColor: COLOR_RED,
      accordionHoverColor: COLOR_WHITE,
      borderHoverColor: COLOR_LIGHTGREY
    }
  },
  {
    schemeName: "whiteTurquoise",
    scheme: {
      textColor: COLOR_DARKGREY,
      accordionBorderColor: COLOR_LIGHTGREY,
      activeAccordionBackgroundColor: COLOR_ULTRALIGHTGREY,
      activeAccordionBarColor: COLOR_TURQUOISE,
      accordionHoverColor: COLOR_ULTRALIGHTGREY,
      borderHoverColor: COLOR_LIGHTGREY
    }
  },
  {
    schemeName: "whiteTurquoiseOnLightgrey",
    scheme: {
      textColor: COLOR_DARKGREY,
      accordionBorderColor: COLOR_LIGHTGREY_ACTIVE,
      activeAccordionBackgroundColor: COLOR_ULTRALIGHTGREY,
      activeAccordionBarColor: COLOR_TURQUOISE,
      accordionHoverColor: COLOR_ULTRALIGHTGREY,
      borderHoverColor: COLOR_LIGHTGREY_ACTIVE
    }
  },
  {
    schemeName: "whiteTurquoiseOnUltralightgrey",
    scheme: {
      textColor: COLOR_DARKGREY,
      accordionBorderColor: COLOR_LIGHTGREY,
      activeAccordionBackgroundColor: COLOR_WHITE,
      activeAccordionBarColor: COLOR_TURQUOISE,
      accordionHoverColor: COLOR_WHITE,
      borderHoverColor: COLOR_LIGHTGREY
    }
  },
  {
    schemeName: "red",
    scheme: {
      textColor: COLOR_WHITE,
      accordionBorderColor: COLOR_LIGHTGREY,
      activeAccordionBackgroundColor: COLOR_RED_ACTIVE,
      activeAccordionBarColor: COLOR_LIMEYELLOW,
      accordionHoverColor: COLOR_RED_ACTIVE,
      borderHoverColor: COLOR_RED_75
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      textColor: COLOR_WHITE,
      accordionBorderColor: COLOR_LIGHTGREY,
      activeAccordionBackgroundColor: COLOR_TURQUOISE_ACTIVE,
      activeAccordionBarColor: COLOR_LIMEYELLOW,
      accordionHoverColor: COLOR_TURQUOISE_ACTIVE,
      borderHoverColor: COLOR_TURQUOISE_75
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      textColor: COLOR_WHITE,
      accordionBorderColor: COLOR_LIGHTGREY,
      activeAccordionBackgroundColor: COLOR_BORDEAUX_ACTIVE,
      activeAccordionBarColor: COLOR_LIMEYELLOW,
      accordionHoverColor: COLOR_BORDEAUX_ACTIVE,
      borderHoverColor: COLOR_BORDEAUX_75
    }
  },
  {
    schemeName: "limeyellow",
    scheme: {
      textColor: COLOR_DARKGREY,
      accordionBorderColor: COLOR_LIMEYELLOW_DARK,
      activeAccordionBackgroundColor: COLOR_LIMEYELLOW_ACTIVE,
      activeAccordionBarColor: COLOR_BORDEAUX,
      accordionHoverColor: COLOR_LIMEYELLOW_ACTIVE,
      borderHoverColor: COLOR_LIMEYELLOW_DARK
    }
  }
];
export const ANSWER_CARD_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      footTextColor: COLOR_DARKGREY,
      footTextHoverColor: COLOR_WHITE,
      imageBackgroundColor: COLOR_WHITE,
      imageBackgroundSelectedColor: COLOR_TURQUOISE,
      footBackgroundColor: COLOR_ULTRALIGHTGREY,
      footBackgroundHoverColor: COLOR_TURQUOISE_ACTIVE,
      footBackgroundSelectedColor: COLOR_TURQUOISE_DARK,
      hoverCardBorderColor: COLOR_TURQUOISE,
      selectedCardBorderColor: COLOR_TURQUOISE,
      indicatorBordercolor: COLOR_TURQUOISE,
      errorMessageColor: COLOR_BORDEAUX
    }
  },
  {
    schemeName: "red",
    scheme: {
      footTextColor: COLOR_DARKGREY,
      footTextHoverColor: COLOR_WHITE,
      imageBackgroundColor: COLOR_WHITE,
      imageBackgroundSelectedColor: COLOR_RED,
      footBackgroundColor: COLOR_ULTRALIGHTGREY,
      footBackgroundHoverColor: COLOR_RED_ACTIVE,
      footBackgroundSelectedColor: COLOR_BORDEAUX_ACTIVE,
      hoverCardBorderColor: COLOR_WHITE_OPACITY_50,
      selectedCardBorderColor: COLOR_WHITE,
      indicatorBordercolor: COLOR_BORDEAUX,
      errorMessageColor: COLOR_WHITE
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      footTextColor: COLOR_DARKGREY,
      footTextHoverColor: COLOR_WHITE,
      imageBackgroundColor: COLOR_WHITE,
      imageBackgroundSelectedColor: COLOR_TURQUOISE,
      footBackgroundColor: COLOR_ULTRALIGHTGREY,
      footBackgroundHoverColor: COLOR_TURQUOISE_ACTIVE,
      footBackgroundSelectedColor: COLOR_TURQUOISE_DARK,
      hoverCardBorderColor: COLOR_WHITE_OPACITY_50,
      selectedCardBorderColor: COLOR_WHITE,
      indicatorBordercolor: COLOR_TURQUOISE,
      errorMessageColor: COLOR_WHITE
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      footTextColor: COLOR_DARKGREY,
      footTextHoverColor: COLOR_WHITE,
      imageBackgroundColor: COLOR_WHITE,
      imageBackgroundSelectedColor: COLOR_BORDEAUX,
      footBackgroundColor: COLOR_ULTRALIGHTGREY,
      footBackgroundHoverColor: COLOR_BORDEAUX,
      footBackgroundSelectedColor: COLOR_BORDEAUX_DARK,
      hoverCardBorderColor: COLOR_WHITE_OPACITY_50,
      selectedCardBorderColor: COLOR_WHITE,
      indicatorBordercolor: COLOR_BORDEAUX,
      errorMessageColor: COLOR_WHITE
    }
  },
  {
    schemeName: "limeyellow",
    scheme: {
      footTextColor: COLOR_DARKGREY,
      footTextHoverColor: COLOR_WHITE,
      imageBackgroundColor: COLOR_WHITE,
      imageBackgroundSelectedColor: COLOR_BORDEAUX,
      footBackgroundColor: COLOR_ULTRALIGHTGREY,
      footBackgroundHoverColor: COLOR_BORDEAUX,
      footBackgroundSelectedColor: COLOR_BORDEAUX_DARK,
      hoverCardBorderColor: COLOR_BORDEAUX,
      selectedCardBorderColor: COLOR_BORDEAUX,
      indicatorBordercolor: COLOR_BORDEAUX,
      errorMessageColor: COLOR_BORDEAUX
    }
  },
  {
    schemeName: "darkgrey",
    scheme: {
      footTextColor: COLOR_DARKGREY,
      footTextHoverColor: COLOR_WHITE,
      imageBackgroundColor: COLOR_WHITE,
      imageBackgroundSelectedColor: COLOR_TURQUOISE,
      footBackgroundColor: COLOR_ULTRALIGHTGREY,
      footBackgroundHoverColor: COLOR_TURQUOISE_ACTIVE,
      footBackgroundSelectedColor: COLOR_TURQUOISE_DARK,
      hoverCardBorderColor: COLOR_TURQUOISE,
      selectedCardBorderColor: COLOR_TURQUOISE,
      indicatorBordercolor: COLOR_TURQUOISE,
      errorMessageColor: COLOR_BORDEAUX
    }
  },
  {
    schemeName: "middlegrey",
    scheme: {
      footTextColor: COLOR_DARKGREY,
      footTextHoverColor: COLOR_WHITE,
      imageBackgroundColor: COLOR_WHITE,
      imageBackgroundSelectedColor: COLOR_TURQUOISE,
      footBackgroundColor: COLOR_ULTRALIGHTGREY,
      footBackgroundHoverColor: COLOR_TURQUOISE_ACTIVE,
      footBackgroundSelectedColor: COLOR_TURQUOISE_DARK,
      hoverCardBorderColor: COLOR_TURQUOISE,
      selectedCardBorderColor: COLOR_TURQUOISE,
      indicatorBordercolor: COLOR_TURQUOISE,
      errorMessageColor: COLOR_BORDEAUX
    }
  }
];
export const BADGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white"
  },
  {
    schemeName: "darkgrey"
  }
];
export const BREADCRUMB_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "darkgrey"
  },
  {
    schemeName: "white",
    scheme: {
      contentHoverColor: COLOR_WHITE_OPACITY_85
    }
  }
];
export const BOTTOM_DRAWER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red"
  },
  {
    schemeName: "turquoise"
  },
  {
    schemeName: "bordeaux"
  },
  {
    schemeName: "limeyellow"
  }
];
export const BULLET_LIST_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      highlight: COLOR_LIMEYELLOW_75
    }
  },
  {
    schemeName: "darkgrey",
    scheme: {
      highlight: COLOR_RED
    }
  },
  {
    schemeName: "darkgreyOnLimeyellow",
    scheme: {
      textColor: COLOR_DARKGREY,
      iconColor: COLOR_DARKGREY,
      highlight: COLOR_BORDEAUX
    }
  },
  {
    schemeName: "whiteOnBordeaux",
    scheme: {
      textColor: COLOR_WHITE,
      iconColor: COLOR_WHITE,
      highlight: COLOR_LIMEYELLOW
    }
  }
];
export const BULLET_LIST_DEPRECATED_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white"
  },
  {
    schemeName: "darkgrey"
  }
];
export const BUSINESSCARD_AUTHOR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      textHoverColor: COLOR_WHITE_OPACITY_85
    }
  },
  {
    schemeName: "red",
    scheme: {
      textHoverColor: COLOR_RED_ACTIVE
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      textHoverColor: COLOR_RED_ACTIVE
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      textHoverColor: COLOR_BORDEAUX_ACTIVE
    }
  },
  {
    schemeName: "darkgrey",
    scheme: {
      textHoverColor: COLOR_DARKGREY_ACTIVE
    }
  }
];
export const BUSINESSCARD_CONTACT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      backgroundColor: COLOR_WHITE,
      textcolor: COLOR_DARKGREY,
      linkColor: COLOR_RED,
      linkHoverColor: COLOR_RED_ACTIVE,
      mapsLink: COLOR_DARKGREY
    }
  },
  {
    schemeName: "red",
    scheme: {
      backgroundColor: COLOR_RED,
      textcolor: COLOR_WHITE,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      mapsLink: COLOR_WHITE
    }
  },
  {
    schemeName: "limeyellow",
    scheme: {
      backgroundColor: COLOR_LIMEYELLOW,
      textcolor: COLOR_DARKGREY,
      linkColor: COLOR_BORDEAUX,
      linkHoverColor: COLOR_BORDEAUX_ACTIVE,
      mapsLink: COLOR_DARKGREY
    }
  },
  {
    schemeName: "limeyellowActive",
    scheme: {
      backgroundColor: COLOR_LIMEYELLOW_ACTIVE,
      textcolor: COLOR_DARKGREY,
      linkColor: COLOR_BORDEAUX,
      linkHoverColor: COLOR_BORDEAUX_ACTIVE,
      mapsLink: COLOR_DARKGREY
    }
  },
  {
    schemeName: "ultralightgrey",
    scheme: {
      backgroundColor: COLOR_ULTRALIGHTGREY,
      textcolor: COLOR_DARKGREY,
      linkColor: COLOR_RED,
      linkHoverColor: COLOR_RED_ACTIVE,
      mapsLink: COLOR_DARKGREY
    }
  },
  {
    schemeName: "lightgrey",
    scheme: {
      backgroundColor: COLOR_LIGHTGREY,
      textcolor: COLOR_DARKGREY,
      linkColor: COLOR_RED,
      linkHoverColor: COLOR_RED_ACTIVE,
      mapsLink: COLOR_DARKGREY
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      backgroundColor: COLOR_BORDEAUX,
      textcolor: COLOR_WHITE,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      mapsLink: COLOR_WHITE
    }
  },
  {
    schemeName: "bordeauxDark",
    scheme: {
      backgroundColor: COLOR_BORDEAUX_DARK,
      textcolor: COLOR_WHITE,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      mapsLink: COLOR_WHITE
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      backgroundColor: COLOR_TURQUOISE,
      textcolor: COLOR_WHITE,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      mapsLink: COLOR_WHITE
    }
  },
  {
    schemeName: "turquoiseDark",
    scheme: {
      backgroundColor: COLOR_TURQUOISE_DARK,
      textcolor: COLOR_WHITE,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      mapsLink: COLOR_WHITE
    }
  }
];
export const BOX_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      activeBackgroundColor: COLOR_WHITE
    }
  },
  {
    schemeName: "red",
    scheme: {
      activeBackgroundColor: COLOR_RED
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      activeBackgroundColor: COLOR_BORDEAUX
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      activeBackgroundColor: COLOR_TURQUOISE
    }
  },
  {
    schemeName: "lightgrey",
    scheme: {
      activeBackgroundColor: COLOR_LIGHTGREY
    }
  },
  {
    schemeName: "limeyellow",
    scheme: {
      activeBackgroundColor: COLOR_LIMEYELLOW
    }
  },
  {
    schemeName: "darkgrey",
    scheme: {
      activeBackgroundColor: COLOR_DARKGREY
    }
  }
];
export const BUTTON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red",
    scheme: {
      primaryBackgroundHoverColor: COLOR_RED_ACTIVE,
      primaryBorderHoverColor: COLOR_RED_ACTIVE,
      secondaryBackgroundHoverColor: COLOR_RED_ACTIVE,
      secondaryBorderHoverColor: COLOR_RED_ACTIVE,
      secondaryBtnOnImageTextAndIconHoverColor: COLOR_RED_ACTIVE,
      secondaryBtnOnImageHoverFocusColor: COLOR_LIGHTGREY
    }
  },
  {
    schemeName: "redOnLightgrey",
    scheme: {
      primaryBackgroundColor: COLOR_RED,
      primaryBackgroundHoverColor: COLOR_RED_ACTIVE,
      primaryBackgroundFocusColor: COLOR_RED,
      primaryTextAndIconColor: COLOR_WHITE,
      primaryTextAndIconHoverColor: COLOR_WHITE,
      primaryBorderColor: COLOR_RED,
      primaryBorderHoverColor: COLOR_RED_ACTIVE,
      secondaryBackgroundColor: COLOR_LIGHTGREY,
      secondaryBackgroundHoverColor: COLOR_RED_ACTIVE,
      secondaryBackgroundFocusColor: COLOR_RED,
      secondaryTextAndIconColor: COLOR_RED,
      secondaryTextAndIconHoverColor: COLOR_WHITE,
      secondaryBorderColor: COLOR_RED,
      secondaryBorderHoverColor: COLOR_RED_ACTIVE,
      secondaryBtnOnImageBackgroundColor: COLOR_WHITE,
      secondaryBtnOnImageTextAndIconColor: COLOR_RED,
      secondaryBtnOnImageTextAndIconHoverColor: COLOR_RED_ACTIVE,
      secondaryBtnOnImageHoverFocusColor: COLOR_LIGHTGREY,
      secondaryBtnOnImageFocusBorderColor: COLOR_WHITE,
      focusBorderColor: COLOR_RED
    }
  },
  {
    schemeName: "redOnUltralightgrey",
    scheme: {
      primaryBackgroundColor: COLOR_RED,
      primaryBackgroundHoverColor: COLOR_RED_ACTIVE,
      primaryBackgroundFocusColor: COLOR_RED,
      primaryTextAndIconColor: COLOR_WHITE,
      primaryTextAndIconHoverColor: COLOR_WHITE,
      primaryBorderColor: COLOR_RED,
      primaryBorderHoverColor: COLOR_RED_ACTIVE,
      secondaryBackgroundColor: COLOR_ULTRALIGHTGREY,
      secondaryBackgroundHoverColor: COLOR_RED_ACTIVE,
      secondaryBackgroundFocusColor: COLOR_RED,
      secondaryTextAndIconColor: COLOR_RED,
      secondaryTextAndIconHoverColor: COLOR_WHITE,
      secondaryBorderColor: COLOR_RED,
      secondaryBorderHoverColor: COLOR_RED_ACTIVE,
      secondaryBtnOnImageBackgroundColor: COLOR_WHITE,
      secondaryBtnOnImageTextAndIconColor: COLOR_RED,
      secondaryBtnOnImageTextAndIconHoverColor: COLOR_RED_ACTIVE,
      secondaryBtnOnImageHoverFocusColor: COLOR_ULTRALIGHTGREY,
      secondaryBtnOnImageFocusBorderColor: COLOR_WHITE,
      focusBorderColor: COLOR_RED
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      primaryBackgroundHoverColor: COLOR_TURQUOISE_ACTIVE,
      primaryBorderHoverColor: COLOR_TURQUOISE_ACTIVE,
      secondaryBackgroundHoverColor: COLOR_TURQUOISE_ACTIVE,
      secondaryBorderHoverColor: COLOR_TURQUOISE_ACTIVE,
      secondaryBtnOnImageTextAndIconHoverColor: COLOR_TURQUOISE_ACTIVE,
      secondaryBtnOnImageHoverFocusColor: COLOR_LIGHTGREY
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      primaryBackgroundHoverColor: COLOR_BORDEAUX_ACTIVE,
      primaryBorderHoverColor: COLOR_BORDEAUX_ACTIVE,
      secondaryBackgroundColor: COLOR_LIMEYELLOW,
      secondaryBackgroundHoverColor: COLOR_BORDEAUX_ACTIVE,
      secondaryBackgroundFocusColor: COLOR_LIMEYELLOW,
      secondaryBorderHoverColor: COLOR_BORDEAUX_ACTIVE,
      secondaryBtnOnImageTextAndIconHoverColor: COLOR_BORDEAUX_ACTIVE
    }
  },
  {
    schemeName: "redInverted",
    scheme: {
      primaryBackgroundColor: COLOR_WHITE,
      primaryBackgroundHoverColor: COLOR_RED_15,
      primaryBackgroundFocusColor: COLOR_WHITE,
      primaryTextAndIconColor: COLOR_RED,
      primaryTextAndIconHoverColor: COLOR_RED_ACTIVE,
      primaryBorderColor: COLOR_RED_15,
      primaryBorderHoverColor: COLOR_RED_15,
      secondaryBackgroundColor: COLOR_RED,
      secondaryBackgroundHoverColor: COLOR_RED_15,
      secondaryBackgroundFocusColor: COLOR_WHITE,
      secondaryTextAndIconColor: COLOR_WHITE,
      secondaryTextAndIconHoverColor: COLOR_RED,
      secondaryBorderColor: COLOR_WHITE,
      secondaryBorderHoverColor: COLOR_RED_15,
      secondaryBtnOnImageBackgroundColor: COLOR_WHITE,
      secondaryBtnOnImageTextAndIconColor: COLOR_RED,
      secondaryBtnOnImageTextAndIconHoverColor: COLOR_RED_ACTIVE,
      secondaryBtnOnImageHoverFocusColor: COLOR_LIGHTGREY,
      secondaryBtnOnImageFocusBorderColor: COLOR_WHITE,
      focusBorderColor: COLOR_WHITE,
      inverted: true
    }
  },
  {
    schemeName: "turquoiseInverted",
    scheme: {
      primaryBackgroundColor: COLOR_WHITE,
      primaryBackgroundHoverColor: COLOR_TURQUOISE_15,
      primaryBackgroundFocusColor: COLOR_WHITE,
      primaryTextAndIconColor: COLOR_TURQUOISE,
      primaryTextAndIconHoverColor: COLOR_TURQUOISE_ACTIVE,
      primaryBorderColor: COLOR_TURQUOISE_15,
      primaryBorderHoverColor: COLOR_TURQUOISE_15,
      secondaryBackgroundColor: COLOR_TURQUOISE,
      secondaryBackgroundHoverColor: COLOR_TURQUOISE_15,
      secondaryBackgroundFocusColor: COLOR_WHITE,
      secondaryTextAndIconColor: COLOR_WHITE,
      secondaryTextAndIconHoverColor: COLOR_TURQUOISE,
      secondaryBorderColor: COLOR_WHITE,
      secondaryBorderHoverColor: COLOR_TURQUOISE_15,
      secondaryBtnOnImageBackgroundColor: COLOR_WHITE,
      secondaryBtnOnImageTextAndIconColor: COLOR_TURQUOISE,
      secondaryBtnOnImageTextAndIconHoverColor: COLOR_TURQUOISE_ACTIVE,
      secondaryBtnOnImageHoverFocusColor: COLOR_LIGHTGREY,
      secondaryBtnOnImageFocusBorderColor: COLOR_WHITE,
      focusBorderColor: COLOR_WHITE,
      inverted: true
    }
  },
  {
    schemeName: "bordeauxInverted",
    scheme: {
      primaryBackgroundColor: COLOR_WHITE,
      primaryBackgroundHoverColor: COLOR_BORDEAUX_15,
      primaryBackgroundFocusColor: COLOR_WHITE,
      primaryTextAndIconColor: COLOR_BORDEAUX,
      primaryTextAndIconHoverColor: COLOR_BORDEAUX_ACTIVE,
      primaryBorderColor: COLOR_BORDEAUX_15,
      primaryBorderHoverColor: COLOR_BORDEAUX_15,
      secondaryBackgroundColor: COLOR_BORDEAUX,
      secondaryBackgroundHoverColor: COLOR_BORDEAUX_15,
      secondaryBackgroundFocusColor: COLOR_WHITE,
      secondaryTextAndIconColor: COLOR_WHITE,
      secondaryTextAndIconHoverColor: COLOR_BORDEAUX,
      secondaryBorderColor: COLOR_WHITE,
      secondaryBorderHoverColor: COLOR_BORDEAUX_15,
      secondaryBtnOnImageBackgroundColor: COLOR_WHITE,
      secondaryBtnOnImageTextAndIconColor: COLOR_RED,
      secondaryBtnOnImageTextAndIconHoverColor: COLOR_BORDEAUX_ACTIVE,
      secondaryBtnOnImageHoverFocusColor: COLOR_LIGHTGREY,
      secondaryBtnOnImageFocusBorderColor: COLOR_WHITE,
      focusBorderColor: COLOR_WHITE,
      inverted: true
    }
  },
  {
    schemeName: "discreet",
    scheme: {
      primaryBackgroundColor: COLOR_WHITE,
      primaryBackgroundHoverColor: COLOR_LIGHTGREY,
      primaryBackgroundFocusColor: COLOR_WHITE,
      primaryTextAndIconColor: COLOR_MIDDLEGREY,
      primaryTextAndIconHoverColor: COLOR_MIDDLEGREY_ACTIVE,
      primaryBorderColor: COLOR_WHITE,
      primaryBorderHoverColor: COLOR_LIGHTGREY,
      secondaryBackgroundColor: COLOR_WHITE,
      secondaryBackgroundHoverColor: COLOR_LIGHTGREY,
      secondaryBackgroundFocusColor: COLOR_WHITE,
      secondaryTextAndIconColor: COLOR_MIDDLEGREY,
      secondaryTextAndIconHoverColor: COLOR_MIDDLEGREY_ACTIVE,
      secondaryBorderColor: COLOR_WHITE,
      secondaryBorderHoverColor: COLOR_LIGHTGREY,
      secondaryBtnOnImageBackgroundColor: COLOR_WHITE,
      secondaryBtnOnImageTextAndIconColor: COLOR_MIDDLEGREY,
      secondaryBtnOnImageTextAndIconHoverColor: COLOR_MIDDLEGREY_ACTIVE,
      secondaryBtnOnImageHoverFocusColor: COLOR_LIGHTGREY,
      secondaryBtnOnImageFocusBorderColor: COLOR_LIGHTGREY,
      focusBorderColor: COLOR_MIDDLEGREY
    }
  },
  {
    schemeName: "discreetDark",
    scheme: {
      primaryBackgroundColor: COLOR_WHITE,
      primaryBackgroundHoverColor: COLOR_DARKGREY,
      primaryBackgroundFocusColor: COLOR_DARKGREY,
      primaryTextAndIconColor: COLOR_DARKGREY,
      primaryTextAndIconHoverColor: COLOR_WHITE,
      primaryBorderColor: COLOR_WHITE,
      primaryBorderHoverColor: COLOR_DARKGREY,
      secondaryBackgroundColor: COLOR_WHITE,
      secondaryBackgroundHoverColor: COLOR_DARKGREY,
      secondaryBackgroundFocusColor: COLOR_DARKGREY,
      secondaryTextAndIconColor: COLOR_DARKGREY,
      secondaryTextAndIconHoverColor: COLOR_WHITE,
      secondaryBorderColor: COLOR_WHITE,
      secondaryBorderHoverColor: COLOR_DARKGREY,
      secondaryBtnOnImageBackgroundColor: COLOR_WHITE,
      secondaryBtnOnImageTextAndIconColor: COLOR_DARKGREY,
      secondaryBtnOnImageTextAndIconHoverColor: COLOR_WHITE,
      secondaryBtnOnImageHoverFocusColor: COLOR_DARKGREY,
      secondaryBtnOnImageFocusBorderColor: COLOR_WHITE,
      focusBorderColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "darkgreyCarrier",
    scheme: {
      primaryBackgroundColor: COLOR_DARKGREY_OPACITY_80,
      primaryBackgroundHoverColor: COLOR_RED,
      primaryBackgroundFocusColor: COLOR_RED,
      primaryTextAndIconColor: COLOR_WHITE,
      primaryTextAndIconHoverColor: COLOR_WHITE,
      primaryBorderColor: COLOR_DARKGREY_OPACITY_80,
      primaryBorderHoverColor: COLOR_RED,
      secondaryBackgroundColor: COLOR_DARKGREY_OPACITY_80,
      secondaryBackgroundHoverColor: COLOR_RED,
      secondaryBackgroundFocusColor: COLOR_RED,
      secondaryTextAndIconColor: COLOR_WHITE,
      secondaryTextAndIconHoverColor: COLOR_WHITE,
      secondaryBorderColor: COLOR_DARKGREY_OPACITY_80,
      secondaryBorderHoverColor: COLOR_RED,
      secondaryBtnOnImageBackgroundColor: COLOR_DARKGREY_OPACITY_80,
      secondaryBtnOnImageTextAndIconColor: COLOR_WHITE,
      secondaryBtnOnImageTextAndIconHoverColor: COLOR_WHITE,
      secondaryBtnOnImageHoverFocusColor: COLOR_LIGHTGREY,
      secondaryBtnOnImageFocusBorderColor: COLOR_WHITE,
      focusBorderColor: COLOR_RED,
      carrierbutton: true
    }
  }
];
export const CAPTION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      contentColor: COLOR_DARKGREY,
      backgroundColor: COLOR_ULTRALIGHTGREY,
      leftBorderColor: COLOR_DARK_TABBAR_COLOR
    }
  },
  {
    schemeName: "redActive",
    scheme: {
      contentColor: COLOR_WHITE,
      backgroundColor: COLOR_RED_ACTIVE,
      leftBorderColor: COLOR_WHITE_TABBAR_COLOR
    }
  },
  {
    schemeName: "turquoiseActive",
    scheme: {
      contentColor: COLOR_WHITE,
      backgroundColor: COLOR_TURQUOISE_ACTIVE,
      leftBorderColor: COLOR_WHITE_TABBAR_COLOR
    }
  },
  {
    schemeName: "bordeauxActive",
    scheme: {
      contentColor: COLOR_WHITE,
      backgroundColor: COLOR_BORDEAUX_ACTIVE,
      leftBorderColor: COLOR_WHITE_TABBAR_COLOR
    }
  },
  {
    schemeName: "limeyellowActive",
    scheme: {
      contentColor: COLOR_DARKGREY,
      backgroundColor: COLOR_LIMEYELLOW_ACTIVE,
      leftBorderColor: COLOR_DARK_TABBAR_COLOR
    }
  },
  {
    schemeName: "ultralightgreyActive",
    scheme: {
      contentColor: COLOR_DARKGREY,
      backgroundColor: COLOR_WHITE,
      leftBorderColor: COLOR_DARK_TABBAR_COLOR
    }
  }
];
export const CARD_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      linkColor: COLOR_RED,
      linkHoverColor: COLOR_RED_ACTIVE,
      headlineColor: COLOR_DARKGREY,
      alternativeHeadlineColor1: COLOR_TURQUOISE,
      alternativeHeadlineColor2: COLOR_RED,
      headlineColorOffset: COLOR_RED,
      categoryColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "whiteOnLightgrey",
    scheme: {
      contentColor: COLOR_DARKGREY,
      backgroundColor: COLOR_WHITE,
      linkColor: COLOR_RED,
      linkHoverColor: COLOR_RED_ACTIVE,
      headlineColor: COLOR_DARKGREY,
      alternativeHeadlineColor1: COLOR_TURQUOISE,
      alternativeHeadlineColor2: COLOR_RED,
      headlineColorOffset: COLOR_RED,
      categoryColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "whiteOnLimeyellow",
    scheme: {
      contentColor: COLOR_DARKGREY,
      backgroundColor: COLOR_WHITE,
      linkColor: COLOR_BORDEAUX,
      linkHoverColor: COLOR_BORDEAUX_ACTIVE,
      headlineColor: COLOR_BORDEAUX,
      alternativeHeadlineColor1: COLOR_TURQUOISE,
      alternativeHeadlineColor2: COLOR_RED,
      headlineColorOffset: COLOR_BORDEAUX,
      categoryColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "ultralightgrey",
    scheme: {
      contentColor: COLOR_DARKGREY,
      backgroundColor: COLOR_ULTRALIGHTGREY,
      linkColor: COLOR_RED,
      linkHoverColor: COLOR_RED_ACTIVE,
      headlineColor: COLOR_DARKGREY,
      alternativeHeadlineColor1: COLOR_TURQUOISE,
      alternativeHeadlineColor2: COLOR_RED,
      headlineColorOffset: COLOR_RED,
      categoryColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "lightgrey",
    scheme: {
      contentColor: COLOR_DARKGREY,
      backgroundColor: COLOR_LIGHTGREY,
      linkColor: COLOR_RED,
      linkHoverColor: COLOR_RED_ACTIVE,
      headlineColor: COLOR_DARKGREY,
      alternativeHeadlineColor1: COLOR_TURQUOISE,
      alternativeHeadlineColor2: COLOR_RED,
      headlineColorOffset: COLOR_RED,
      categoryColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "red",
    scheme: {
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      headlineColor: COLOR_WHITE,
      alternativeHeadlineColor1: COLOR_WHITE,
      alternativeHeadlineColor2: COLOR_WHITE,
      headlineColorOffset: COLOR_RED,
      categoryColor: COLOR_WHITE
    }
  },
  {
    schemeName: "limeyellow",
    scheme: {
      linkColor: COLOR_BORDEAUX,
      linkHoverColor: COLOR_BORDEAUX_ACTIVE,
      headlineColor: COLOR_BORDEAUX,
      alternativeHeadlineColor1: COLOR_TURQUOISE,
      alternativeHeadlineColor2: COLOR_DARKGREY,
      headlineColorOffset: COLOR_BORDEAUX,
      categoryColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      headlineColor: COLOR_WHITE,
      alternativeHeadlineColor1: COLOR_WHITE,
      alternativeHeadlineColor2: COLOR_WHITE,
      headlineColorOffset: COLOR_WHITE,
      categoryColor: COLOR_WHITE
    }
  },
  {
    schemeName: "bordeauxDark",
    scheme: {
      contentColor: COLOR_WHITE,
      backgroundColor: COLOR_BORDEAUX_DARK,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      headlineColor: COLOR_WHITE,
      alternativeHeadlineColor1: COLOR_WHITE,
      alternativeHeadlineColor2: COLOR_WHITE,
      headlineColorOffset: COLOR_WHITE,
      categoryColor: COLOR_WHITE
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      headlineColor: COLOR_WHITE,
      alternativeHeadlineColor1: COLOR_WHITE,
      alternativeHeadlineColor2: COLOR_WHITE,
      headlineColorOffset: COLOR_TURQUOISE,
      categoryColor: COLOR_WHITE
    }
  },
  {
    schemeName: "turquoiseDark",
    scheme: {
      contentColor: COLOR_WHITE,
      backgroundColor: COLOR_TURQUOISE_DARK,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      headlineColor: COLOR_WHITE,
      alternativeHeadlineColor1: COLOR_WHITE,
      alternativeHeadlineColor2: COLOR_WHITE,
      headlineColorOffset: COLOR_WHITE,
      categoryColor: COLOR_WHITE
    }
  }
];
export const CAROUSEL_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "turquoise",
    scheme: {
      indicatorColor: COLOR_DARKGREY_25,
      indicatorHoverColor: COLOR_MIDDLEGREY,
      controlHoverColor: COLOR_TURQUOISE_ACTIVE,
      outsideControlHoverColor: COLOR_TURQUOISE_ACTIVE
    }
  },
  {
    schemeName: "turquoiseInverted",
    scheme: {
      indicatorColor: COLOR_WHITE_OPACITY_30,
      indicatorHoverColor: COLOR_TURQUOISE_50,
      indicatorActColor: COLOR_WHITE,
      controlHoverColor: COLOR_TURQUOISE_ACTIVE,
      controlHoverIconColor: COLOR_TURQUOISE_FONT,
      outsideControlColor: COLOR_WHITE,
      outsideControlIconColor: COLOR_DARKGREY,
      outsideControlHoverColor: COLOR_WHITE,
      outsideControlHoverIconColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "red",
    scheme: {
      indicatorColor: COLOR_DARKGREY_25,
      indicatorHoverColor: COLOR_MIDDLEGREY,
      controlHoverColor: COLOR_RED_ACTIVE,
      outsideControlHoverColor: COLOR_RED_ACTIVE
    }
  },
  {
    schemeName: "redInverted",
    scheme: {
      indicatorColor: COLOR_WHITE_OPACITY_30,
      indicatorHoverColor: COLOR_RED_50,
      indicatorActColor: COLOR_WHITE,
      controlHoverColor: COLOR_RED_ACTIVE,
      controlHoverIconColor: COLOR_RED_FONT,
      outsideControlColor: COLOR_WHITE,
      outsideControlIconColor: COLOR_DARKGREY,
      outsideControlHoverColor: COLOR_WHITE,
      outsideControlHoverIconColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      indicatorColor: COLOR_DARKGREY_OPACITY_30,
      indicatorHoverColor: COLOR_BORDEAUX_ACTIVE,
      controlHoverColor: COLOR_BORDEAUX_ACTIVE,
      outsideControlHoverColor: COLOR_BORDEAUX_ACTIVE
    }
  },
  {
    schemeName: "bordeauxInverted",
    scheme: {
      indicatorColor: COLOR_WHITE_OPACITY_30,
      indicatorHoverColor: COLOR_BORDEAUX_50,
      indicatorActColor: COLOR_WHITE,
      controlHoverColor: COLOR_BORDEAUX_ACTIVE,
      controlHoverIconColor: COLOR_BORDEAUX_FONT,
      outsideControlColor: COLOR_WHITE,
      outsideControlIconColor: COLOR_DARKGREY,
      outsideControlHoverColor: COLOR_WHITE,
      outsideControlHoverIconColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "darkgrey",
    scheme: {
      indicatorColor: COLOR_DARKGREY_OPACITY_30,
      indicatorHoverColor: COLOR_DARKGREY_ACTIVE,
      controlHoverColor: COLOR_DARKGREY_ACTIVE,
      outsideControlHoverColor: COLOR_DARKGREY_ACTIVE
    }
  }
];
export const CHECKBOX_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "turquoise",
    scheme: {
      labelColor: COLOR_DARKGREY,
      uncheckedColor: COLOR_MIDDLEGREY,
      checkedHoverColor: COLOR_TURQUOISE_ACTIVE,
      errorColor: COLOR_BORDEAUX,
      disabledUncheckedColor: COLOR_MIDDLEGREY_OPACITY_60,
      disabledCheckedColor: COLOR_TURQUOISE_OPACITY_60,
      disabledLabelColor: COLOR_DARKGREY_OPACITY_60,
      boxColorUnchecked: COLOR_MIDDLEGREY,
      boxColorCheckedHover: COLOR_TURQUOISE_ACTIVE
    }
  },
  {
    schemeName: "red",
    scheme: {
      labelColor: COLOR_DARKGREY,
      uncheckedColor: COLOR_MIDDLEGREY,
      checkedHoverColor: COLOR_RED_ACTIVE,
      errorColor: COLOR_BORDEAUX,
      disabledUncheckedColor: COLOR_MIDDLEGREY_OPACITY_60,
      disabledCheckedColor: COLOR_RED_OPACITY_60,
      disabledLabelColor: COLOR_DARKGREY_OPACITY_60,
      boxColorUnchecked: COLOR_MIDDLEGREY,
      boxColorCheckedHover: COLOR_RED_ACTIVE
    }
  },
  {
    schemeName: "inverted",
    scheme: {
      labelColor: COLOR_WHITE,
      uncheckedColor: COLOR_WHITE,
      uncheckedHoverColor: COLOR_WHITE_OPACITY_75,
      focusColor: COLOR_WHITE_OPACITY_75,
      iconColor: COLOR_BORDEAUX,
      checkedColor: COLOR_WHITE,
      checkedHoverColor: COLOR_WHITE_OPACITY_75,
      errorColor: COLOR_WHITE,
      disabledUncheckedColor: COLOR_WHITE_OPACITY_60,
      disabledCheckedColor: COLOR_WHITE_OPACITY_60,
      disabledLabelColor: COLOR_WHITE_OPACITY_60,
      boxColorUnchecked: COLOR_WHITE,
      boxColorUncheckedHover: COLOR_WHITE_OPACITY_75,
      boxColorChecked: COLOR_WHITE,
      boxColorCheckedHover: COLOR_WHITE_OPACITY_75
    }
  },
  {
    schemeName: "darkgrey",
    scheme: {
      labelColor: COLOR_DARKGREY,
      uncheckedColor: COLOR_DARKGREY,
      uncheckedHoverColor: COLOR_DARKGREY_OPACITY_80,
      focusColor: COLOR_DARKGREY_OPACITY_80,
      iconColor: COLOR_LIMEYELLOW,
      checkedHoverColor: COLOR_DARKGREY_OPACITY_80,
      errorColor: COLOR_BORDEAUX,
      disabledUncheckedColor: COLOR_DARKGREY_OPACITY_60,
      disabledCheckedColor: COLOR_DARKGREY_OPACITY_60,
      disabledLabelColor: COLOR_DARKGREY_OPACITY_60,
      boxColorUnchecked: COLOR_DARKGREY,
      boxColorUncheckedHover: COLOR_DARKGREY_OPACITY_80,
      boxColorCheckedHover: COLOR_DARKGREY_OPACITY_80
    }
  }
];
export const CLICKABLE_IMAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "turquoise"
  },
  {
    schemeName: "red"
  },
  {
    schemeName: "bordeaux"
  },
  {
    schemeName: "white",
    scheme: {
      buttonScheme: "discreetDark",
      tooltipScheme: "white"
    }
  }
];
export const COMPASS_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "ultralightgrey",
    scheme: {
      directionBackgroundColor: COLOR_ULTRALIGHTGREY,
      directionBackgroundSelectedColor: COLOR_TURQUOISE,
      directionBackgroundSelectedHoverColor: COLOR_TURQUOISE_ACTIVE,
      iconColor: COLOR_DARKGREY,
      iconHoverColor: COLOR_TURQUOISE,
      iconSelectedColor: COLOR_WHITE,
      errorMessageColor: COLOR_BORDEAUX,
      tooltipScheme: "darkgrey"
    }
  },
  {
    schemeName: "white",
    scheme: {
      directionBackgroundColor: COLOR_WHITE,
      directionBackgroundSelectedColor: COLOR_TURQUOISE,
      directionBackgroundSelectedHoverColor: COLOR_TURQUOISE_ACTIVE,
      iconColor: COLOR_DARKGREY,
      iconHoverColor: COLOR_TURQUOISE,
      iconSelectedColor: COLOR_WHITE,
      errorMessageColor: COLOR_BORDEAUX,
      tooltipScheme: "darkgrey"
    }
  }
];
export const CONTACT_BAR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white"
  },
  {
    schemeName: "darkgrey"
  }
];
export const CONTACT_LAYER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red"
  },
  {
    schemeName: "turquoise"
  },
  {
    schemeName: "limeyellow"
  },
  {
    schemeName: "bordeaux"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "ultralightgrey"
  },
  {
    schemeName: "lightgrey"
  },
  {
    schemeName: "turquoiseDark",
    scheme: {
      backgroundColor: COLOR_TURQUOISE_DARK,
      color: COLOR_WHITE
    }
  },
  {
    schemeName: "bordeauxDark",
    scheme: {
      backgroundColor: COLOR_BORDEAUX_DARK,
      color: COLOR_WHITE
    }
  }
];
export const CONTACT_LIST_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      linkHoverColor: COLOR_WHITE_OPACITY_85
    }
  },
  {
    schemeName: "darkgrey",
    scheme: {
      linkHoverColor: COLOR_DARKGREY_ACTIVE
    }
  }
];
export const CONTENT_AGGREGATOR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red"
  },
  {
    schemeName: "redInverted"
  },
  {
    schemeName: "bordeaux"
  },
  {
    schemeName: "bordeauxInverted"
  },
  {
    schemeName: "turquoise"
  },
  {
    schemeName: "turquoiseInverted"
  },
  {
    schemeName: "darkgrey"
  }
];
export const CONTENT_AGGREGATOR_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      dateColorOnImage: COLOR_WHITE,
      backgroundColorShade: COLOR_ULTRALIGHTGREY,
      leftBorderColor: COLOR_DARKGREY_OPACITY_50,
      linkColor: COLOR_RED,
      linkHoverColor: COLOR_RED_ACTIVE,
      hoverColor: COLOR_TURQUOISE,
      listButtonScheme: "discreet"
    }
  },
  {
    schemeName: "whiteOnTurquoise",
    scheme: {
      contentColor: COLOR_DARKGREY,
      dateColorOnImage: COLOR_WHITE,
      backgroundColor: COLOR_WHITE,
      backgroundColorShade: COLOR_ULTRALIGHTGREY,
      leftBorderColor: COLOR_DARKGREY_OPACITY_50,
      linkColor: COLOR_RED,
      linkHoverColor: COLOR_RED_ACTIVE,
      contentBackground: COLOR_WHITE,
      hoverColor: COLOR_DARKGREY,
      listButtonScheme: "discreet"
    }
  },
  {
    schemeName: "whiteOnRed",
    scheme: {
      contentColor: COLOR_DARKGREY,
      dateColorOnImage: COLOR_WHITE,
      backgroundColor: COLOR_WHITE,
      backgroundColorShade: COLOR_ULTRALIGHTGREY,
      leftBorderColor: COLOR_DARKGREY_OPACITY_50,
      linkColor: COLOR_RED,
      linkHoverColor: COLOR_RED_ACTIVE,
      contentBackground: COLOR_WHITE,
      hoverColor: COLOR_DARKGREY,
      listButtonScheme: "discreet"
    }
  },
  {
    schemeName: "whiteOnBordeaux",
    scheme: {
      contentColor: COLOR_DARKGREY,
      dateColorOnImage: COLOR_WHITE,
      backgroundColor: COLOR_WHITE,
      backgroundColorShade: COLOR_ULTRALIGHTGREY,
      leftBorderColor: COLOR_DARKGREY_OPACITY_50,
      linkColor: COLOR_RED,
      linkHoverColor: COLOR_RED_ACTIVE,
      contentBackground: COLOR_WHITE,
      hoverColor: COLOR_DARKGREY,
      listButtonScheme: "discreet"
    }
  },
  {
    schemeName: "whiteOnLimeyellow",
    scheme: {
      contentColor: COLOR_DARKGREY,
      dateColorOnImage: COLOR_WHITE,
      backgroundColor: COLOR_WHITE,
      backgroundColorShade: COLOR_ULTRALIGHTGREY,
      leftBorderColor: COLOR_DARKGREY_OPACITY_50,
      linkColor: COLOR_BORDEAUX,
      linkHoverColor: COLOR_BORDEAUX_ACTIVE,
      contentBackground: COLOR_WHITE,
      hoverColor: COLOR_TURQUOISE,
      listButtonScheme: "discreet"
    }
  },
  {
    schemeName: "ultralightgrey",
    scheme: {
      dateColorOnImage: COLOR_WHITE,
      backgroundColorShade: COLOR_WHITE,
      leftBorderColor: COLOR_DARKGREY_OPACITY_50,
      linkColor: COLOR_RED,
      linkHoverColor: COLOR_RED_ACTIVE,
      hoverColor: COLOR_TURQUOISE,
      listButtonScheme: "discreet"
    }
  },
  {
    schemeName: "lightgrey",
    scheme: {
      dateColorOnImage: COLOR_WHITE,
      backgroundColorShade: COLOR_ULTRALIGHTGREY,
      leftBorderColor: COLOR_DARKGREY_OPACITY_50,
      linkColor: COLOR_RED,
      linkHoverColor: COLOR_RED_ACTIVE,
      contentBackground: COLOR_ULTRALIGHTGREY,
      hoverColor: COLOR_TURQUOISE,
      listButtonScheme: "discreet"
    }
  },
  {
    schemeName: "red",
    scheme: {
      dateColorOnImage: COLOR_WHITE,
      backgroundColorShade: COLOR_RED_ACTIVE,
      leftBorderColor: COLOR_WHITE,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      contentBackground: COLOR_WHITE,
      hoverColor: COLOR_TURQUOISE,
      listButtonScheme: "discreet"
    }
  },
  {
    schemeName: "limeyellow",
    scheme: {
      dateColorOnImage: COLOR_WHITE,
      backgroundColorShade: COLOR_LIMEYELLOW_ACTIVE,
      leftBorderColor: COLOR_DARKGREY_OPACITY_50,
      linkColor: COLOR_BORDEAUX,
      linkHoverColor: COLOR_BORDEAUX_ACTIVE,
      contentBackground: COLOR_WHITE,
      hoverColor: COLOR_TURQUOISE,
      listButtonScheme: "discreet"
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      dateColorOnImage: COLOR_WHITE,
      backgroundColorShade: COLOR_BORDEAUX_ACTIVE,
      leftBorderColor: COLOR_WHITE,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      contentBackground: COLOR_WHITE,
      hoverColor: COLOR_LIMEYELLOW,
      listButtonScheme: "discreet"
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      dateColorOnImage: COLOR_WHITE,
      backgroundColorShade: COLOR_TURQUOISE_ACTIVE,
      leftBorderColor: COLOR_WHITE,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      contentBackground: COLOR_WHITE,
      hoverColor: COLOR_LIMEYELLOW,
      listButtonScheme: "discreet"
    }
  }
];
export const CONTEXT_MENU_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      backgroundColor: COLOR_WHITE,
      menuTitleBackgroundColor: COLOR_WHITE
    }
  }
];
export const CONTEXT_MENU_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      itemBackgroundColor: COLOR_WHITE,
      itemIconActiveColor: COLOR_TURQUOISE_DARK
    }
  }
];
export const DATE_EVENT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      dateColor: COLOR_WHITE,
      dateLeftBorder: COLOR_LIGHTGREY
    }
  },
  {
    schemeName: "darkgrey",
    scheme: {
      dateColor: COLOR_DARKGREY,
      dateLeftBorder: COLOR_DARKGREY_OPACITY_50
    }
  }
];
export const DIVIDER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red"
  },
  {
    schemeName: "turquoise"
  },
  {
    schemeName: "limeyellow"
  },
  {
    schemeName: "bordeaux"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "ultralightgrey"
  },
  {
    schemeName: "lightgrey"
  },
  {
    schemeName: "darkgrey"
  }
];
export const DROPDOWN_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "turquoise",
    scheme: {
      borderColor: COLOR_MIDDLEGREY,
      borderHoverColor: COLOR_MIDDLEGREY_ACTIVE,
      labelColor: COLOR_DARKGREY,
      errorMessageColor: COLOR_BORDEAUX,
      trailingIconBackgroundColor: COLOR_ULTRALIGHTGREY,
      trailingIconColor: COLOR_MIDDLEGREY,
      trailingIconColorHover: COLOR_MIDDLEGREY_ACTIVE,
      trailingIconColorActive: COLOR_MIDDLEGREY_ACTIVE,
      disabledBackgroundColor: COLOR_LIGHTGREY,
      disabledBorderColor: COLOR_MIDDLEGREY,
      disabledTrailingIconColor: COLOR_DARKGREY_OPACITY_60,
      disabledLabelColor: COLOR_DARKGREY_OPACITY_40,
      disabledOpacity: 0.4,
      multiselectDeleteBackgroundColor: COLOR_TURQUOISE_DARK,
      multiselectDeleteFontColor: COLOR_WHITE,
      multiselectDeleteIconColor: COLOR_WHITE,
      multiselectDeleteIconHoverColor: COLOR_TURQUOISE_DARK
    }
  },
  {
    schemeName: "turquoiseOnUltralightgrey",
    scheme: {
      borderColor: COLOR_MIDDLEGREY,
      borderHoverColor: COLOR_MIDDLEGREY_ACTIVE,
      borderActiveColor: COLOR_TURQUOISE,
      labelColor: COLOR_DARKGREY,
      errorMessageColor: COLOR_BORDEAUX,
      trailingIconBackgroundColor: COLOR_LIGHTGREY,
      trailingIconColor: COLOR_MIDDLEGREY,
      trailingIconColorHover: COLOR_MIDDLEGREY_ACTIVE,
      trailingIconColorActive: COLOR_MIDDLEGREY_ACTIVE,
      disabledBackgroundColor: COLOR_LIGHTGREY_ACTIVE,
      disabledBorderColor: COLOR_MIDDLEGREY_ACTIVE,
      disabledTrailingIconColor: COLOR_DARKGREY_75,
      disabledLabelColor: COLOR_DARKGREY_OPACITY_40,
      disabledOpacity: 0.4,
      multiselectDeleteBackgroundColor: COLOR_TURQUOISE_DARK,
      multiselectDeleteFontColor: COLOR_WHITE,
      multiselectDeleteIconColor: COLOR_WHITE,
      multiselectDeleteIconHoverColor: COLOR_TURQUOISE_DARK
    }
  },
  {
    schemeName: "turquoiseOnLightgrey",
    scheme: {
      borderColor: COLOR_MIDDLEGREY,
      borderHoverColor: COLOR_MIDDLEGREY_ACTIVE,
      borderActiveColor: COLOR_TURQUOISE,
      labelColor: COLOR_DARKGREY,
      errorMessageColor: COLOR_BORDEAUX,
      trailingIconBackgroundColor: COLOR_DARKGREY_OPACITY_10,
      trailingIconColor: COLOR_MIDDLEGREY,
      trailingIconColorHover: COLOR_MIDDLEGREY_ACTIVE,
      trailingIconColorActive: COLOR_MIDDLEGREY_ACTIVE,
      disabledBackgroundColor: COLOR_DARKGREY_25,
      disabledBorderColor: COLOR_MIDDLEGREY_ACTIVE,
      disabledTrailingIconColor: COLOR_DARKGREY,
      disabledLabelColor: COLOR_DARKGREY_OPACITY_40,
      disabledOpacity: 0.4,
      multiselectDeleteBackgroundColor: COLOR_TURQUOISE_DARK,
      multiselectDeleteFontColor: COLOR_WHITE,
      multiselectDeleteIconColor: COLOR_WHITE,
      multiselectDeleteIconHoverColor: COLOR_TURQUOISE_DARK
    }
  },
  {
    schemeName: "whiteOnRed",
    scheme: {
      borderColor: COLOR_WHITE_OPACITY_80,
      borderHoverColor: COLOR_WHITE,
      borderActiveColor: COLOR_WHITE,
      labelColor: COLOR_WHITE,
      errorMessageColor: COLOR_WHITE,
      trailingIconBackgroundColor: COLOR_RED_ACTIVE,
      trailingIconColor: COLOR_WHITE_OPACITY_60,
      trailingIconColorHover: COLOR_WHITE_OPACITY_85,
      trailingIconColorActive: COLOR_WHITE,
      disabledBackgroundColor: COLOR_TRANSPARENT,
      disabledBorderColor: COLOR_WHITE,
      disabledTrailingIconColor: COLOR_WHITE,
      disabledLabelColor: COLOR_WHITE_OPACITY_60,
      disabledOpacity: 0.6,
      multiselectDeleteBackgroundColor: COLOR_RED_ACTIVE,
      multiselectDeleteFontColor: COLOR_WHITE,
      multiselectDeleteIconColor: COLOR_WHITE,
      multiselectDeleteIconHoverColor: COLOR_RED_ACTIVE
    }
  },
  {
    schemeName: "whiteOnTurquoise",
    scheme: {
      borderColor: COLOR_WHITE_OPACITY_80,
      borderHoverColor: COLOR_WHITE,
      borderActiveColor: COLOR_WHITE,
      labelColor: COLOR_WHITE,
      errorMessageColor: COLOR_WHITE,
      trailingIconBackgroundColor: COLOR_TURQUOISE_ACTIVE,
      trailingIconColor: COLOR_WHITE_OPACITY_60,
      trailingIconColorHover: COLOR_WHITE_OPACITY_85,
      trailingIconColorActive: COLOR_WHITE,
      disabledBackgroundColor: COLOR_TRANSPARENT,
      disabledBorderColor: COLOR_WHITE,
      disabledTrailingIconColor: COLOR_WHITE,
      disabledLabelColor: COLOR_WHITE_OPACITY_60,
      disabledOpacity: 0.6,
      multiselectDeleteBackgroundColor: COLOR_TURQUOISE_DARK,
      multiselectDeleteFontColor: COLOR_WHITE,
      multiselectDeleteIconColor: COLOR_WHITE,
      multiselectDeleteIconHoverColor: COLOR_TURQUOISE_DARK
    }
  },
  {
    schemeName: "whiteOnBordeaux",
    scheme: {
      borderColor: COLOR_WHITE_OPACITY_80,
      borderHoverColor: COLOR_WHITE,
      borderActiveColor: COLOR_WHITE,
      labelColor: COLOR_WHITE,
      errorMessageColor: COLOR_WHITE,
      trailingIconBackgroundColor: COLOR_BORDEAUX_ACTIVE,
      trailingIconColor: COLOR_WHITE_OPACITY_60,
      trailingIconColorHover: COLOR_WHITE_OPACITY_85,
      trailingIconColorActive: COLOR_WHITE,
      disabledBackgroundColor: COLOR_TRANSPARENT,
      disabledBorderColor: COLOR_WHITE,
      disabledTrailingIconColor: COLOR_WHITE,
      disabledLabelColor: COLOR_WHITE_OPACITY_60,
      disabledOpacity: 0.6,
      multiselectDeleteBackgroundColor: COLOR_BORDEAUX_ACTIVE,
      multiselectDeleteFontColor: COLOR_WHITE,
      multiselectDeleteIconColor: COLOR_WHITE,
      multiselectDeleteIconHoverColor: COLOR_BORDEAUX_ACTIVE
    }
  },
  {
    schemeName: "darkgreyOnLimeyellow",
    scheme: {
      borderColor: COLOR_DARKGREY_OPACITY_80,
      borderHoverColor: COLOR_DARKGREY,
      borderActiveColor: COLOR_DARKGREY,
      labelColor: COLOR_DARKGREY,
      errorMessageColor: COLOR_BORDEAUX,
      trailingIconBackgroundColor: COLOR_LIMEYELLOW_ACTIVE,
      trailingIconColor: COLOR_DARKGREY_OPACITY_80,
      trailingIconColorHover: COLOR_DARKGREY,
      trailingIconColorActive: COLOR_DARKGREY,
      disabledBackgroundColor: COLOR_TRANSPARENT,
      disabledBorderColor: COLOR_DARKGREY,
      disabledTrailingIconColor: COLOR_DARKGREY,
      disabledLabelColor: COLOR_DARKGREY_OPACITY_40,
      disabledOpacity: 0.4,
      multiselectDeleteBackgroundColor: COLOR_DARKGREY,
      multiselectDeleteFontColor: COLOR_WHITE,
      multiselectDeleteIconColor: COLOR_WHITE,
      multiselectDeleteIconHoverColor: COLOR_DARKGREY
    }
  }
];
export const DROPDOWN_OPTION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "turquoise",
    scheme: {
      borderBottomColor: COLOR_LIGHTGREY,
      backgroundColorHover: COLOR_ULTRALIGHTGREY
    }
  }
];
export const ERROR_MESSAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "turquoiseDark",
    scheme: {
      backgroundColor: COLOR_TURQUOISE_DARK
    }
  },
  {
    schemeName: "bordeaux"
  },
  {
    schemeName: "limeyellow"
  }
];
export const FILE_UPLOAD_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "whiteOnRed",
    scheme: {
      dropzoneBorderSingle: COLOR_WHITE,
      dropzoneBorderMultiple: COLOR_WHITE_OPACITY_20,
      dropzoneBackground: COLOR_WHITE_OPACITY_10,
      dropzoneHoverBackground: COLOR_TURQUOISE_25,
      dropzoneHoverBorder: COLOR_WHITE,
      dropzoneOnDragHoverBackground: COLOR_TURQUOISE,
      dropzoneOnDragHoverBorder: COLOR_WHITE,
      errorMessageColor: COLOR_WHITE,
      buttonScheme: String(/redInverted/),
      uploadCompleteBackground: COLOR_ULTRALIGHTGREY,
      dragOverBorder: COLOR_TURQUOISE,
      dropzoneIconColor: COLOR_WHITE,
      dropzoneIconHoverColor: COLOR_DARKGREY,
      dropzoneContentColor: COLOR_WHITE,
      dropzoneContentHoverColor: COLOR_DARKGREY,
      dropzoneLinkColor: COLOR_WHITE,
      dropzoneLinkHoverColor: COLOR_DARKGREY,
      uploadedStatusColor: COLOR_WHITE,
      uploadCompleteContentColor: COLOR_TURQUOISE
    }
  },
  {
    schemeName: "lightgreyOnWhite",
    scheme: {
      dropzoneBorderSingle: COLOR_BLACK_OPACITY_10,
      dropzoneBorderMultiple: COLOR_DARKGREY_OPACITY_20,
      dropzoneBackground: COLOR_ULTRALIGHTGREY,
      dropzoneHoverBackground: COLOR_LIGHTGREY,
      dropzoneHoverBorder: COLOR_TURQUOISE_ACTIVE,
      dropzoneOnDragHoverBackground: COLOR_TURQUOISE_25,
      dropzoneOnDragHoverBorder: COLOR_TURQUOISE,
      errorMessageColor: COLOR_BORDEAUX,
      buttonScheme: String(/red/),
      uploadCompleteBackground: COLOR_ULTRALIGHTGREY,
      dragOverBorder: COLOR_TURQUOISE,
      dropzoneIconColor: COLOR_DARKGREY,
      dropzoneIconHoverColor: COLOR_DARKGREY,
      dropzoneContentColor: COLOR_DARKGREY,
      dropzoneContentHoverColor: COLOR_DARKGREY,
      dropzoneLinkColor: COLOR_RED,
      dropzoneLinkHoverColor: COLOR_RED,
      uploadedStatusColor: COLOR_DARKGREY,
      uploadCompleteContentColor: COLOR_TURQUOISE
    }
  },
  {
    schemeName: "turquoiseOnYellow",
    scheme: {
      dropzoneBorderSingle: COLOR_BLACK_OPACITY_20,
      dropzoneBorderMultiple: COLOR_BLACK_OPACITY_20,
      dropzoneBackground: COLOR_WHITE_OPACITY_20,
      dropzoneHoverBackground: COLOR_TURQUOISE_25,
      dropzoneHoverBorder: COLOR_TURQUOISE,
      dropzoneOnDragHoverBackground: COLOR_TURQUOISE_25,
      dropzoneOnDragHoverBorder: COLOR_TURQUOISE,
      errorMessageColor: COLOR_BORDEAUX,
      buttonScheme: String(/bordeaux/),
      uploadCompleteBackground: COLOR_ULTRALIGHTGREY,
      dragOverBorder: COLOR_TURQUOISE,
      dropzoneIconColor: COLOR_DARKGREY,
      dropzoneIconHoverColor: COLOR_DARKGREY,
      dropzoneContentColor: COLOR_DARKGREY,
      dropzoneContentHoverColor: COLOR_DARKGREY,
      dropzoneLinkColor: COLOR_DARKGREY,
      dropzoneLinkHoverColor: COLOR_DARKGREY,
      uploadedStatusColor: COLOR_DARKGREY,
      uploadCompleteContentColor: COLOR_TURQUOISE
    }
  },
  {
    schemeName: "whiteOnTurquoise",
    scheme: {
      dropzoneBorderSingle: COLOR_WHITE,
      dropzoneBorderMultiple: COLOR_WHITE_OPACITY_20,
      dropzoneBackground: COLOR_WHITE_OPACITY_10,
      dropzoneHoverBackground: COLOR_TURQUOISE_25,
      dropzoneHoverBorder: COLOR_WHITE,
      dropzoneOnDragHoverBackground: COLOR_TURQUOISE_25,
      dropzoneOnDragHoverBorder: COLOR_WHITE,
      errorMessageColor: COLOR_BORDEAUX,
      buttonScheme: String(/turquoiseInverted/),
      uploadCompleteBackground: COLOR_ULTRALIGHTGREY,
      dragOverBorder: COLOR_TURQUOISE,
      dropzoneIconColor: COLOR_WHITE,
      dropzoneIconHoverColor: COLOR_DARKGREY,
      dropzoneContentColor: COLOR_WHITE,
      dropzoneContentHoverColor: COLOR_DARKGREY,
      dropzoneLinkColor: COLOR_WHITE,
      dropzoneLinkHoverColor: COLOR_DARKGREY,
      uploadedStatusColor: COLOR_WHITE,
      uploadCompleteContentColor: COLOR_TURQUOISE
    }
  },
  {
    schemeName: "whiteOnBordeaux",
    scheme: {
      dropzoneBorderSingle: COLOR_WHITE,
      dropzoneBorderMultiple: COLOR_WHITE_OPACITY_20,
      dropzoneBackground: COLOR_WHITE_OPACITY_10,
      dropzoneHoverBackground: COLOR_TURQUOISE_25,
      dropzoneHoverBorder: COLOR_WHITE,
      dropzoneOnDragHoverBackground: COLOR_TURQUOISE,
      dropzoneOnDragHoverBorder: COLOR_WHITE,
      errorMessageColor: COLOR_WHITE,
      buttonScheme: String(/bordeauxInverted/),
      uploadCompleteBackground: COLOR_ULTRALIGHTGREY,
      dragOverBorder: COLOR_TURQUOISE,
      dropzoneIconColor: COLOR_WHITE,
      dropzoneIconHoverColor: COLOR_DARKGREY,
      dropzoneContentColor: COLOR_WHITE,
      dropzoneContentHoverColor: COLOR_DARKGREY,
      dropzoneLinkColor: COLOR_WHITE,
      dropzoneLinkHoverColor: COLOR_DARKGREY,
      uploadedStatusColor: COLOR_WHITE,
      uploadCompleteContentColor: COLOR_TURQUOISE
    }
  },
  {
    schemeName: "turquoiseOnLightgrey",
    scheme: {
      dropzoneBorderSingle: COLOR_BLACK_OPACITY_20,
      dropzoneBorderMultiple: COLOR_BLACK_OPACITY_20,
      dropzoneBackground: COLOR_ULTRALIGHTGREY,
      dropzoneHoverBackground: COLOR_TURQUOISE_25,
      dropzoneHoverBorder: COLOR_TURQUOISE,
      dropzoneOnDragHoverBackground: COLOR_TURQUOISE_25,
      dropzoneOnDragHoverBorder: COLOR_TURQUOISE,
      errorMessageColor: COLOR_BORDEAUX,
      buttonScheme: String(/redOnLightgrey/),
      uploadCompleteBackground: COLOR_WHITE,
      dragOverBorder: COLOR_TURQUOISE,
      dropzoneIconColor: COLOR_DARKGREY,
      dropzoneIconHoverColor: COLOR_DARKGREY,
      dropzoneContentColor: COLOR_DARKGREY,
      dropzoneContentHoverColor: COLOR_DARKGREY,
      dropzoneLinkColor: COLOR_DARKGREY,
      dropzoneLinkHoverColor: COLOR_DARKGREY,
      uploadedStatusColor: COLOR_DARKGREY,
      uploadCompleteContentColor: COLOR_TURQUOISE
    }
  },
  {
    schemeName: "turquoiseOnUltralightgrey",
    scheme: {
      dropzoneBorderSingle: COLOR_DARKGREY_OPACITY_20,
      dropzoneBorderMultiple: COLOR_DARKGREY_OPACITY_20,
      dropzoneBackground: COLOR_LIGHTGREY,
      dropzoneHoverBackground: COLOR_TURQUOISE_25,
      dropzoneHoverBorder: COLOR_TURQUOISE,
      dropzoneOnDragHoverBackground: COLOR_TURQUOISE_25,
      dropzoneOnDragHoverBorder: COLOR_TURQUOISE,
      errorMessageColor: COLOR_BORDEAUX,
      buttonScheme: String(/redOnUltralightgrey/),
      uploadCompleteBackground: COLOR_WHITE,
      dragOverBorder: COLOR_TURQUOISE,
      dropzoneIconColor: COLOR_DARKGREY,
      dropzoneIconHoverColor: COLOR_DARKGREY,
      dropzoneContentColor: COLOR_DARKGREY,
      dropzoneContentHoverColor: COLOR_DARKGREY,
      dropzoneLinkColor: COLOR_DARKGREY,
      dropzoneLinkHoverColor: COLOR_DARKGREY,
      uploadedStatusColor: COLOR_DARKGREY,
      uploadCompleteContentColor: COLOR_TURQUOISE
    }
  }
];
export const FILE_PREVIEW_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red",
    scheme: {
      iconColor: COLOR_DARKGREY,
      textColor: COLOR_DARKGREY,
      boxBackground: COLOR_WHITE,
      fileIconColor: COLOR_MIDDLEGREY,
      descriptionColor: COLOR_MIDDLEGREY,
      progressCircleScheme: "white",
      previewCancelIconColor: COLOR_MIDDLEGREY
    }
  },
  {
    schemeName: "white",
    scheme: {
      iconColor: COLOR_DARKGREY,
      textColor: COLOR_DARKGREY,
      boxBackground: COLOR_ULTRALIGHTGREY,
      fileIconColor: COLOR_MIDDLEGREY,
      descriptionColor: COLOR_MIDDLEGREY,
      progressCircleScheme: "ultralightgrey",
      previewCancelIconColor: COLOR_MIDDLEGREY
    }
  }
];
export const FORM_MESSAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "standard",
    scheme: {
      infoColor: COLOR_DARKGREY,
      successColor: COLOR_TURQUOISE,
      errorColor: COLOR_BORDEAUX
    }
  },
  {
    schemeName: "white",
    scheme: {
      errorColor: COLOR_WHITE
    }
  },
  {
    schemeName: "darkgrey",
    scheme: {
      errorColor: COLOR_BORDEAUX
    }
  }
];
export const HEADLINE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white"
  },
  {
    schemeName: "red"
  },
  {
    schemeName: "bordeaux"
  },
  {
    schemeName: "turquoise"
  },
  {
    schemeName: "darkgrey"
  }
];
export const ICON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white"
  },
  {
    schemeName: "red"
  },
  {
    schemeName: "turquoise"
  },
  {
    schemeName: "bordeaux"
  },
  {
    schemeName: "limeyellow"
  },
  {
    schemeName: "limeyellowLight"
  },
  {
    schemeName: "darkgrey"
  },
  {
    schemeName: "middlegrey"
  }
];
export const INFO_ICON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red",
    scheme: {
      iconHoverColor: COLOR_RED_ACTIVE
    }
  },
  {
    schemeName: "white",
    scheme: {
      iconHoverColor: COLOR_WHITE_OPACITY_80
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      iconHoverColor: COLOR_TURQUOISE_ACTIVE
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      iconHoverColor: COLOR_BORDEAUX_ACTIVE
    }
  },
  {
    schemeName: "darkgrey",
    scheme: {
      iconHoverColor: COLOR_MIDDLEGREY_ACTIVE
    }
  },
  {
    schemeName: "middlegrey",
    scheme: {
      iconHoverColor: COLOR_MIDDLEGREY_ACTIVE
    }
  }
];
export const INPUT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "turquoise",
    scheme: {
      borderColor: COLOR_MIDDLEGREY,
      borderHoverColor: COLOR_MIDDLEGREY_ACTIVE,
      labelColor: COLOR_DARKGREY,
      labelColorActive: COLOR_DARKGREY,
      errorMessageColor: COLOR_BORDEAUX,
      trailingIconBackgroundColor: COLOR_ULTRALIGHTGREY,
      trailingIconColor: COLOR_MIDDLEGREY,
      trailingIconColorActive: COLOR_MIDDLEGREY_ACTIVE,
      disabledBackgroundColor: COLOR_LIGHTGREY,
      disabledBorderColor: COLOR_MIDDLEGREY,
      disabledTrailingIconColor: COLOR_DARKGREY_OPACITY_40,
      disabledLabelColor: COLOR_DARKGREY_OPACITY_40,
      disabledOpacity: 0.4,
      optionsBackgroundColor: COLOR_WHITE,
      optionsBorderBottomColor: COLOR_LIGHTGREY,
      optionsBackgroundColorHover: COLOR_ULTRALIGHTGREY
    }
  },
  {
    schemeName: "turquoiseOnUltralightgrey",
    scheme: {
      borderColor: COLOR_MIDDLEGREY,
      borderHoverColor: COLOR_MIDDLEGREY_ACTIVE,
      borderActiveColor: COLOR_TURQUOISE,
      labelColor: COLOR_DARKGREY,
      labelColorActive: COLOR_DARKGREY,
      errorMessageColor: COLOR_BORDEAUX,
      trailingIconBackgroundColor: COLOR_LIGHTGREY,
      trailingIconColor: COLOR_MIDDLEGREY,
      trailingIconColorActive: COLOR_MIDDLEGREY_ACTIVE,
      disabledBackgroundColor: COLOR_LIGHTGREY_ACTIVE,
      disabledBorderColor: COLOR_MIDDLEGREY_ACTIVE,
      disabledTrailingIconColor: COLOR_DARKGREY_75,
      disabledLabelColor: COLOR_DARKGREY_OPACITY_40,
      disabledOpacity: 0.4,
      optionsBackgroundColor: COLOR_WHITE,
      optionsBorderHoverColor: COLOR_TURQUOISE,
      optionsBorderBottomColor: COLOR_LIGHTGREY,
      optionsBackgroundColorHover: COLOR_ULTRALIGHTGREY,
      optionsBackgroundColorActive: COLOR_TURQUOISE_25
    }
  },
  {
    schemeName: "turquoiseOnLightgrey",
    scheme: {
      borderColor: COLOR_MIDDLEGREY,
      borderHoverColor: COLOR_MIDDLEGREY_ACTIVE,
      borderActiveColor: COLOR_TURQUOISE,
      labelColor: COLOR_DARKGREY,
      labelColorActive: COLOR_DARKGREY,
      errorMessageColor: COLOR_BORDEAUX,
      trailingIconBackgroundColor: COLOR_DARKGREY_OPACITY_10,
      trailingIconColor: COLOR_MIDDLEGREY,
      trailingIconColorActive: COLOR_MIDDLEGREY_ACTIVE,
      disabledBackgroundColor: COLOR_DARKGREY_25,
      disabledBorderColor: COLOR_MIDDLEGREY_ACTIVE,
      disabledTrailingIconColor: COLOR_DARKGREY,
      disabledLabelColor: COLOR_DARKGREY_OPACITY_40,
      disabledOpacity: 0.4,
      optionsBackgroundColor: COLOR_WHITE,
      optionsBorderHoverColor: COLOR_TURQUOISE,
      optionsBorderBottomColor: COLOR_LIGHTGREY,
      optionsBackgroundColorHover: COLOR_ULTRALIGHTGREY,
      optionsBackgroundColorActive: COLOR_TURQUOISE_25
    }
  },
  {
    schemeName: "whiteOnRed",
    scheme: {
      borderColor: COLOR_WHITE_OPACITY_80,
      borderHoverColor: COLOR_WHITE,
      borderActiveColor: COLOR_WHITE,
      labelColor: COLOR_WHITE,
      labelColorActive: COLOR_WHITE,
      errorMessageColor: COLOR_WHITE,
      trailingIconBackgroundColor: COLOR_RED_ACTIVE,
      trailingIconColor: COLOR_WHITE_OPACITY_60,
      trailingIconColorActive: COLOR_WHITE,
      disabledBackgroundColor: COLOR_TRANSPARENT,
      disabledBorderColor: COLOR_WHITE,
      disabledTrailingIconColor: COLOR_WHITE,
      disabledLabelColor: COLOR_WHITE_OPACITY_60,
      optionsBackgroundColor: COLOR_WHITE,
      optionsBorderHoverColor: COLOR_TURQUOISE,
      optionsBorderBottomColor: COLOR_LIGHTGREY,
      optionsBackgroundColorHover: COLOR_ULTRALIGHTGREY,
      optionsBackgroundColorActive: COLOR_TURQUOISE_25
    }
  },
  {
    schemeName: "whiteOnTurquoise",
    scheme: {
      borderColor: COLOR_WHITE_OPACITY_80,
      borderHoverColor: COLOR_WHITE,
      borderActiveColor: COLOR_WHITE,
      labelColor: COLOR_WHITE,
      labelColorActive: COLOR_WHITE,
      errorMessageColor: COLOR_WHITE,
      trailingIconBackgroundColor: COLOR_TURQUOISE_ACTIVE,
      trailingIconColor: COLOR_WHITE_OPACITY_60,
      trailingIconColorActive: COLOR_WHITE,
      disabledBackgroundColor: COLOR_TRANSPARENT,
      disabledBorderColor: COLOR_WHITE,
      disabledTrailingIconColor: COLOR_WHITE,
      disabledLabelColor: COLOR_WHITE_OPACITY_60,
      optionsBackgroundColor: COLOR_WHITE,
      optionsBorderHoverColor: COLOR_TURQUOISE,
      optionsBorderBottomColor: COLOR_LIGHTGREY,
      optionsBackgroundColorHover: COLOR_ULTRALIGHTGREY,
      optionsBackgroundColorActive: COLOR_TURQUOISE_25
    }
  },
  {
    schemeName: "whiteOnBordeaux",
    scheme: {
      borderColor: COLOR_WHITE_OPACITY_80,
      borderHoverColor: COLOR_WHITE,
      borderActiveColor: COLOR_WHITE,
      labelColor: COLOR_WHITE,
      labelColorActive: COLOR_WHITE,
      errorMessageColor: COLOR_WHITE,
      trailingIconBackgroundColor: COLOR_BORDEAUX_ACTIVE,
      trailingIconColor: COLOR_WHITE_OPACITY_60,
      trailingIconColorActive: COLOR_WHITE,
      disabledBackgroundColor: COLOR_TRANSPARENT,
      disabledBorderColor: COLOR_WHITE,
      disabledTrailingIconColor: COLOR_WHITE,
      disabledLabelColor: COLOR_WHITE_OPACITY_60,
      optionsBackgroundColor: COLOR_WHITE,
      optionsBorderHoverColor: COLOR_TURQUOISE,
      optionsBorderBottomColor: COLOR_LIGHTGREY,
      optionsBackgroundColorHover: COLOR_ULTRALIGHTGREY,
      optionsBackgroundColorActive: COLOR_TURQUOISE_25
    }
  },
  {
    schemeName: "darkgreyOnLimeyellow",
    scheme: {
      borderColor: COLOR_DARKGREY_OPACITY_80,
      borderHoverColor: COLOR_DARKGREY,
      borderActiveColor: COLOR_DARKGREY,
      labelColor: COLOR_DARKGREY,
      labelColorActive: COLOR_DARKGREY,
      errorMessageColor: COLOR_BORDEAUX,
      trailingIconBackgroundColor: COLOR_LIMEYELLOW_ACTIVE,
      trailingIconColor: COLOR_DARKGREY_OPACITY_80,
      trailingIconColorActive: COLOR_DARKGREY,
      disabledBackgroundColor: COLOR_TRANSPARENT,
      disabledBorderColor: COLOR_DARKGREY,
      disabledTrailingIconColor: COLOR_DARKGREY,
      disabledLabelColor: COLOR_DARKGREY_OPACITY_40,
      disabledOpacity: 0.4,
      optionsBackgroundColor: COLOR_DARKGREY,
      optionsBorderHoverColor: COLOR_TURQUOISE,
      optionsBorderBottomColor: COLOR_LIGHTGREY,
      optionsBackgroundColorHover: COLOR_ULTRALIGHTGREY,
      optionsBackgroundColorActive: COLOR_TURQUOISE_25
    }
  }
];
export const LINK_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red",
    scheme: {
      contentHoverColor: COLOR_RED_ACTIVE,
      mapsLinkColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      contentHoverColor: COLOR_TURQUOISE_ACTIVE
    }
  },
  {
    schemeName: "white",
    scheme: {
      contentHoverColor: COLOR_WHITE_OPACITY_85
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      contentHoverColor: COLOR_BORDEAUX_ACTIVE,
      mapsLinkColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "darkgrey",
    scheme: {
      contentHoverColor: COLOR_DARKGREY_ACTIVE,
      mapsLinkColor: COLOR_DARKGREY
    }
  }
];
export const LINKLIST_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red",
    scheme: {
      linklistHoverColor: COLOR_RED_ACTIVE
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      linklistHoverColor: COLOR_TURQUOISE_ACTIVE
    }
  },
  {
    schemeName: "white",
    scheme: {
      linklistHoverColor: COLOR_WHITE_OPACITY_85
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      linklistHoverColor: COLOR_BORDEAUX_ACTIVE
    }
  },
  {
    schemeName: "darkgrey",
    scheme: {
      linklistHoverColor: COLOR_DARKGREY_ACTIVE
    }
  }
];
export const MAP_INFO_LAYER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      headerBackgroundColor: COLOR_ULTRALIGHTGREY,
      contentColor: COLOR_DARKGREY,
      contentBackgroundColor: COLOR_WHITE
    }
  },
  {
    schemeName: "limeyellow",
    scheme: {
      headerBackgroundColor: COLOR_LIMEYELLOW_ACTIVE,
      contentColor: COLOR_DARKGREY,
      contentBackgroundColor: COLOR_LIMEYELLOW
    }
  },
  {
    schemeName: "red",
    scheme: {
      headerBackgroundColor: COLOR_RED_ACTIVE,
      contentColor: COLOR_WHITE,
      contentBackgroundColor: COLOR_RED
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      headerBackgroundColor: COLOR_BORDEAUX_ACTIVE,
      contentColor: COLOR_WHITE,
      contentBackgroundColor: COLOR_BORDEAUX
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      headerBackgroundColor: COLOR_TURQUOISE_ACTIVE,
      contentColor: COLOR_WHITE,
      contentBackgroundColor: COLOR_TURQUOISE
    }
  }
];
export const MULTI_CONTENT_STAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red",
    scheme: {
      backgroundColor: COLOR_RED,
      color: COLOR_WHITE,
      activeBackgroundColor: COLOR_RED_ACTIVE,
      loadingBarColor: COLOR_LIMEYELLOW,
      controlColor: COLOR_WHITE,
      controlColorHover: COLOR_ULTRALIGHTGREY,
      controlIconColor: COLOR_DARKGREY,
      controlIconColorHover: COLOR_DARKGREY
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      backgroundColor: COLOR_TURQUOISE,
      color: COLOR_WHITE,
      activeBackgroundColor: COLOR_TURQUOISE_ACTIVE,
      loadingBarColor: COLOR_LIMEYELLOW,
      controlColor: COLOR_WHITE,
      controlColorHover: COLOR_ULTRALIGHTGREY,
      controlIconColor: COLOR_DARKGREY,
      controlIconColorHover: COLOR_DARKGREY
    }
  },
  {
    schemeName: "ultralightgrey",
    scheme: {
      backgroundColor: COLOR_ULTRALIGHTGREY,
      color: COLOR_DARKGREY,
      activeBackgroundColor: COLOR_ULTRALIGHTGREY_50,
      loadingBarColor: COLOR_RED,
      controlColor: COLOR_RED,
      controlColorHover: COLOR_RED_ACTIVE,
      controlIconColor: COLOR_WHITE,
      controlIconColorHover: COLOR_WHITE
    }
  },
  {
    schemeName: "limeyellow",
    scheme: {
      backgroundColor: COLOR_LIMEYELLOW,
      color: COLOR_DARKGREY,
      activeBackgroundColor: COLOR_LIMEYELLOW_ACTIVE,
      loadingBarColor: COLOR_BORDEAUX,
      controlColor: COLOR_BORDEAUX,
      controlColorHover: COLOR_BORDEAUX_ACTIVE,
      controlIconColor: COLOR_WHITE,
      controlIconColorHover: COLOR_WHITE
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      backgroundColor: COLOR_BORDEAUX,
      color: COLOR_WHITE,
      activeBackgroundColor: COLOR_BORDEAUX_ACTIVE,
      loadingBarColor: COLOR_LIMEYELLOW,
      controlColor: COLOR_WHITE,
      controlColorHover: COLOR_ULTRALIGHTGREY,
      controlIconColor: COLOR_DARKGREY,
      controlIconColorHover: COLOR_DARKGREY
    }
  },
  {
    schemeName: "white",
    scheme: {
      backgroundColor: COLOR_WHITE,
      color: COLOR_DARKGREY,
      activeBackgroundColor: COLOR_WHITE,
      loadingBarColor: COLOR_RED,
      controlColor: COLOR_RED,
      controlColorHover: COLOR_RED_ACTIVE,
      controlIconColor: COLOR_WHITE,
      controlIconColorHover: COLOR_WHITE
    }
  }
];
export const NUMBER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white"
  },
  {
    schemeName: "darkgrey"
  },
  {
    schemeName: "red"
  },
  {
    schemeName: "bordeaux"
  },
  {
    schemeName: "turquoise"
  }
];
export const OFFSET_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      contentColor: COLOR_DARKGREY,
      innerBackgroundColor: COLOR_WHITE,
      visibleBackgroundColor: COLOR_WHITE,
      linkColor: COLOR_RED,
      linkHoverColor: COLOR_RED_ACTIVE,
      headlineColor: COLOR_RED,
      headlineColorOffset: COLOR_RED
    }
  },
  {
    schemeName: "whiteOnLightgrey",
    scheme: {
      contentColor: COLOR_DARKGREY,
      innerBackgroundColor: COLOR_WHITE,
      visibleBackgroundColor: COLOR_WHITE,
      linkColor: COLOR_RED,
      linkHoverColor: COLOR_RED_ACTIVE,
      headlineColor: COLOR_RED,
      headlineColorOffset: COLOR_RED
    }
  },
  {
    schemeName: "whiteOnLimeyellow",
    scheme: {
      contentColor: COLOR_DARKGREY,
      innerBackgroundColor: COLOR_WHITE,
      visibleBackgroundColor: COLOR_WHITE,
      linkColor: COLOR_BORDEAUX,
      linkHoverColor: COLOR_BORDEAUX_ACTIVE,
      headlineColor: COLOR_BORDEAUX,
      headlineColorOffset: COLOR_BORDEAUX
    }
  },
  {
    schemeName: "ultralightgrey",
    scheme: {
      contentColor: COLOR_DARKGREY,
      innerBackgroundColor: COLOR_ULTRALIGHTGREY,
      visibleBackgroundColor: COLOR_ULTRALIGHTGREY,
      linkColor: COLOR_RED,
      linkHoverColor: COLOR_RED_ACTIVE,
      headlineColor: COLOR_RED,
      headlineColorOffset: COLOR_RED
    }
  },
  {
    schemeName: "lightgrey",
    scheme: {
      contentColor: COLOR_DARKGREY,
      innerBackgroundColor: COLOR_LIGHTGREY,
      visibleBackgroundColor: COLOR_LIGHTGREY,
      linkColor: COLOR_RED,
      linkHoverColor: COLOR_RED_ACTIVE,
      headlineColor: COLOR_RED,
      headlineColorOffset: COLOR_RED
    }
  },
  {
    schemeName: "red",
    scheme: {
      contentColor: COLOR_WHITE,
      innerBackgroundColor: COLOR_RED,
      visibleBackgroundColor: COLOR_RED,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      headlineColor: COLOR_WHITE,
      headlineColorOffset: COLOR_RED
    }
  },
  {
    schemeName: "limeyellow",
    scheme: {
      contentColor: COLOR_DARKGREY,
      innerBackgroundColor: COLOR_LIMEYELLOW,
      visibleBackgroundColor: COLOR_LIMEYELLOW,
      linkColor: COLOR_BORDEAUX,
      linkHoverColor: COLOR_BORDEAUX_ACTIVE,
      headlineColor: COLOR_BORDEAUX,
      headlineColorOffset: COLOR_BORDEAUX
    }
  },
  {
    schemeName: "limeyellowActive",
    scheme: {
      contentColor: COLOR_DARKGREY,
      innerBackgroundColor: COLOR_LIMEYELLOW,
      visibleBackgroundColor: COLOR_LIMEYELLOW_ACTIVE,
      linkColor: COLOR_BORDEAUX,
      linkHoverColor: COLOR_BORDEAUX_ACTIVE,
      headlineColor: COLOR_BORDEAUX,
      headlineColorOffset: COLOR_BORDEAUX
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      contentColor: COLOR_WHITE,
      innerBackgroundColor: COLOR_BORDEAUX,
      visibleBackgroundColor: COLOR_BORDEAUX,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      headlineColor: COLOR_WHITE,
      headlineColorOffset: COLOR_WHITE
    }
  },
  {
    schemeName: "bordeauxDark",
    scheme: {
      contentColor: COLOR_WHITE,
      innerBackgroundColor: COLOR_BORDEAUX,
      visibleBackgroundColor: COLOR_BORDEAUX_DARK,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      headlineColor: COLOR_WHITE,
      headlineColorOffset: COLOR_WHITE
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      contentColor: COLOR_WHITE,
      innerBackgroundColor: COLOR_TURQUOISE,
      visibleBackgroundColor: COLOR_TURQUOISE,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      headlineColor: COLOR_WHITE,
      headlineColorOffset: COLOR_TURQUOISE
    }
  },
  {
    schemeName: "turquoiseDark",
    scheme: {
      contentColor: COLOR_WHITE,
      innerBackgroundColor: COLOR_TURQUOISE,
      visibleBackgroundColor: COLOR_TURQUOISE_DARK,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      headlineColor: COLOR_WHITE,
      headlineColorOffset: COLOR_WHITE
    }
  },
  {
    schemeName: "whiteOnTurquoise",
    scheme: {
      contentColor: COLOR_DARKGREY,
      innerBackgroundColor: COLOR_WHITE,
      visibleBackgroundColor: COLOR_WHITE,
      linkColor: COLOR_RED,
      linkHoverColor: COLOR_RED_ACTIVE,
      headlineColor: COLOR_RED,
      headlineColorOffset: COLOR_WHITE
    }
  }
];
export const OFFSET_TEASER5_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white"
  },
  {
    schemeName: "whiteOnLightgrey"
  },
  {
    schemeName: "whiteOnLimeyellow"
  },
  {
    schemeName: "ultralightgrey"
  },
  {
    schemeName: "lightgrey"
  },
  {
    schemeName: "red"
  },
  {
    schemeName: "limeyellow"
  },
  {
    schemeName: "limeyellowActive"
  },
  {
    schemeName: "bordeaux"
  },
  {
    schemeName: "bordeauxDark"
  },
  {
    schemeName: "turquoise"
  },
  {
    schemeName: "turquoiseDark"
  }
];
export const PRELOADER_CIRCLE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "colorful",
    scheme: {
      spinnerColor: COLOR_RED,
      trackColor: COLOR_DARKGREY_OPACITY_5
    }
  },
  {
    schemeName: "red",
    scheme: {
      trackColor: COLOR_DARKGREY_OPACITY_5
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      trackColor: COLOR_DARKGREY_OPACITY_5
    }
  },
  {
    schemeName: "darkgrey",
    scheme: {
      trackColor: COLOR_DARKGREY_OPACITY_10
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      trackColor: COLOR_BORDEAUX_OPACITY_30
    }
  },
  {
    schemeName: "white",
    scheme: {
      spinnerColor: COLOR_WHITE,
      trackColor: COLOR_WHITE_OPACITY_20
    }
  }
];
export const PRELOADER_SQUARES_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red",
    scheme: {
      color: COLOR_MIDDLEGREY
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      color: COLOR_MIDDLEGREY
    }
  },
  {
    schemeName: "darkgrey",
    scheme: {
      color: COLOR_DARKGREY
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      color: COLOR_BORDEAUX
    }
  },
  {
    schemeName: "white",
    scheme: {
      color: COLOR_WHITE
    }
  }
];
export const PROGRESS_CIRCLE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red",
    scheme: {
      textColor: COLOR_WHITE,
      backgroundColor: COLOR_RED,
      progressBackgroundColor: COLOR_WHITE_OPACITY_30,
      progressColor: COLOR_WHITE,
      iconColorOnHover: COLOR_RED,
      progressBackgroundColorOnHover: COLOR_WHITE_OPACITY_30,
      progressColorOnHover: COLOR_WHITE
    }
  },
  {
    schemeName: "white",
    scheme: {
      textColor: COLOR_TURQUOISE,
      iconColor: COLOR_TURQUOISE,
      backgroundColor: COLOR_WHITE,
      progressBackgroundColor: COLOR_LIGHTGREY,
      progressColor: COLOR_TURQUOISE,
      iconColorOnHover: COLOR_DARKGREY,
      progressBackgroundColorOnHover: COLOR_LIGHTGREY,
      progressColorOnHover: COLOR_LIGHTGREY_ACTIVE
    }
  },
  {
    schemeName: "yellow",
    scheme: {
      textColor: COLOR_DARKGREY,
      iconColor: COLOR_DARKGREY,
      backgroundColor: COLOR_LIMEYELLOW,
      progressBackgroundColor: COLOR_DARKGREY_OPACITY_20,
      progressColor: COLOR_DARKGREY,
      iconColorOnHover: COLOR_DARKGREY,
      progressBackgroundColorOnHover: COLOR_DARKGREY_OPACITY_20,
      progressColorOnHover: COLOR_DARKGREY
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      textColor: COLOR_WHITE,
      backgroundColor: COLOR_TURQUOISE,
      progressBackgroundColor: COLOR_WHITE_OPACITY_30,
      progressColor: COLOR_WHITE,
      progressBackgroundColorOnHover: COLOR_WHITE_OPACITY_30,
      progressColorOnHover: COLOR_WHITE
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      textColor: COLOR_WHITE,
      backgroundColor: COLOR_BORDEAUX,
      progressBackgroundColor: COLOR_WHITE_OPACITY_30,
      progressColor: COLOR_WHITE,
      progressBackgroundColorOnHover: COLOR_WHITE_OPACITY_30,
      progressColorOnHover: COLOR_WHITE
    }
  },
  {
    schemeName: "lightgrey",
    scheme: {
      textColor: COLOR_TURQUOISE,
      backgroundColor: COLOR_LIGHTGREY,
      progressBackgroundColor: COLOR_WHITE,
      progressColor: COLOR_TURQUOISE,
      progressBackgroundColorOnHover: COLOR_WHITE,
      progressColorOnHover: COLOR_TURQUOISE
    }
  },
  {
    schemeName: "ultralightgrey",
    scheme: {
      textColor: COLOR_TURQUOISE,
      iconColor: COLOR_TURQUOISE,
      backgroundColor: COLOR_ULTRALIGHTGREY,
      progressBackgroundColor: COLOR_LIGHTGREY,
      progressColor: COLOR_TURQUOISE,
      iconColorOnHover: COLOR_DARKGREY,
      progressBackgroundColorOnHover: COLOR_LIGHTGREY,
      progressColorOnHover: COLOR_LIGHTGREY_ACTIVE
    }
  }
];
export const PROMO_FLAG_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      textColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "ultralightgrey",
    scheme: {
      textColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "limeyellow",
    scheme: {
      textColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      textColor: COLOR_WHITE
    }
  },
  {
    schemeName: "red",
    scheme: {
      textColor: COLOR_WHITE
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      textColor: COLOR_WHITE
    }
  },
  {
    schemeName: "bordeauxDark",
    scheme: {
      textColor: COLOR_WHITE,
      backgroundColor: COLOR_BORDEAUX_DARK,
      cornerColor: COLOR_BORDEAUX_SHADE_2
    }
  },
  {
    schemeName: "turquoiseDark",
    scheme: {
      textColor: COLOR_WHITE,
      backgroundColor: COLOR_TURQUOISE_DARK,
      cornerColor: COLOR_TURQUOISE_SHADE_2
    }
  }
];
export const PAGE_HEADER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red",
    scheme: {
      wideShade: COLOR_BORDEAUX,
      narrowShade: COLOR_TURQUOISE
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      narrowShade: COLOR_LIMEYELLOW
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      wideShade: COLOR_RED,
      narrowShade: COLOR_LIMEYELLOW
    }
  },
  {
    schemeName: "limeyellow",
    scheme: {
      contentColor: COLOR_DARKGREY,
      narrowShade: COLOR_TURQUOISE
    }
  },
  {
    schemeName: "white",
    scheme: {
      contentColor: COLOR_DARKGREY,
      wideShade: COLOR_WHITE,
      narrowShade: COLOR_RED
    }
  },
  {
    schemeName: "ultralightgrey",
    scheme: {
      contentColor: COLOR_DARKGREY,
      narrowShade: COLOR_RED
    }
  },
  {
    schemeName: "lightgrey",
    scheme: {
      contentColor: COLOR_DARKGREY,
      narrowShade: COLOR_RED
    }
  }
];
export const PICTOGRAM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white"
  },
  {
    schemeName: "red"
  },
  {
    schemeName: "turquoise"
  },
  {
    schemeName: "bordeaux"
  },
  {
    schemeName: "limeyellow"
  },
  {
    schemeName: "darkgrey"
  },
  {
    schemeName: "middlegrey"
  }
];
export const RADIO_BUTTON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "turquoise",
    scheme: {
      labelColor: COLOR_DARKGREY,
      uncheckedColor: COLOR_MIDDLEGREY,
      checkedHoverColor: COLOR_TURQUOISE_ACTIVE,
      errorColor: COLOR_BORDEAUX,
      disabledLabelColor: COLOR_DARKGREY_OPACITY_60
    }
  },
  {
    schemeName: "red",
    scheme: {
      labelColor: COLOR_DARKGREY,
      uncheckedColor: COLOR_MIDDLEGREY,
      checkedHoverColor: COLOR_RED_ACTIVE,
      errorColor: COLOR_BORDEAUX,
      disabledLabelColor: COLOR_DARKGREY_OPACITY_60
    }
  },
  {
    schemeName: "inverted",
    scheme: {
      labelColor: COLOR_WHITE,
      uncheckedColor: COLOR_WHITE,
      uncheckedHoverColor: COLOR_WHITE,
      focusColor: COLOR_WHITE_OPACITY_75,
      checkedColor: COLOR_WHITE,
      checkedHoverColor: COLOR_WHITE_OPACITY_75,
      errorColor: COLOR_WHITE,
      inverted: true,
      disabledLabelColor: COLOR_WHITE_OPACITY_60
    }
  },
  {
    schemeName: "darkgrey",
    scheme: {
      labelColor: COLOR_DARKGREY,
      uncheckedColor: COLOR_DARKGREY,
      uncheckedHoverColor: COLOR_DARKGREY_OPACITY_80,
      focusColor: COLOR_DARKGREY_OPACITY_80,
      checkedHoverColor: COLOR_DARKGREY_OPACITY_80,
      errorColor: COLOR_BORDEAUX,
      disabledLabelColor: COLOR_DARKGREY_OPACITY_60
    }
  }
];
export const READ_MORE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "darkgreyOnWhite",
    scheme: {
      rulerColor: COLOR_DARKGREY,
      rulerButtonHoverColor: COLOR_RED_ACTIVE,
      rulerArrowColor: COLOR_WHITE,
      rulerColorHover: COLOR_RED_ACTIVE
    }
  },
  {
    schemeName: "darkgreyOnUltralightgrey",
    scheme: {
      rulerColor: COLOR_DARKGREY,
      rulerButtonHoverColor: COLOR_RED_ACTIVE,
      rulerArrowColor: COLOR_WHITE,
      rulerColorHover: COLOR_RED_ACTIVE
    }
  },
  {
    schemeName: "darkgreyOnLightgrey",
    scheme: {
      rulerColor: COLOR_DARKGREY,
      rulerButtonHoverColor: COLOR_RED_ACTIVE,
      rulerArrowColor: COLOR_WHITE,
      rulerColorHover: COLOR_RED_ACTIVE
    }
  },
  {
    schemeName: "whiteOnRed",
    scheme: {
      rulerColor: COLOR_WHITE,
      rulerButtonHoverColor: COLOR_RED_15,
      rulerArrowColor: COLOR_DARKGREY,
      rulerColorHover: COLOR_RED_15
    }
  },
  {
    schemeName: "whiteOnBordeaux",
    scheme: {
      rulerColor: COLOR_WHITE,
      rulerButtonHoverColor: COLOR_BORDEAUX_15,
      rulerArrowColor: COLOR_DARKGREY,
      rulerColorHover: COLOR_BORDEAUX_15
    }
  },
  {
    schemeName: "whiteOnTurquoise",
    scheme: {
      rulerColor: COLOR_WHITE,
      rulerButtonHoverColor: COLOR_TURQUOISE_15,
      rulerArrowColor: COLOR_DARKGREY,
      rulerColorHover: COLOR_TURQUOISE_15
    }
  },
  {
    schemeName: "darkgreyOnLimeyellow",
    scheme: {
      rulerColor: COLOR_DARKGREY,
      rulerButtonHoverColor: COLOR_BORDEAUX_ACTIVE,
      rulerArrowColor: COLOR_WHITE,
      rulerColorHover: COLOR_BORDEAUX_ACTIVE
    }
  }
];
export const RTE_RENDERER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bordeaux",
    scheme: {
      paragraphColor: COLOR_DARKGREY,
      blockquoteColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "red",
    scheme: {
      paragraphColor: COLOR_DARKGREY,
      blockquoteColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "darkgrey"
  },
  {
    schemeName: "turquoise",
    scheme: {
      paragraphColor: COLOR_DARKGREY,
      blockquoteColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "white",
    scheme: {
      paragraphColor: COLOR_WHITE,
      sublineColor: COLOR_WHITE,
      blockquoteColor: COLOR_WHITE
    }
  }
];
export const SECTION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      footerSeparatorColor: COLOR_ULTRALIGHTGREY
    }
  },
  {
    schemeName: "lightgrey"
  },
  {
    schemeName: "ultralightgrey",
    scheme: {
      footerSeparatorColor: COLOR_LIGHTGREY
    }
  },
  {
    schemeName: "red"
  },
  {
    schemeName: "limeyellow"
  },
  {
    schemeName: "bordeaux"
  },
  {
    schemeName: "turquoise"
  },
  {
    schemeName: "transparent"
  }
];
export const SEARCH_RESULT_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      contentBackground: COLOR_WHITE,
      descriptionBackground: COLOR_WHITE_OPACITY_90,
      highlightColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "white75",
    scheme: {
      contentBackground: COLOR_WHITE,
      descriptionBackground: COLOR_WHITE_OPACITY_75,
      highlightColor: COLOR_TURQUOISE,
      contentFontColor: COLOR_DARKGREY,
      descriptionFontColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "ultralightgrey",
    scheme: {
      contentBackground: COLOR_ULTRALIGHTGREY,
      descriptionBackground: COLOR_LIGHTGREY,
      highlightColor: COLOR_TURQUOISE
    }
  },
  {
    schemeName: "whiteWithLightGreyDescription",
    scheme: {
      contentBackground: COLOR_WHITE,
      descriptionBackground: COLOR_LIGHTGREY,
      highlightColor: COLOR_TURQUOISE,
      contentFontColor: COLOR_DARKGREY,
      descriptionFontColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "whiteWithUltralightGreyDescription",
    scheme: {
      contentBackground: COLOR_WHITE,
      descriptionBackground: COLOR_ULTRALIGHTGREY,
      highlightColor: COLOR_TURQUOISE,
      contentFontColor: COLOR_DARKGREY,
      descriptionFontColor: COLOR_DARKGREY
    }
  }
];
export const SITELINK_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "whiteRed",
    scheme: {
      linkColor: COLOR_DARKGREY,
      linkHoverColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "whiteRedOnLightgrey",
    scheme: {
      linkColor: COLOR_DARKGREY,
      linkHoverColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "whiteRedOnUltralightgrey",
    scheme: {
      linkColor: COLOR_DARKGREY,
      linkHoverColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "whiteTurquoise",
    scheme: {
      linkColor: COLOR_DARKGREY,
      linkHoverColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "whiteTurquoiseOnLightgrey",
    scheme: {
      linkColor: COLOR_DARKGREY,
      linkHoverColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "whiteTurquoiseOnUltralightgrey",
    scheme: {
      linkColor: COLOR_DARKGREY,
      linkHoverColor: COLOR_DARKGREY
    }
  },
  {
    schemeName: "red",
    scheme: {
      linkHoverColor: COLOR_WHITE
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      linkHoverColor: COLOR_WHITE
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      linkHoverColor: COLOR_WHITE
    }
  },
  {
    schemeName: "limeyellow",
    scheme: {
      linkHoverColor: COLOR_DARKGREY
    }
  }
];
export const SLIDER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "turquoise",
    scheme: {
      knobColor: COLOR_WHITE,
      knobHoverColor: COLOR_WHITE,
      knobBorderColor: COLOR_TURQUOISE,
      knobBorderHoverColor: COLOR_TURQUOISE,
      barColor: COLOR_DARKGREY_25,
      barActiveColor: COLOR_TURQUOISE_DARK,
      pipColor: COLOR_MIDDLEGREY,
      pipHoverColor: COLOR_MIDDLEGREY_ACTIVE,
      errorColor: COLOR_BORDEAUX
    }
  },
  {
    schemeName: "red",
    scheme: {
      knobColor: COLOR_WHITE,
      knobHoverColor: COLOR_WHITE,
      knobBorderColor: COLOR_RED,
      knobBorderHoverColor: COLOR_RED,
      barColor: COLOR_DARKGREY_25,
      barActiveColor: COLOR_BORDEAUX,
      pipColor: COLOR_MIDDLEGREY,
      pipHoverColor: COLOR_MIDDLEGREY_ACTIVE,
      errorColor: COLOR_BORDEAUX
    }
  },
  {
    schemeName: "darkgreyOnLimeyellow",
    scheme: {
      knobColor: COLOR_LIMEYELLOW,
      knobHoverColor: COLOR_LIMEYELLOW,
      knobBorderColor: COLOR_DARKGREY,
      knobBorderHoverColor: COLOR_DARKGREY,
      barColor: COLOR_DARKGREY_OPACITY_30,
      barActiveColor: COLOR_DARKGREY,
      pipColor: COLOR_DARKGREY,
      pipHoverColor: COLOR_BLACK,
      errorColor: COLOR_BORDEAUX
    }
  },
  {
    schemeName: "whiteOnTurquoise",
    scheme: {
      knobColor: COLOR_TURQUOISE,
      knobHoverColor: COLOR_TURQUOISE,
      knobBorderColor: COLOR_WHITE,
      knobBorderHoverColor: COLOR_WHITE,
      barColor: COLOR_WHITE_OPACITY_30,
      barActiveColor: COLOR_WHITE,
      pipColor: COLOR_WHITE_OPACITY_80,
      pipHoverColor: COLOR_WHITE,
      errorColor: COLOR_WHITE
    }
  },
  {
    schemeName: "whiteOnRed",
    scheme: {
      knobColor: COLOR_RED,
      knobHoverColor: COLOR_RED,
      knobBorderColor: COLOR_WHITE,
      knobBorderHoverColor: COLOR_WHITE,
      barColor: COLOR_WHITE_OPACITY_30,
      barActiveColor: COLOR_WHITE,
      pipColor: COLOR_WHITE_OPACITY_80,
      pipHoverColor: COLOR_WHITE,
      errorColor: COLOR_WHITE
    }
  },
  {
    schemeName: "whiteOnBordeaux",
    scheme: {
      knobColor: COLOR_BORDEAUX,
      knobHoverColor: COLOR_BORDEAUX,
      knobBorderColor: COLOR_WHITE,
      knobBorderHoverColor: COLOR_WHITE,
      barColor: COLOR_WHITE_OPACITY_30,
      barActiveColor: COLOR_WHITE,
      pipColor: COLOR_WHITE_OPACITY_80,
      pipHoverColor: COLOR_WHITE,
      errorColor: COLOR_WHITE
    }
  },
  {
    schemeName: "bordeauxOnLimeyellow",
    scheme: {
      knobColor: COLOR_LIMEYELLOW,
      knobHoverColor: COLOR_LIMEYELLOW,
      knobBorderColor: COLOR_BORDEAUX,
      knobBorderHoverColor: COLOR_BORDEAUX,
      barColor: COLOR_DARKGREY_OPACITY_30,
      barActiveColor: COLOR_BORDEAUX,
      pipColor: COLOR_DARKGREY,
      pipHoverColor: COLOR_BLACK,
      errorColor: COLOR_BORDEAUX
    }
  }
];
export const SWITCH_TOGGLE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "turquoise",
    scheme: {
      labelColor: COLOR_DARKGREY,
      uncheckedColor: COLOR_MIDDLEGREY,
      errorColor: COLOR_BORDEAUX,
      disabledUncheckedColor: COLOR_MIDDLEGREY_OPACITY_60,
      disabledLabelColor: COLOR_DARKGREY_OPACITY_60
    }
  },
  {
    schemeName: "red",
    scheme: {
      labelColor: COLOR_DARKGREY,
      uncheckedColor: COLOR_MIDDLEGREY,
      errorColor: COLOR_BORDEAUX,
      disabledUncheckedColor: COLOR_MIDDLEGREY_OPACITY_60,
      disabledLabelColor: COLOR_DARKGREY_OPACITY_60
    }
  },
  {
    schemeName: "inverted",
    scheme: {
      labelColor: COLOR_WHITE,
      uncheckedColor: COLOR_WHITE,
      uncheckedHoverColor: COLOR_WHITE_OPACITY_75,
      focusColor: COLOR_WHITE_OPACITY_75,
      checkedColor: COLOR_WHITE,
      checkedHoverColor: COLOR_WHITE_OPACITY_75,
      errorColor: COLOR_WHITE,
      isInverted: true,
      disabledUncheckedColor: COLOR_WHITE_OPACITY_60,
      disabledCheckedColor: COLOR_WHITE_OPACITY_60,
      disabledLabelColor: COLOR_WHITE_OPACITY_60
    }
  },
  {
    schemeName: "darkgrey",
    scheme: {
      labelColor: COLOR_DARKGREY,
      uncheckedColor: COLOR_DARKGREY,
      uncheckedHoverColor: COLOR_DARKGREY_OPACITY_80,
      focusColor: COLOR_DARKGREY_OPACITY_80,
      checkedColor: COLOR_DARKGREY,
      checkedHoverColor: COLOR_DARKGREY_OPACITY_80,
      errorColor: COLOR_BORDEAUX,
      isInverted: true,
      disabledUncheckedColor: COLOR_DARKGREY_OPACITY_60,
      disabledLabelColor: COLOR_DARKGREY_OPACITY_60
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      labelColor: COLOR_DARKGREY,
      uncheckedColor: COLOR_DARKGREY,
      errorColor: COLOR_BORDEAUX,
      disabledUncheckedColor: COLOR_MIDDLEGREY_OPACITY_60,
      disabledLabelColor: COLOR_DARKGREY_OPACITY_60
    }
  }
];
export const STAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red",
    scheme: {
      subheadlineColor: COLOR_RED
    }
  },
  {
    schemeName: "white"
  }
];
export const STEP_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "redOnLightgrey",
    scheme: {
      activeStepColor: COLOR_RED,
      inactiveStepColor: COLOR_LIGHTGREY_25,
      doneStepColor: COLOR_RED,
      activeStepMobileBorder: COLOR_RED_OPACITY_30,
      inactiveIconColor: COLOR_RED_OPACITY_75,
      activeIconColor: COLOR_LIGHTGREY_25,
      doneIconColor: COLOR_LIGHTGREY_25,
      activeTextColor: COLOR_DARKGREY,
      inactiveTextColor: COLOR_DARKGREY_OPACITY_75,
      doneTextColor: COLOR_DARKGREY_OPACITY_75,
      inactiveStepColorCircleBar: COLOR_RED_50,
      activeStepShadowColorCircleBar: COLOR_RED_OPACITY_25,
      activeStepColorCircleBar: COLOR_RED_ACTIVE,
      doneStepColorCircleBar: COLOR_RED,
      iconColorCircleBar: COLOR_LIGHTGREY,
      errorDoneStepColorCircleBar: COLOR_BORDEAUX,
      errorActiveStepColorCircleBar: COLOR_BORDEAUX_DARK,
      errorActiveStepShadowColorCircleBar: COLOR_BORDEAUX_OPACITY_25,
      tooltipScheme: "bordeaux"
    }
  },
  {
    schemeName: "whiteOnRed",
    scheme: {
      activeStepColor: COLOR_WHITE,
      inactiveStepColor: COLOR_RED_25,
      doneStepColor: COLOR_WHITE,
      activeStepMobileBorder: COLOR_WHITE_OPACITY_30,
      inactiveIconColor: COLOR_RED,
      activeIconColor: COLOR_RED,
      doneIconColor: COLOR_RED,
      activeTextColor: COLOR_WHITE,
      inactiveTextColor: COLOR_RED_25,
      doneTextColor: COLOR_RED_25,
      inactiveStepColorCircleBar: COLOR_RED_50,
      activeStepShadowColorCircleBar: COLOR_TURQUOISE_OPACITY_25,
      activeStepColorCircleBar: COLOR_ULTRALIGHTGREY,
      doneStepColorCircleBar: COLOR_WHITE,
      iconColorCircleBar: COLOR_RED,
      errorDoneStepColorCircleBar: COLOR_WHITE,
      errorActiveStepColorCircleBar: COLOR_WHITE,
      errorActiveStepShadowColorCircleBar: COLOR_WHITE_OPACITY_25,
      tooltipScheme: "white"
    }
  },
  {
    schemeName: "whiteOnBordeaux",
    scheme: {
      activeStepColor: COLOR_WHITE,
      inactiveStepColor: COLOR_BORDEAUX_25,
      doneStepColor: COLOR_WHITE,
      activeStepMobileBorder: COLOR_WHITE_OPACITY_30,
      inactiveIconColor: COLOR_BORDEAUX,
      activeIconColor: COLOR_BORDEAUX,
      doneIconColor: COLOR_BORDEAUX,
      activeTextColor: COLOR_WHITE,
      inactiveTextColor: COLOR_BORDEAUX_25,
      doneTextColor: COLOR_BORDEAUX_25,
      inactiveStepColorCircleBar: COLOR_BORDEAUX_50,
      activeStepShadowColorCircleBar: COLOR_WHITE_OPACITY_25,
      activeStepColorCircleBar: COLOR_WHITE,
      doneStepColorCircleBar: COLOR_WHITE,
      iconColorCircleBar: COLOR_BORDEAUX,
      errorDoneStepColorCircleBar: COLOR_WHITE,
      errorActiveStepColorCircleBar: COLOR_WHITE,
      errorActiveStepShadowColorCircleBar: COLOR_WHITE_OPACITY_25,
      tooltipScheme: "white"
    }
  },
  {
    schemeName: "whiteOnTurquoise",
    scheme: {
      activeStepColor: COLOR_WHITE,
      inactiveStepColor: COLOR_TURQUOISE_25,
      doneStepColor: COLOR_WHITE,
      activeStepMobileBorder: COLOR_WHITE_OPACITY_30,
      inactiveIconColor: COLOR_TURQUOISE,
      activeIconColor: COLOR_TURQUOISE,
      doneIconColor: COLOR_TURQUOISE,
      activeTextColor: COLOR_WHITE,
      inactiveTextColor: COLOR_TURQUOISE_25,
      doneTextColor: COLOR_TURQUOISE_25,
      inactiveStepColorCircleBar: COLOR_TURQUOISE_50,
      activeStepShadowColorCircleBar: COLOR_WHITE_OPACITY_25,
      activeStepColorCircleBar: COLOR_WHITE,
      doneStepColorCircleBar: COLOR_WHITE,
      iconColorCircleBar: COLOR_TURQUOISE,
      errorDoneStepColorCircleBar: COLOR_WHITE,
      errorActiveStepColorCircleBar: COLOR_WHITE,
      errorActiveStepShadowColorCircleBar: COLOR_WHITE_OPACITY_25,
      tooltipScheme: "white"
    }
  },
  {
    schemeName: "whiteOnLimeyellow",
    scheme: {
      activeStepColor: COLOR_WHITE,
      inactiveStepColor: COLOR_LIMEYELLOW_25,
      doneStepColor: COLOR_WHITE,
      activeStepMobileBorder: COLOR_WHITE_OPACITY_30,
      inactiveIconColor: COLOR_DARKGREY_OPACITY_75,
      activeIconColor: COLOR_DARKGREY,
      doneIconColor: COLOR_DARKGREY,
      activeTextColor: COLOR_DARKGREY,
      inactiveTextColor: COLOR_DARKGREY_OPACITY_75,
      doneTextColor: COLOR_DARKGREY_OPACITY_75,
      inactiveStepColorCircleBar: COLOR_LIMEYELLOW_50,
      activeStepShadowColorCircleBar: COLOR_WHITE_OPACITY_25,
      activeStepColorCircleBar: COLOR_WHITE,
      doneStepColorCircleBar: COLOR_WHITE,
      iconColorCircleBar: COLOR_LIMEYELLOW,
      errorDoneStepColorCircleBar: COLOR_WHITE,
      errorActiveStepColorCircleBar: COLOR_WHITE,
      errorActiveStepShadowColorCircleBar: COLOR_WHITE_OPACITY_25,
      tooltipScheme: "white"
    }
  },
  {
    schemeName: "greyOnLimeyellow",
    scheme: {
      inactiveStepColorCircleBar: COLOR_DARKGREY_50,
      activeStepShadowColorCircleBar: COLOR_DARKGREY_OPACITY_25,
      activeStepColorCircleBar: COLOR_DARKGREY,
      doneStepColorCircleBar: COLOR_DARKGREY,
      iconColorCircleBar: COLOR_LIMEYELLOW,
      errorDoneStepColorCircleBar: COLOR_BORDEAUX,
      errorActiveStepColorCircleBar: COLOR_BORDEAUX_DARK,
      errorActiveStepShadowColorCircleBar: COLOR_BORDEAUX_OPACITY_25,
      tooltipScheme: "darkgrey"
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      inactiveStepColor: COLOR_DARKGREY_25,
      activeStepMobileBorder: COLOR_TURQUOISE_OPACITY_30,
      inactiveIconColor: COLOR_WHITE,
      activeIconColor: COLOR_WHITE,
      doneIconColor: COLOR_WHITE,
      activeTextColor: COLOR_DARKGREY,
      inactiveTextColor: COLOR_MIDDLEGREY,
      doneTextColor: COLOR_MIDDLEGREY,
      inactiveStepColorCircleBar: COLOR_TURQUOISE_50,
      activeStepShadowColorCircleBar: COLOR_TURQUOISE_OPACITY_25,
      activeStepColorCircleBar: COLOR_TURQUOISE_DARK,
      doneStepColorCircleBar: COLOR_TURQUOISE,
      iconColorCircleBar: COLOR_WHITE,
      errorDoneStepColorCircleBar: COLOR_BORDEAUX,
      errorActiveStepColorCircleBar: COLOR_BORDEAUX_DARK,
      errorActiveStepShadowColorCircleBar: COLOR_BORDEAUX_OPACITY_25,
      tooltipScheme: "turquoiseDark"
    }
  },
  {
    schemeName: "turquoiseOnUltralightgrey",
    scheme: {
      inactiveStepColor: COLOR_DARKGREY_25,
      activeStepMobileBorder: COLOR_TURQUOISE_OPACITY_30,
      inactiveIconColor: COLOR_WHITE,
      activeIconColor: COLOR_WHITE,
      doneIconColor: COLOR_WHITE,
      activeTextColor: COLOR_DARKGREY,
      inactiveTextColor: COLOR_MIDDLEGREY,
      doneTextColor: COLOR_MIDDLEGREY,
      inactiveStepColorCircleBar: COLOR_TURQUOISE_50,
      activeStepShadowColorCircleBar: COLOR_TURQUOISE_OPACITY_25,
      activeStepColorCircleBar: COLOR_TURQUOISE_DARK,
      doneStepColorCircleBar: COLOR_TURQUOISE,
      iconColorCircleBar: COLOR_ULTRALIGHTGREY,
      errorDoneStepColorCircleBar: COLOR_BORDEAUX,
      errorActiveStepColorCircleBar: COLOR_BORDEAUX_DARK,
      errorActiveStepShadowColorCircleBar: COLOR_BORDEAUX_OPACITY_25,
      tooltipScheme: "turquoiseDark"
    }
  },
  {
    schemeName: "turquoiseOnLightgrey",
    scheme: {
      inactiveStepColorCircleBar: COLOR_TURQUOISE_50,
      activeStepShadowColorCircleBar: COLOR_TURQUOISE_OPACITY_25,
      activeStepColorCircleBar: COLOR_TURQUOISE_DARK,
      doneStepColorCircleBar: COLOR_TURQUOISE,
      iconColorCircleBar: COLOR_LIGHTGREY,
      errorDoneStepColorCircleBar: COLOR_BORDEAUX,
      errorActiveStepColorCircleBar: COLOR_BORDEAUX_DARK,
      errorActiveStepShadowColorCircleBar: COLOR_BORDEAUX_OPACITY_25,
      tooltipScheme: "turquoiseDark"
    }
  },
  {
    schemeName: "redOnWhite",
    scheme: {
      inactiveStepColorCircleBar: COLOR_RED_50,
      activeStepShadowColorCircleBar: COLOR_RED_OPACITY_25,
      activeStepColorCircleBar: COLOR_BORDEAUX_ACTIVE,
      doneStepColorCircleBar: COLOR_RED,
      iconColorCircleBar: COLOR_WHITE,
      errorDoneStepColorCircleBar: COLOR_BORDEAUX,
      errorActiveStepColorCircleBar: COLOR_BORDEAUX_DARK,
      errorActiveStepShadowColorCircleBar: COLOR_BORDEAUX_OPACITY_25,
      tooltipScheme: "bordeaux"
    }
  },
  {
    schemeName: "redOnUltralightgrey",
    scheme: {
      inactiveStepColorCircleBar: COLOR_RED_50,
      activeStepShadowColorCircleBar: COLOR_RED_OPACITY_25,
      activeStepColorCircleBar: COLOR_BORDEAUX_ACTIVE,
      doneStepColorCircleBar: COLOR_RED,
      iconColorCircleBar: COLOR_ULTRALIGHTGREY,
      errorDoneStepColorCircleBar: COLOR_BORDEAUX,
      errorActiveStepColorCircleBar: COLOR_BORDEAUX_DARK,
      errorActiveStepShadowColorCircleBar: COLOR_BORDEAUX_OPACITY_25,
      tooltipScheme: "bordeaux"
    }
  }
];
export const STEPS_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "turquoise",
    scheme: {
      inactiveSeparatorColor: COLOR_DARKGREY_25
    }
  },
  {
    schemeName: "whiteOnRed",
    scheme: {
      activeSeparatorColor: COLOR_WHITE,
      inactiveSeparatorColor: COLOR_RED_25
    }
  },
  {
    schemeName: "whiteOnBordeaux",
    scheme: {
      activeSeparatorColor: COLOR_WHITE,
      inactiveSeparatorColor: COLOR_BORDEAUX_25
    }
  },
  {
    schemeName: "whiteOnTurquoise",
    scheme: {
      activeSeparatorColor: COLOR_WHITE,
      inactiveSeparatorColor: COLOR_TURQUOISE_25
    }
  },
  {
    schemeName: "whiteOnLimeyellow",
    scheme: {
      activeSeparatorColor: COLOR_WHITE,
      inactiveSeparatorColor: COLOR_LIMEYELLOW_25
    }
  },
  {
    schemeName: "redOnLightgrey",
    scheme: {
      activeSeparatorColor: COLOR_RED,
      inactiveSeparatorColor: COLOR_LIGHTGREY_25
    }
  },
  {
    schemeName: "greyOnLimeyellow",
    scheme: {}
  },
  {
    schemeName: "turquoiseOnUltralightgrey",
    scheme: {}
  },
  {
    schemeName: "turquoiseOnLightgrey",
    scheme: {}
  },
  {
    schemeName: "redOnWhite",
    scheme: {}
  },
  {
    schemeName: "redOnUltralightgrey",
    scheme: {}
  }
];
export const TABLE_RENDERER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "whiteRedHighlighting",
    scheme: {
      paragraphColor: COLOR_DARKGREY,
      tableBorderColor: COLOR_DARKGREY,
      tableHighlightColor: COLOR_RED,
      tableBackgroundColor: COLOR_WHITE,
      tableAlternateBackgroundColor: COLOR_ULTRALIGHTGREY
    }
  },
  {
    schemeName: "whiteTurquoiseHighlighting",
    scheme: {
      paragraphColor: COLOR_DARKGREY,
      tableBorderColor: COLOR_DARKGREY,
      tableHighlightColor: COLOR_TURQUOISE,
      tableBackgroundColor: COLOR_WHITE,
      tableAlternateBackgroundColor: COLOR_ULTRALIGHTGREY
    }
  },
  {
    schemeName: "lightgreyRedHighlighting",
    scheme: {
      paragraphColor: COLOR_DARKGREY,
      tableBorderColor: COLOR_DARKGREY,
      tableHighlightColor: COLOR_RED,
      tableBackgroundColor: COLOR_LIGHTGREY,
      tableAlternateBackgroundColor: COLOR_ULTRALIGHTGREY
    }
  },
  {
    schemeName: "lightgreyTurquoiseHighlighting",
    scheme: {
      paragraphColor: COLOR_DARKGREY,
      tableBorderColor: COLOR_DARKGREY,
      tableHighlightColor: COLOR_TURQUOISE,
      tableBackgroundColor: COLOR_LIGHTGREY,
      tableAlternateBackgroundColor: COLOR_ULTRALIGHTGREY
    }
  },
  {
    schemeName: "ultralightgreyRedHighlighting",
    scheme: {
      paragraphColor: COLOR_DARKGREY,
      tableBorderColor: COLOR_DARKGREY,
      tableHighlightColor: COLOR_RED,
      tableBackgroundColor: COLOR_ULTRALIGHTGREY,
      tableAlternateBackgroundColor: COLOR_LIGHTGREY
    }
  },
  {
    schemeName: "ultralightgreyTurquoiseHighlighting",
    scheme: {
      paragraphColor: COLOR_DARKGREY,
      tableBorderColor: COLOR_DARKGREY,
      tableHighlightColor: COLOR_TURQUOISE,
      tableBackgroundColor: COLOR_ULTRALIGHTGREY,
      tableAlternateBackgroundColor: COLOR_ULTRALIGHTGREY
    }
  },
  {
    schemeName: "red",
    scheme: {
      paragraphColor: COLOR_WHITE,
      tableBorderColor: COLOR_WHITE,
      tableHighlightColor: COLOR_LIMEYELLOW,
      tableBackgroundColor: COLOR_RED,
      tableAlternateBackgroundColor: COLOR_RED_ACTIVE
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      paragraphColor: COLOR_WHITE,
      tableBorderColor: COLOR_WHITE,
      tableHighlightColor: COLOR_LIMEYELLOW,
      tableBackgroundColor: COLOR_BORDEAUX,
      tableAlternateBackgroundColor: COLOR_BORDEAUX_ACTIVE
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      paragraphColor: COLOR_WHITE,
      tableBorderColor: COLOR_WHITE,
      tableHighlightColor: COLOR_LIMEYELLOW,
      tableBackgroundColor: COLOR_TURQUOISE,
      tableAlternateBackgroundColor: COLOR_TURQUOISE_ACTIVE
    }
  },
  {
    schemeName: "limeyellow",
    scheme: {
      paragraphColor: COLOR_DARKGREY,
      tableBorderColor: COLOR_DARKGREY,
      tableHighlightColor: COLOR_BORDEAUX,
      tableBackgroundColor: COLOR_LIMEYELLOW,
      tableAlternateBackgroundColor: COLOR_LIMEYELLOW_ACTIVE
    }
  }
];
export const TABS_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      textColor: COLOR_DARKGREY,
      tabBorderColor: COLOR_DARK_TABBAR_COLOR,
      tabActiveBorderColor: COLOR_DARKGREY,
      tabHoverColor: COLOR_ULTRALIGHTGREY,
      tabFocusColor: COLOR_ULTRALIGHTGREY
    }
  },
  {
    schemeName: "lightgrey",
    scheme: {
      textColor: COLOR_DARKGREY,
      tabBorderColor: COLOR_DARK_TABBAR_COLOR,
      tabActiveBorderColor: COLOR_DARKGREY,
      tabHoverColor: COLOR_LIGHTGREY_ACTIVE,
      tabFocusColor: COLOR_LIGHTGREY_ACTIVE
    }
  },
  {
    schemeName: "ultralightgrey",
    scheme: {
      textColor: COLOR_DARKGREY,
      tabBorderColor: COLOR_DARK_TABBAR_COLOR,
      tabActiveBorderColor: COLOR_DARKGREY,
      tabHoverColor: COLOR_LIGHTGREY,
      tabFocusColor: COLOR_LIGHTGREY
    }
  },
  {
    schemeName: "red",
    scheme: {
      textColor: COLOR_WHITE,
      tabBorderColor: COLOR_WHITE_TABBAR_COLOR,
      tabActiveBorderColor: COLOR_WHITE,
      tabHoverColor: COLOR_RED_ACTIVE,
      tabFocusColor: COLOR_RED_ACTIVE
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      textColor: COLOR_WHITE,
      tabBorderColor: COLOR_WHITE_TABBAR_COLOR,
      tabActiveBorderColor: COLOR_WHITE,
      tabHoverColor: COLOR_TURQUOISE_ACTIVE,
      tabFocusColor: COLOR_TURQUOISE_ACTIVE
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      textColor: COLOR_WHITE,
      tabBorderColor: COLOR_WHITE_TABBAR_COLOR,
      tabActiveBorderColor: COLOR_WHITE,
      tabHoverColor: COLOR_BORDEAUX_ACTIVE,
      tabFocusColor: COLOR_BORDEAUX_ACTIVE
    }
  },
  {
    schemeName: "limeyellow",
    scheme: {
      textColor: COLOR_DARKGREY,
      tabBorderColor: COLOR_DARK_TABBAR_COLOR,
      tabActiveBorderColor: COLOR_DARKGREY,
      tabHoverColor: COLOR_LIMEYELLOW_ACTIVE,
      tabFocusColor: COLOR_LIMEYELLOW_ACTIVE
    }
  }
];
export const TAG_PILL_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red",
    scheme: {
      backgroundHoverColor: COLOR_RED_25,
      backgroundActiveHoverColor: COLOR_RED_ACTIVE,
      textAndIconHoverColor: COLOR_RED_ACTIVE,
      textAndIconActiveColor: COLOR_WHITE,
      textAndIconActiveHoverColor: COLOR_WHITE,
      borderColor: COLOR_RED_25
    }
  },
  {
    schemeName: "whiteOnRed",
    scheme: {
      backgroundHoverColor: COLOR_WHITE_OPACITY_50,
      backgroundActiveColor: COLOR_WHITE,
      backgroundActiveHoverColor: COLOR_WHITE_OPACITY_85,
      textAndIconColor: COLOR_WHITE,
      textAndIconHoverColor: COLOR_WHITE,
      textAndIconActiveColor: COLOR_RED,
      textAndIconActiveHoverColor: COLOR_RED_ACTIVE,
      borderColor: COLOR_WHITE_OPACITY_50,
      focusBorderColor: COLOR_WHITE_OPACITY_75
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      backgroundHoverColor: COLOR_TURQUOISE_25,
      backgroundActiveHoverColor: COLOR_TURQUOISE_ACTIVE,
      textAndIconHoverColor: COLOR_TURQUOISE_ACTIVE,
      textAndIconActiveColor: COLOR_WHITE,
      textAndIconActiveHoverColor: COLOR_WHITE,
      borderColor: COLOR_TURQUOISE_25
    }
  },
  {
    schemeName: "whiteOnTurquoise",
    scheme: {
      backgroundHoverColor: COLOR_WHITE_OPACITY_50,
      backgroundActiveColor: COLOR_WHITE,
      backgroundActiveHoverColor: COLOR_WHITE_OPACITY_85,
      textAndIconColor: COLOR_WHITE,
      textAndIconHoverColor: COLOR_WHITE,
      textAndIconActiveColor: COLOR_TURQUOISE,
      textAndIconActiveHoverColor: COLOR_TURQUOISE_ACTIVE,
      borderColor: COLOR_WHITE_OPACITY_50,
      focusBorderColor: COLOR_WHITE_OPACITY_75
    }
  },
  {
    schemeName: "whiteOnBordeaux",
    scheme: {
      backgroundHoverColor: COLOR_WHITE_OPACITY_50,
      backgroundActiveColor: COLOR_WHITE,
      backgroundActiveHoverColor: COLOR_WHITE_OPACITY_85,
      textAndIconColor: COLOR_WHITE,
      textAndIconHoverColor: COLOR_WHITE,
      textAndIconActiveColor: COLOR_BORDEAUX,
      textAndIconActiveHoverColor: COLOR_BORDEAUX_ACTIVE,
      borderColor: COLOR_WHITE_OPACITY_50,
      focusBorderColor: COLOR_WHITE_OPACITY_75
    }
  },
  {
    schemeName: "darkgrey",
    scheme: {
      backgroundHoverColor: COLOR_DARKGREY_OPACITY_10,
      backgroundActiveHoverColor: COLOR_DARKGREY_OPACITY_80,
      textAndIconHoverColor: COLOR_DARKGREY_OPACITY_80,
      textAndIconActiveColor: COLOR_WHITE,
      textAndIconActiveHoverColor: COLOR_WHITE,
      borderColor: COLOR_DARKGREY_OPACITY_10
    }
  }
];
export const TEXT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white"
  },
  {
    schemeName: "darkgrey"
  },
  {
    schemeName: "red"
  }
];
export const TEXT_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      valueTextColor: COLOR_RED,
      contentColor: COLOR_DARKGREY,
      contentBackgroundColor: COLOR_WHITE
    }
  },
  {
    schemeName: "ultralightgrey",
    scheme: {
      valueTextColor: COLOR_RED,
      contentColor: COLOR_DARKGREY,
      contentBackgroundColor: COLOR_ULTRALIGHTGREY
    }
  },
  {
    schemeName: "lightgrey",
    scheme: {
      valueTextColor: COLOR_RED,
      contentColor: COLOR_DARKGREY,
      contentBackgroundColor: COLOR_LIGHTGREY
    }
  },
  {
    schemeName: "red",
    scheme: {
      valueTextColor: COLOR_WHITE,
      contentColor: COLOR_WHITE,
      contentBackgroundColor: COLOR_RED
    }
  },
  {
    schemeName: "limeyellow",
    scheme: {
      valueTextColor: COLOR_BORDEAUX,
      contentColor: COLOR_DARKGREY,
      contentBackgroundColor: COLOR_LIMEYELLOW
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      valueTextColor: COLOR_WHITE,
      contentColor: COLOR_WHITE,
      contentBackgroundColor: COLOR_BORDEAUX
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      valueTextColor: COLOR_WHITE,
      contentColor: COLOR_WHITE,
      contentBackgroundColor: COLOR_TURQUOISE
    }
  },
  {
    schemeName: "turquoiseDark",
    scheme: {
      valueTextColor: COLOR_WHITE,
      contentColor: COLOR_WHITE,
      contentBackgroundColor: COLOR_TURQUOISE_DARK
    }
  },
  {
    schemeName: "bordeauxDark",
    scheme: {
      valueTextColor: COLOR_WHITE,
      contentColor: COLOR_WHITE,
      contentBackgroundColor: COLOR_BORDEAUX_DARK
    }
  },
  {
    schemeName: "limeyellowActive",
    scheme: {
      valueTextColor: COLOR_BORDEAUX,
      contentColor: COLOR_DARKGREY,
      contentBackgroundColor: COLOR_LIMEYELLOW_ACTIVE
    }
  }
];
export const THIRD_LEVEL_NAVIGATION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bordeaux",
    scheme: {
      tabBorderColor: COLOR_WHITE_TABBAR_COLOR,
      tabActiveBorderColor: COLOR_WHITE
    }
  },
  {
    schemeName: "limeyellow",
    scheme: {
      tabBorderColor: COLOR_DARK_TABBAR_COLOR,
      tabActiveBorderColor: COLOR_BORDEAUX
    }
  },
  {
    schemeName: "red",
    scheme: {
      tabBorderColor: COLOR_WHITE_TABBAR_COLOR,
      tabActiveBorderColor: COLOR_WHITE
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      tabBorderColor: COLOR_WHITE_TABBAR_COLOR,
      tabActiveBorderColor: COLOR_WHITE
    }
  },
  {
    schemeName: "ultralightgrey",
    scheme: {
      tabBorderColor: COLOR_LIGHTGREY,
      tabActiveBorderColor: COLOR_RED
    }
  }
];
export const THIRD_LEVEL_NAVIGATION_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bordeaux",
    scheme: {
      tabHoverBorderColor: COLOR_WHITE_TABBAR_COLOR,
      tabHoverColor: COLOR_BORDEAUX_ACTIVE
    }
  },
  {
    schemeName: "limeyellow",
    scheme: {
      tabHoverBorderColor: COLOR_DARK_TABBAR_COLOR,
      tabHoverColor: COLOR_LIMEYELLOW_ACTIVE
    }
  },
  {
    schemeName: "red",
    scheme: {
      tabHoverBorderColor: COLOR_WHITE_TABBAR_COLOR,
      tabHoverColor: COLOR_RED_ACTIVE
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      tabHoverBorderColor: COLOR_WHITE_TABBAR_COLOR,
      tabHoverColor: COLOR_TURQUOISE_ACTIVE
    }
  },
  {
    schemeName: "ultralightgrey",
    scheme: {
      textColor: COLOR_MIDDLEGREY_ACTIVE,
      tabHoverBorderColor: COLOR_LIGHTGREY,
      tabHoverColor: COLOR_LIGHTGREY
    }
  }
];
export const TILES_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red",
    scheme: {
      backgroundColor: COLOR_RED,
      hoverBackgroundColor: COLOR_RED_ACTIVE
    }
  },
  {
    schemeName: "white",
    scheme: {
      backgroundColor: COLOR_WHITE,
      hoverBackgroundColor: COLOR_ULTRALIGHTGREY,
      hoverColor: COLOR_RED
    }
  },
  {
    schemeName: "bordeaux",
    scheme: {
      backgroundColor: COLOR_BORDEAUX,
      hoverBackgroundColor: COLOR_BORDEAUX_ACTIVE
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      backgroundColor: COLOR_TURQUOISE,
      hoverBackgroundColor: COLOR_TURQUOISE_ACTIVE
    }
  },
  {
    schemeName: "limeyellow",
    scheme: {
      backgroundColor: COLOR_LIMEYELLOW,
      hoverBackgroundColor: COLOR_LIMEYELLOW_ACTIVE,
      hoverColor: COLOR_BORDEAUX
    }
  }
];
export const TOOLTIP_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "darkgrey"
  },
  {
    schemeName: "ultralightgrey"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "turquoise"
  },
  {
    schemeName: "turquoiseDark",
    scheme: {
      backgroundColor: COLOR_TURQUOISE_DARK,
      innerContentColor: COLOR_WHITE
    }
  },
  {
    schemeName: "red"
  },
  {
    schemeName: "bordeaux"
  },
  {
    schemeName: "bordeauxDark",
    scheme: {
      backgroundColor: COLOR_BORDEAUX_DARK,
      innerContentColor: COLOR_WHITE
    }
  }
];
export const VIDEOPLAYER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red"
  },
  {
    schemeName: "white",
    scheme: {
      playButtonColor: COLOR_RED
    }
  }
];
export const VIOLATOR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red"
  },
  {
    schemeName: "bordeaux"
  },
  {
    schemeName: "limeyellow"
  },
  {
    schemeName: "turquoise"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "black"
  }
];

export interface AccordionSchemeConfiguration<T> {
  whiteRed?: T;
  whiteRedOnLightgrey?: T;
  whiteRedOnUltralightgrey?: T;
  whiteTurquoise?: T;
  whiteTurquoiseOnLightgrey?: T;
  whiteTurquoiseOnUltralightgrey?: T;
  red?: T;
  turquoise?: T;
  bordeaux?: T;
  limeyellow?: T;
}
export interface AnswerCardSchemeConfiguration<T> {
  white?: T;
  red?: T;
  turquoise?: T;
  bordeaux?: T;
  limeyellow?: T;
  darkgrey?: T;
  middlegrey?: T;
}
export interface BadgeSchemeConfiguration<T> {
  white?: T;
  darkgrey?: T;
}
export interface BreadcrumbSchemeConfiguration<T> {
  darkgrey?: T;
  white?: T;
}
export interface BottomDrawerSchemeConfiguration<T> {
  red?: T;
  turquoise?: T;
  bordeaux?: T;
  limeyellow?: T;
}
export interface BulletListSchemeConfiguration<T> {
  white?: T;
  darkgrey?: T;
  darkgreyOnLimeyellow?: T;
  whiteOnBordeaux?: T;
}
export interface BulletListDeprecatedSchemeConfiguration<T> {
  white?: T;
  darkgrey?: T;
}
export interface BusinesscardAuthorSchemeConfiguration<T> {
  white?: T;
  red?: T;
  turquoise?: T;
  bordeaux?: T;
  darkgrey?: T;
}
export interface BusinesscardContactSchemeConfiguration<T> {
  white?: T;
  red?: T;
  limeyellow?: T;
  limeyellowActive?: T;
  ultralightgrey?: T;
  lightgrey?: T;
  bordeaux?: T;
  bordeauxDark?: T;
  turquoise?: T;
  turquoiseDark?: T;
}
export interface BoxSchemeConfiguration<T> {
  white?: T;
  red?: T;
  bordeaux?: T;
  turquoise?: T;
  lightgrey?: T;
  limeyellow?: T;
  darkgrey?: T;
}
export interface ButtonSchemeConfiguration<T> {
  red?: T;
  redOnLightgrey?: T;
  redOnUltralightgrey?: T;
  turquoise?: T;
  bordeaux?: T;
  redInverted?: T;
  turquoiseInverted?: T;
  bordeauxInverted?: T;
  discreet?: T;
  discreetDark?: T;
  darkgreyCarrier?: T;
}
export interface CaptionSchemeConfiguration<T> {
  white?: T;
  redActive?: T;
  turquoiseActive?: T;
  bordeauxActive?: T;
  limeyellowActive?: T;
  ultralightgreyActive?: T;
}
export interface CardTeaserSchemeConfiguration<T> {
  white?: T;
  whiteOnLightgrey?: T;
  whiteOnLimeyellow?: T;
  ultralightgrey?: T;
  lightgrey?: T;
  red?: T;
  limeyellow?: T;
  bordeaux?: T;
  bordeauxDark?: T;
  turquoise?: T;
  turquoiseDark?: T;
}
export interface CarouselSchemeConfiguration<T> {
  turquoise?: T;
  turquoiseInverted?: T;
  red?: T;
  redInverted?: T;
  bordeaux?: T;
  bordeauxInverted?: T;
  darkgrey?: T;
}
export interface CheckboxSchemeConfiguration<T> {
  turquoise?: T;
  red?: T;
  inverted?: T;
  darkgrey?: T;
}
export interface ClickableImageSchemeConfiguration<T> {
  turquoise?: T;
  red?: T;
  bordeaux?: T;
  white?: T;
}
export interface CompassSchemeConfiguration<T> {
  ultralightgrey?: T;
  white?: T;
}
export interface ContactBarSchemeConfiguration<T> {
  white?: T;
  darkgrey?: T;
}
export interface ContactLayerSchemeConfiguration<T> {
  red?: T;
  turquoise?: T;
  limeyellow?: T;
  bordeaux?: T;
  white?: T;
  ultralightgrey?: T;
  lightgrey?: T;
  turquoiseDark?: T;
  bordeauxDark?: T;
}
export interface ContactListSchemeConfiguration<T> {
  white?: T;
  darkgrey?: T;
}
export interface ContentAggregatorSchemeConfiguration<T> {
  red?: T;
  redInverted?: T;
  bordeaux?: T;
  bordeauxInverted?: T;
  turquoise?: T;
  turquoiseInverted?: T;
  darkgrey?: T;
}
export interface ContentAggregatorItemSchemeConfiguration<T> {
  white?: T;
  whiteOnTurquoise?: T;
  whiteOnRed?: T;
  whiteOnBordeaux?: T;
  whiteOnLimeyellow?: T;
  ultralightgrey?: T;
  lightgrey?: T;
  red?: T;
  limeyellow?: T;
  bordeaux?: T;
  turquoise?: T;
}
export interface ContextMenuSchemeConfiguration<T> {
  white?: T;
}
export interface ContextMenuItemSchemeConfiguration<T> {
  white?: T;
}
export interface DateEventSchemeConfiguration<T> {
  white?: T;
  darkgrey?: T;
}
export interface DividerSchemeConfiguration<T> {
  red?: T;
  turquoise?: T;
  limeyellow?: T;
  bordeaux?: T;
  white?: T;
  ultralightgrey?: T;
  lightgrey?: T;
  darkgrey?: T;
}
export interface DropdownSchemeConfiguration<T> {
  turquoise?: T;
  turquoiseOnUltralightgrey?: T;
  turquoiseOnLightgrey?: T;
  whiteOnRed?: T;
  whiteOnTurquoise?: T;
  whiteOnBordeaux?: T;
  darkgreyOnLimeyellow?: T;
}
export interface DropdownOptionSchemeConfiguration<T> {
  turquoise?: T;
}
export interface ErrorMessageSchemeConfiguration<T> {
  turquoiseDark?: T;
  bordeaux?: T;
  limeyellow?: T;
}
export interface FileUploadSchemeConfiguration<T> {
  whiteOnRed?: T;
  lightgreyOnWhite?: T;
  turquoiseOnYellow?: T;
  whiteOnTurquoise?: T;
  whiteOnBordeaux?: T;
  turquoiseOnLightgrey?: T;
  turquoiseOnUltralightgrey?: T;
}
export interface FilePreviewSchemeConfiguration<T> {
  red?: T;
  white?: T;
}
export interface FormMessageSchemeConfiguration<T> {
  standard?: T;
  white?: T;
  darkgrey?: T;
}
export interface HeadlineSchemeConfiguration<T> {
  white?: T;
  red?: T;
  bordeaux?: T;
  turquoise?: T;
  darkgrey?: T;
}
export interface IconSchemeConfiguration<T> {
  white?: T;
  red?: T;
  turquoise?: T;
  bordeaux?: T;
  limeyellow?: T;
  limeyellowLight?: T;
  darkgrey?: T;
  middlegrey?: T;
}
export interface InfoIconSchemeConfiguration<T> {
  red?: T;
  white?: T;
  turquoise?: T;
  bordeaux?: T;
  darkgrey?: T;
  middlegrey?: T;
}
export interface InputSchemeConfiguration<T> {
  turquoise?: T;
  turquoiseOnUltralightgrey?: T;
  turquoiseOnLightgrey?: T;
  whiteOnRed?: T;
  whiteOnTurquoise?: T;
  whiteOnBordeaux?: T;
  darkgreyOnLimeyellow?: T;
}
export interface LinkSchemeConfiguration<T> {
  red?: T;
  turquoise?: T;
  white?: T;
  bordeaux?: T;
  darkgrey?: T;
}
export interface LinklistSchemeConfiguration<T> {
  red?: T;
  turquoise?: T;
  white?: T;
  bordeaux?: T;
  darkgrey?: T;
}
export interface MapInfoLayerSchemeConfiguration<T> {
  white?: T;
  limeyellow?: T;
  red?: T;
  bordeaux?: T;
  turquoise?: T;
}
export interface MultiContentStageSchemeConfiguration<T> {
  red?: T;
  turquoise?: T;
  ultralightgrey?: T;
  limeyellow?: T;
  bordeaux?: T;
  white?: T;
}
export interface NumberSchemeConfiguration<T> {
  white?: T;
  darkgrey?: T;
  red?: T;
  bordeaux?: T;
  turquoise?: T;
}
export interface OffsetTeaserSchemeConfiguration<T> {
  white?: T;
  whiteOnLightgrey?: T;
  whiteOnLimeyellow?: T;
  ultralightgrey?: T;
  lightgrey?: T;
  red?: T;
  limeyellow?: T;
  limeyellowActive?: T;
  bordeaux?: T;
  bordeauxDark?: T;
  turquoise?: T;
  turquoiseDark?: T;
  whiteOnTurquoise?: T;
}
export interface OffsetTeaser5SchemeConfiguration<T> {
  white?: T;
  whiteOnLightgrey?: T;
  whiteOnLimeyellow?: T;
  ultralightgrey?: T;
  lightgrey?: T;
  red?: T;
  limeyellow?: T;
  limeyellowActive?: T;
  bordeaux?: T;
  bordeauxDark?: T;
  turquoise?: T;
  turquoiseDark?: T;
}
export interface PreloaderCircleSchemeConfiguration<T> {
  colorful?: T;
  red?: T;
  turquoise?: T;
  darkgrey?: T;
  bordeaux?: T;
  white?: T;
}
export interface PreloaderSquaresSchemeConfiguration<T> {
  red?: T;
  turquoise?: T;
  darkgrey?: T;
  bordeaux?: T;
  white?: T;
}
export interface ProgressCircleSchemeConfiguration<T> {
  red?: T;
  white?: T;
  yellow?: T;
  turquoise?: T;
  bordeaux?: T;
  lightgrey?: T;
  ultralightgrey?: T;
}
export interface PromoFlagSchemeConfiguration<T> {
  white?: T;
  ultralightgrey?: T;
  limeyellow?: T;
  turquoise?: T;
  red?: T;
  bordeaux?: T;
  bordeauxDark?: T;
  turquoiseDark?: T;
}
export interface PageHeaderSchemeConfiguration<T> {
  red?: T;
  turquoise?: T;
  bordeaux?: T;
  limeyellow?: T;
  white?: T;
  ultralightgrey?: T;
  lightgrey?: T;
}
export interface PictogramSchemeConfiguration<T> {
  white?: T;
  red?: T;
  turquoise?: T;
  bordeaux?: T;
  limeyellow?: T;
  darkgrey?: T;
  middlegrey?: T;
}
export interface RadioButtonSchemeConfiguration<T> {
  turquoise?: T;
  red?: T;
  inverted?: T;
  darkgrey?: T;
}
export interface ReadMoreSchemeConfiguration<T> {
  darkgreyOnWhite?: T;
  darkgreyOnUltralightgrey?: T;
  darkgreyOnLightgrey?: T;
  whiteOnRed?: T;
  whiteOnBordeaux?: T;
  whiteOnTurquoise?: T;
  darkgreyOnLimeyellow?: T;
}
export interface RteRendererSchemeConfiguration<T> {
  bordeaux?: T;
  red?: T;
  darkgrey?: T;
  turquoise?: T;
  white?: T;
}
export interface SectionSchemeConfiguration<T> {
  white?: T;
  lightgrey?: T;
  ultralightgrey?: T;
  red?: T;
  limeyellow?: T;
  bordeaux?: T;
  turquoise?: T;
  transparent?: T;
}
export interface SearchResultItemSchemeConfiguration<T> {
  white?: T;
  white75?: T;
  ultralightgrey?: T;
  whiteWithLightGreyDescription?: T;
  whiteWithUltralightGreyDescription?: T;
}
export interface SitelinkSchemeConfiguration<T> {
  whiteRed?: T;
  whiteRedOnLightgrey?: T;
  whiteRedOnUltralightgrey?: T;
  whiteTurquoise?: T;
  whiteTurquoiseOnLightgrey?: T;
  whiteTurquoiseOnUltralightgrey?: T;
  red?: T;
  turquoise?: T;
  bordeaux?: T;
  limeyellow?: T;
}
export interface SliderSchemeConfiguration<T> {
  turquoise?: T;
  red?: T;
  darkgreyOnLimeyellow?: T;
  whiteOnTurquoise?: T;
  whiteOnRed?: T;
  whiteOnBordeaux?: T;
  bordeauxOnLimeyellow?: T;
}
export interface SwitchToggleSchemeConfiguration<T> {
  turquoise?: T;
  red?: T;
  inverted?: T;
  darkgrey?: T;
  bordeaux?: T;
}
export interface StageSchemeConfiguration<T> {
  red?: T;
  white?: T;
}
export interface StepSchemeConfiguration<T> {
  redOnLightgrey?: T;
  whiteOnRed?: T;
  whiteOnBordeaux?: T;
  whiteOnTurquoise?: T;
  whiteOnLimeyellow?: T;
  greyOnLimeyellow?: T;
  turquoise?: T;
  turquoiseOnUltralightgrey?: T;
  turquoiseOnLightgrey?: T;
  redOnWhite?: T;
  redOnUltralightgrey?: T;
}
export interface StepsSchemeConfiguration<T> {
  turquoise?: T;
  whiteOnRed?: T;
  whiteOnBordeaux?: T;
  whiteOnTurquoise?: T;
  whiteOnLimeyellow?: T;
  redOnLightgrey?: T;
  greyOnLimeyellow?: T;
  turquoiseOnUltralightgrey?: T;
  turquoiseOnLightgrey?: T;
  redOnWhite?: T;
  redOnUltralightgrey?: T;
}
export interface TableRendererSchemeConfiguration<T> {
  whiteRedHighlighting?: T;
  whiteTurquoiseHighlighting?: T;
  lightgreyRedHighlighting?: T;
  lightgreyTurquoiseHighlighting?: T;
  ultralightgreyRedHighlighting?: T;
  ultralightgreyTurquoiseHighlighting?: T;
  red?: T;
  bordeaux?: T;
  turquoise?: T;
  limeyellow?: T;
}
export interface TabsSchemeConfiguration<T> {
  white?: T;
  lightgrey?: T;
  ultralightgrey?: T;
  red?: T;
  turquoise?: T;
  bordeaux?: T;
  limeyellow?: T;
}
export interface TagPillSchemeConfiguration<T> {
  red?: T;
  whiteOnRed?: T;
  turquoise?: T;
  whiteOnTurquoise?: T;
  whiteOnBordeaux?: T;
  darkgrey?: T;
}
export interface TextSchemeConfiguration<T> {
  white?: T;
  darkgrey?: T;
  red?: T;
}
export interface TextTeaserSchemeConfiguration<T> {
  white?: T;
  ultralightgrey?: T;
  lightgrey?: T;
  red?: T;
  limeyellow?: T;
  bordeaux?: T;
  turquoise?: T;
  turquoiseDark?: T;
  bordeauxDark?: T;
  limeyellowActive?: T;
}
export interface ThirdLevelNavigationSchemeConfiguration<T> {
  bordeaux?: T;
  limeyellow?: T;
  red?: T;
  turquoise?: T;
  ultralightgrey?: T;
}
export interface ThirdLevelNavigationItemSchemeConfiguration<T> {
  bordeaux?: T;
  limeyellow?: T;
  red?: T;
  turquoise?: T;
  ultralightgrey?: T;
}
export interface TilesTeaserSchemeConfiguration<T> {
  red?: T;
  white?: T;
  bordeaux?: T;
  turquoise?: T;
  limeyellow?: T;
}
export interface TooltipSchemeConfiguration<T> {
  darkgrey?: T;
  ultralightgrey?: T;
  white?: T;
  turquoise?: T;
  turquoiseDark?: T;
  red?: T;
  bordeaux?: T;
  bordeauxDark?: T;
}
export interface VideoplayerSchemeConfiguration<T> {
  red?: T;
  white?: T;
}
export interface ViolatorSchemeConfiguration<T> {
  red?: T;
  bordeaux?: T;
  limeyellow?: T;
  turquoise?: T;
  white?: T;
  black?: T;
}
//add Components Color-Variables from colorDefinitions
export const ANCHOR_NAVIGATION_BACKGROUND_COLOR = "eon-anchor-navigation-background-color" as const;
export const ANCHOR_NAVIGATION_BACKGROUND_HOVER_COLOR = "eon-anchor-navigation-background-hover-color" as const;
export const ANCHOR_NAVIGATION_ICON_COLOR = "eon-anchor-navigation-icon-color" as const;
export const ANCHOR_NAVIGATION_ICON_HOVER_COLOR = "eon-anchor-navigation-icon-hover-color" as const;
export const ANCHOR_NAVIGATION_ICON_HIGHLIGHT_COLOR = "eon-anchor-navigation-icon-highlight-color" as const;
export const ANCHOR_NAVIGATION_ITEM_BACKGROUND_COLOR = "eon-anchor-navigation-item-background-color" as const;
export const ANCHOR_NAVIGATION_ITEM_HOVER_COLOR = "eon-anchor-navigation-item-hover-color" as const;
export const ANCHOR_NAVIGATION_LINK_COLOR = "eon-anchor-navigation-link-color" as const;
export const ANCHOR_NAVIGATION_LINK_HOVER_COLOR = "eon-anchor-navigation-link-hover-color" as const;
export const ANCHOR_NAVIGATION_LINK_HIGHLIGHT_COLOR = "eon-anchor-navigation-link-highlight-color" as const;
export const COLOR_SEPARATOR_FIRST_COLOR = "eon-color-separator-first-color" as const;
export const COLOR_SEPARATOR_SECOND_COLOR = "eon-color-separator-second-color" as const;
export const COLOR_SEPARATOR_THIRD_COLOR = "eon-color-separator-third-color" as const;
export const CONTACT_BAR_MODAL_BACKGROUND_COLOR = "eon-contact-bar-modal-background-color" as const;
export const CONTEXT_MENU_ITEM_BACKGROUND_HOVER_COLOR = "eon-context-menu-item-background-hover-color" as const;
export const CONTEXT_MENU_ITEM_BACKGROUND_ACTIVE_COLOR = "eon-context-menu-item-background-active-color" as const;
export const DATA_TABLE_HEAD_CELL_COLOR = "eon-data-table-head-cell-color" as const;
export const DATA_TABLE_HEAD_CELL_ICON_COLOR = "eon-data-table-head-cell-icon-color" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND = "eon-data-table-head-cell-background" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND_HOVER = "eon-data-table-head-cell-background-hover" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND_ACT = "eon-data-table-head-cell-background-act" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND_ACT_HOVER = "eon-data-table-head-cell-background-act-hover" as const;
export const DATA_TABLE_HEAD_CELL_BORDER = "eon-data-table-head-cell-border" as const;
export const DATA_TABLE_HEAD_CELL_BORDER_HOVER = "eon-data-table-head-cell-border-hover" as const;
export const DATA_TABLE_HEAD_CELL_BORDER_ACT = "eon-data-table-head-cell-border-act" as const;
export const DATA_TABLE_HEAD_CELL_BORDER_ACT_HOVER = "eon-data-table-head-cell-border-act-hover" as const;
export const DATA_TABLE_CELL_COLOR = "eon-data-table-cell-color" as const;
export const DATA_TABLE_CELL_ICON_COLOR = "eon-data-table-cell-icon-color" as const;
export const DATA_TABLE_CELL_BACKGROUND = "eon-data-table-cell-background" as const;
export const DATA_TABLE_CELL_BACKGROUND_HOVER = "eon-data-table-cell-background-hover" as const;
export const DATA_TABLE_CELL_BACKGROUND_SELECTED = "eon-data-table-cell-background-selected" as const;
export const DATA_TABLE_CELL_BACKGROUND_SELECTED_HOVER = "eon-data-table-cell-background-selected-hover" as const;
export const DATA_TABLE_CELL_BACKGROUND_ODD = "eon-data-table-cell-background-odd" as const;
export const DATA_TABLE_CELL_BACKGROUND_ODD_HOVER = "eon-data-table-cell-background-odd-hover" as const;
export const DATA_TABLE_CELL_BACKGROUND_EVEN = "eon-data-table-cell-background-even" as const;
export const DATA_TABLE_CELL_BACKGROUND_EVEN_HOVER = "eon-data-table-cell-background-even-hover" as const;
export const DATA_TABLE_CELL_BORDER = "eon-data-table-cell-border" as const;
export const DATA_TABLE_CELL_BORDER_HOVER = "eon-data-table-cell-border-hover" as const;
export const DATA_TABLE_CELL_BORDER_SELECTED = "eon-data-table-cell-border-selected" as const;
export const DATA_TABLE_CELL_BORDER_SELECTED_HOVER = "eon-data-table-cell-border-selected-hover" as const;
export const DATA_TABLE_CELL_BORDER_ODD = "eon-data-table-cell-border-odd" as const;
export const DATA_TABLE_CELL_BORDER_ODD_HOVER = "eon-data-table-cell-border-odd-hover" as const;
export const DATA_TABLE_CELL_BORDER_EVEN = "eon-data-table-cell-border-even" as const;
export const DATA_TABLE_CELL_BORDER_EVEN_HOVER = "eon-data-table-cell-border-even-hover" as const;
export const DATA_TABLE_TOOLBAR_BACKGROUND = "eon-data-table-toolbar-background" as const;
export const DATA_TABLE_TOOLBAR_COLOR = "eon-data-table-toolbar-color" as const;
export const DATA_TABLE_TOOLBAR_SELECTED_BACKGROUND = "eon-data-table-toolbar-selected-background" as const;
export const DATA_TABLE_TOOLBAR_SELECTED_COLOR = "eon-data-table-toolbar-selected-color" as const;
export const FOOTER_BAR_COPYRIGHT_COLOR = "eon-footer-bar-copyright-color" as const;
export const FOOTER_BAR_BACKGROUND_COLOR = "eon-footer-bar-background-color" as const;
export const FOOTER_BAR_LINK_COLOR = "eon-footer-bar-link-color" as const;
export const FOOTER_BAR_LINK_HOVER_COLOR = "eon-footer-bar-link-hover-color" as const;
export const NAVIGATION_BOX_SHADOW = "eon-navigation-box-shadow" as const;
export const NAVIGATION_META_BG_COLOR = "eon-navigation-meta-bg-color" as const;
export const NAVIGATION_META_BORDER_COLOR = "eon-navigation-meta-border-color" as const;
export const NAVIGATION_META_LINK_FONT_COLOR = "eon-navigation-meta-link-font-color" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_HOVER = "eon-navigation-meta-link-font-color-hover" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_FOCUS = "eon-navigation-meta-link-font-color-focus" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_CURRENT = "eon-navigation-meta-link-font-color-current" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-meta-link-font-color-current-hover" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-meta-link-font-color-current-focus" as const;
export const NAVIGATION_META_LINK_BG_COLOR = "eon-navigation-meta-link-bg-color" as const;
export const NAVIGATION_META_LINK_BG_COLOR_HOVER = "eon-navigation-meta-link-bg-color-hover" as const;
export const NAVIGATION_META_LINK_BG_COLOR_FOCUS = "eon-navigation-meta-link-bg-color-focus" as const;
export const NAVIGATION_META_LINK_BG_COLOR_CURRENT = "eon-navigation-meta-link-bg-color-current" as const;
export const NAVIGATION_META_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-meta-link-bg-color-current-hover" as const;
export const NAVIGATION_META_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-meta-link-bg-color-current-focus" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR = "eon-navigation-meta-link-border-color" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_HOVER = "eon-navigation-meta-link-border-color-hover" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_FOCUS = "eon-navigation-meta-link-border-color-focus" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_CURRENT = "eon-navigation-meta-link-border-color-current" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-navigation-meta-link-border-color-current-hover" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_CURRENT_FOCUS = "eon-navigation-meta-link-border-color-current-focus" as const;
export const NAVIGATION_TOOLBAR_BG_COLOR = "eon-navigation-toolbar-bg-color" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR = "eon-navigation-toolbar-icon-link-font-color" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_HOVER = "eon-navigation-toolbar-icon-link-font-color-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_FOCUS = "eon-navigation-toolbar-icon-link-font-color-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_CURRENT = "eon-navigation-toolbar-icon-link-font-color-current" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-toolbar-icon-link-font-color-current-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-toolbar-icon-link-font-color-current-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_ACTIVE = "eon-navigation-toolbar-icon-link-font-color-active" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-navigation-toolbar-icon-link-font-color-active-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_ACTIVE_FOCUS = "eon-navigation-toolbar-icon-link-font-color-active-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR = "eon-navigation-toolbar-icon-link-bg-color" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_HOVER = "eon-navigation-toolbar-icon-link-bg-color-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_FOCUS = "eon-navigation-toolbar-icon-link-bg-color-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_CURRENT = "eon-navigation-toolbar-icon-link-bg-color-current" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-toolbar-icon-link-bg-color-current-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-toolbar-icon-link-bg-color-current-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_ACTIVE = "eon-navigation-toolbar-icon-link-bg-color-active" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_ACTIVE_HOVER = "eon-navigation-toolbar-icon-link-bg-color-active-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_ACTIVE_FOCUS = "eon-navigation-toolbar-icon-link-bg-color-active-focus" as const;
export const NAVIGATION_TOOLBAR_SUB_BG_COLOR = "eon-navigation-toolbar-sub-bg-color" as const;
export const NAVIGATION_MAIN_BG_COLOR = "eon-navigation-main-bg-color" as const;
export const NAVIGATION_MAIN_BORDER_COLOR = "eon-navigation-main-border-color" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR = "eon-navigation-main-link-font-color" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_HOVER = "eon-navigation-main-link-font-color-hover" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_FOCUS = "eon-navigation-main-link-font-color-focus" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT = "eon-navigation-main-link-font-color-current" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-main-link-font-color-current-hover" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-main-link-font-color-current-focus" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE = "eon-navigation-main-link-font-color-active" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-navigation-main-link-font-color-active-hover" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE_FOCUS = "eon-navigation-main-link-font-color-active-focus" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR = "eon-navigation-main-link-bg-color" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_HOVER = "eon-navigation-main-link-bg-color-hover" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_FOCUS = "eon-navigation-main-link-bg-color-focus" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT = "eon-navigation-main-link-bg-color-current" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-main-link-bg-color-current-hover" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-main-link-bg-color-current-focus" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE = "eon-navigation-main-link-bg-color-active" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE_HOVER = "eon-navigation-main-link-bg-color-active-hover" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE_FOCUS = "eon-navigation-main-link-bg-color-active-focus" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR = "eon-navigation-main-link-border-color" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_HOVER = "eon-navigation-main-link-border-color-hover" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_FOCUS = "eon-navigation-main-link-border-color-focus" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT = "eon-navigation-main-link-border-color-current" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-navigation-main-link-border-color-current-hover" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT_FOCUS = "eon-navigation-main-link-border-color-current-focus" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE = "eon-navigation-main-link-border-color-active" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE_HOVER = "eon-navigation-main-link-border-color-active-hover" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE_FOCUS = "eon-navigation-main-link-border-color-active-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR = "eon-navigation-main-icon-link-font-color" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_HOVER = "eon-navigation-main-icon-link-font-color-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_FOCUS = "eon-navigation-main-icon-link-font-color-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_CURRENT = "eon-navigation-main-icon-link-font-color-current" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-main-icon-link-font-color-current-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-main-icon-link-font-color-current-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_ACTIVE = "eon-navigation-main-icon-link-font-color-active" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-navigation-main-icon-link-font-color-active-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_ACTIVE_FOCUS = "eon-navigation-main-icon-link-font-color-active-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR = "eon-navigation-main-icon-link-bg-color" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_HOVER = "eon-navigation-main-icon-link-bg-color-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_FOCUS = "eon-navigation-main-icon-link-bg-color-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_CURRENT = "eon-navigation-main-icon-link-bg-color-current" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-main-icon-link-bg-color-current-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-main-icon-link-bg-color-current-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_ACTIVE = "eon-navigation-main-icon-link-bg-color-active" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_ACTIVE_HOVER = "eon-navigation-main-icon-link-bg-color-active-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_ACTIVE_FOCUS = "eon-navigation-main-icon-link-bg-color-active-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR = "eon-navigation-main-icon-link-border-color" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_HOVER = "eon-navigation-main-icon-link-border-color-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_FOCUS = "eon-navigation-main-icon-link-border-color-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_CURRENT = "eon-navigation-main-icon-link-border-color-current" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-navigation-main-icon-link-border-color-current-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_CURRENT_FOCUS = "eon-navigation-main-icon-link-border-color-current-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_ACTIVE = "eon-navigation-main-icon-link-border-color-active" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_ACTIVE_HOVER = "eon-navigation-main-icon-link-border-color-active-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_ACTIVE_FOCUS = "eon-navigation-main-icon-link-border-color-active-focus" as const;
export const NAVIGATION_MAIN_SUB_BG_COLOR = "eon-navigation-main-sub-bg-color" as const;
export const NAVIGATION_MAIN_SUB_BOX_SHADOW = "eon-navigation-main-sub-box-shadow" as const;
export const NAVIGATION_FLYOUT_DIVIDER_BG_COLOR = "eon-navigation-flyout-divider-bg-color" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR = "eon-navigation-flyout-link-font-color" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR_HOVER = "eon-navigation-flyout-link-font-color-hover" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR_FOCUS = "eon-navigation-flyout-link-font-color-focus" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR_CURRENT = "eon-navigation-flyout-link-font-color-current" as const;
export const NAVIGATION_FLYOUT_LINK_BORDER_COLOR_CURRENT = "eon-navigation-flyout-link-border-color-current" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR = "eon-navigation-flyout-link-large-font-color" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_HOVER = "eon-navigation-flyout-link-large-font-color-hover" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_FOCUS = "eon-navigation-flyout-link-large-font-color-focus" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_CURRENT = "eon-navigation-flyout-link-large-font-color-current" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_BORDER_COLOR_CURRENT = "eon-navigation-flyout-link-large-border-color-current" as const;
export const NAVIGATION_MOBILE_BG_COLOR = "eon-navigation-mobile-bg-color" as const;
export const NAVIGATION_MOBILE_LINK_FONT_COLOR = "eon-navigation-mobile-link-font-color" as const;
export const NAVIGATION_MOBILE_LINK_HIGHLIGHT_BORDER_COLOR = "eon-navigation-mobile-link-highlight-border-color" as const;
export const NAVIGATION_MOBILE_LINK_BORDER_COLOR = "eon-navigation-mobile-link-border-color" as const;
export const OFFSET_TEASER_COLOR_BAR_TURQUOISE = "eon-offset-teaser-color-bar-turquoise" as const;
export const OFFSET_TEASER_COLOR_BAR_BORDEAUX = "eon-offset-teaser-color-bar-bordeaux" as const;
export const OFFSET_TEASER_COLOR_BAR_LIMEYELLOW = "eon-offset-teaser-color-bar-limeyellow" as const;
export const OFFSET_TEASER_COLOR_BAR_RED = "eon-offset-teaser-color-bar-red" as const;
export const PAGE_HEADER_COLOR_BAR_TURQUOISE = "eon-page-header-color-bar-turquoise" as const;
export const PAGE_HEADER_COLOR_BAR_BORDEAUX = "eon-page-header-color-bar-bordeaux" as const;
export const PAGE_HEADER_COLOR_BAR_LIMEYELLOW = "eon-page-header-color-bar-limeyellow" as const;
export const PAGE_HEADER_COLOR_BAR_RED = "eon-page-header-color-bar-red" as const;
export const SECTION_VIDEO_CONTROL_COLOR_LIGHT = "eon-section-video-control-color-light" as const;
export const SECTION_VIDEO_CONTROL_COLOR_DARK = "eon-section-video-control-color-dark" as const;
export const SEARCH_RESULT_ITEM_MARK_COLOR = "eon-search-result-item-mark-color" as const;
export const SEARCH_RESULT_ITEM_VISITED_COLOR = "eon-search-result-item-visited-color" as const;
export const VIDEOPLAYER_FOCUS_OUTLINE_COLOR = "eon-videoplayer-focus-outline-color" as const;
export const VIDEOPLAYER_ERROR_COLOR = "eon-videoplayer-error-color" as const;
export const VIDEOPLAYER_ERROR_BACKGROUND_COLOR = "eon-videoplayer-error-background-color" as const;
export const VIDEOPLAYER_CONTROLS_BACKGROUND = "eon-videoplayer-controls-background" as const;
export const VIDEOPLAYER_PROGRESS_BACKGROUND = "eon-videoplayer-progress-background" as const;
export const VIDEOPLAYER_PROGRESS_COLOR = "eon-videoplayer-progress-color" as const;
export const VIDEOPLAYER_PROGRESS_BAR_COLOR = "eon-videoplayer-progress-bar-color" as const;
export const VIDEOPLAYER_PROGRESS_BAR_BACKGROUND = "eon-videoplayer-progress-bar-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_ACTIVE_BACKGROUND = "eon-videoplayer-progress-bar-active-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_TIME_COLOR = "eon-videoplayer-progress-bar-time-color" as const;
export const VIDEOPLAYER_PROGRESS_BAR_VALUE_BACKGROUND = "eon-videoplayer-progress-bar-value-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_BUTTON_COLOR = "eon-videoplayer-progress-bar-button-color" as const;
export const VIDEOPLAYER_PROGRESS_BAR_BUTTON_FOCUS = "eon-videoplayer-progress-bar-button-focus" as const;
export const VIDEOPLAYER_PROGRESS_BAR_PLAY_BUTTON_BACKGROUND = "eon-videoplayer-progress-bar-play-button-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_PLAY_BUTTON_HOVER_BACKGROUND = "eon-videoplayer-progress-bar-play-button-hover-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_MUTE_BUTTON_BACKGROUND = "eon-videoplayer-progress-bar-mute-button-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_MUTE_BUTTON_HOVER_BACKGROUND = "eon-videoplayer-progress-bar-mute-button-hover-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_FULL_SCREEN_BUTTON_BACKGROUND = "eon-videoplayer-progress-bar-full-screen-button-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_FULL_SCREEN_BUTTON_HOVER_BACKGROUND = "eon-videoplayer-progress-bar-full-screen-button-hover-background" as const;

export const SCHEME_ALIAS_CONFIG = {
  ACCORDION: {},
  ANCHOR_NAVIGATION: {},
  ANSWER_CARD: {},
  BADGE: {},
  BREADCRUMB: {},
  BOTTOM_DRAWER: {},
  BULLET_LIST: {},
  BULLET_LIST_DEPRECATED: {},
  BUSINESSCARD_AUTHOR: {},
  BUSINESSCARD_CONTACT: {},
  BOX: {},
  BUTTON: {},
  CAPTION: {},
  CARD_TEASER: {},
  CAROUSEL: {},
  CHECKBOX: {},
  CLICKABLE_IMAGE: {},
  COLOR_SEPARATOR: {},
  COMPASS: {},
  CONTACT_BAR: {},
  CONTACT_LAYER: {},
  CONTACT_LIST: {},
  CONTENT_AGGREGATOR: {},
  CONTENT_AGGREGATOR_ITEM: {},
  CONTEXT_MENU: {},
  CONTEXT_MENU_ITEM: {},
  DATA_TABLE: {},
  DATE_EVENT: {},
  DATE_PICKER: {},
  DIVIDER: {},
  DROPDOWN: {},
  DROPDOWN_OPTION: {},
  ERROR_MESSAGE: {},
  FILE_UPLOAD: {},
  FILE_PREVIEW: {},
  FOOTER_BAR: {},
  FORM_MESSAGE: {},
  HEADLINE: {},
  ICON: {},
  IMAGE: {},
  INFO_ICON: {},
  INPUT: {},
  LINK: {},
  LINKLIST: {},
  MAP: {},
  MAP_INFO_LAYER: {},
  MODAL: {},
  MULTI_CONTENT_STAGE: {},
  NAVIGATION: {},
  NUMBER: {},
  OFFSET_TEASER: {},
  OFFSET_TEASER5: {},
  PRELOADER_CIRCLE: {},
  PRELOADER_SQUARES: {},
  PROGRESS_CIRCLE: {},
  PROMO_FLAG: {},
  PAGE_HEADER: {},
  PICTOGRAM: {},
  RADIO_BUTTON: {},
  READ_MORE: {},
  RTE_RENDERER: {},
  SECTION: {},
  SEARCH_RESULT_ITEM: {},
  SITELINK: {},
  SLIDER: {},
  SWITCH_TOGGLE: {},
  SPACER: {},
  STAGE: {},
  STEP: {},
  STEPS: {},
  TABLE_RENDERER: {},
  TABS: {},
  TAG_PILL: {},
  TEXT: {},
  TEXT_TEASER: {},
  THIRD_LEVEL_NAVIGATION: {},
  THIRD_LEVEL_NAVIGATION_ITEM: {},
  TILES_TEASER: {},
  TOOLTIP: {},
  VIDEOPLAYER: {},
  VIOLATOR: {}
};

export const BACKGROUND_COLORS = [
  // COLOR_ULTRALIGHTGREY,
  // COLOR_WHITE,
  // COLOR_LIGHTGREY,

  COLOR_BRIGHT,
  COLOR_DARK,
  COLOR_RED,
  COLOR_TURQUOISE,
  COLOR_LIMEYELLOW,
  COLOR_BORDEAUX,
  COLOR_WHITE,
  COLOR_ULTRALIGHTGREY,
  COLOR_LIGHTGREY,
  COLOR_MIDDLEGREY,
  COLOR_DARKGREY,
  COLOR_BLACK
];

export interface BackgroundSchemeConfiguration<T> {
  // white?: T;
  // lightgrey?: T;
  // ultralightgrey?: T;

  bright?: T;
  dark?: T;
  red?: T;
  turquoise?: T;
  limeyellow?: T;
  bordeaux?: T;
  white?: T;
  ultralightgrey?: T;
  lightgrey?: T;
  middlegrey?: T;
  darkgrey?: T;
  black?: T;
}

interface ColorMap {
  [name: string]: string | boolean | number;
}

export interface SchemeConfig {
  schemeName: string;
  scheme?: ColorMap;
}

export type EonColor = typeof EON_COLORS[number];

/* PLOP_INJECT_ALIGNMENT */
